
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    /*!
  * Bootstrap v5.2.3 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $cc4ed71c4f27adbc$exports = {};

$parcel$export($cc4ed71c4f27adbc$exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);
$parcel$export($cc4ed71c4f27adbc$exports, "detectOverflow", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperBase", () => $60bdf67e43f5dfcb$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperLite", () => $ef991c361ca719ad$export$8f7491d57c8f97a9);
var $1472b89a65155de2$exports = {};

$parcel$export($1472b89a65155de2$exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export($1472b89a65155de2$exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export($1472b89a65155de2$exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export($1472b89a65155de2$exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export($1472b89a65155de2$exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export($1472b89a65155de2$exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export($1472b89a65155de2$exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export($1472b89a65155de2$exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export($1472b89a65155de2$exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export($1472b89a65155de2$exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export($1472b89a65155de2$exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export($1472b89a65155de2$exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export($1472b89a65155de2$exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export($1472b89a65155de2$exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export($1472b89a65155de2$exports, "beforeRead", () => $1472b89a65155de2$export$421679a7c3d56e);
$parcel$export($1472b89a65155de2$exports, "read", () => $1472b89a65155de2$export$aafa59e2e03f2942);
$parcel$export($1472b89a65155de2$exports, "afterRead", () => $1472b89a65155de2$export$6964f6c886723980);
$parcel$export($1472b89a65155de2$exports, "beforeMain", () => $1472b89a65155de2$export$c65e99957a05207c);
$parcel$export($1472b89a65155de2$exports, "main", () => $1472b89a65155de2$export$f22da7240b7add18);
$parcel$export($1472b89a65155de2$exports, "afterMain", () => $1472b89a65155de2$export$bab79516f2d662fe);
$parcel$export($1472b89a65155de2$exports, "beforeWrite", () => $1472b89a65155de2$export$8d4d2d70e7d46032);
$parcel$export($1472b89a65155de2$exports, "write", () => $1472b89a65155de2$export$68d8715fc104d294);
$parcel$export($1472b89a65155de2$exports, "afterWrite", () => $1472b89a65155de2$export$70a6e5159acce2e6);
$parcel$export($1472b89a65155de2$exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $a3382052de3d061b$exports = {};

$parcel$export($a3382052de3d061b$exports, "applyStyles", () => $7deefb3680d4558f$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "arrow", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "computeStyles", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "eventListeners", () => $e7d7845625089588$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "flip", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "hide", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "offset", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "popperOffsets", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "preventOverflow", () => $865d356b2ca960a5$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}




var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}







function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $60bdf67e43f5dfcb$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $60bdf67e43f5dfcb$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $ef991c361ca719ad$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039)
];
var $ef991c361ca719ad$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $ef991c361ca719ad$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $1472b89a65155de2$exports);
$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $a3382052de3d061b$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$MAX_UID = 1000000;
const $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER = 1000;
const $e9dd36436aec3b21$var$TRANSITION_END = "transitionend"; // Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e9dd36436aec3b21$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e9dd36436aec3b21$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e9dd36436aec3b21$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e9dd36436aec3b21$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href"); // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
         // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector;
};
const $e9dd36436aec3b21$var$getSelectorFromElement = (element)=>{
    const selector = $e9dd36436aec3b21$var$getSelector(element);
    if (selector) return document.querySelector(selector) ? selector : null;
    return null;
};
const $e9dd36436aec3b21$var$getElementFromSelector = (element)=>{
    const selector = $e9dd36436aec3b21$var$getSelector(element);
    return selector ? document.querySelector(selector) : null;
};
const $e9dd36436aec3b21$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
     // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
     // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER;
};
const $e9dd36436aec3b21$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e9dd36436aec3b21$var$TRANSITION_END));
};
const $e9dd36436aec3b21$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $e9dd36436aec3b21$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e9dd36436aec3b21$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector(object);
    return null;
};
const $e9dd36436aec3b21$var$isVisible = (element)=>{
    if (!$e9dd36436aec3b21$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible"; // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e9dd36436aec3b21$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $e9dd36436aec3b21$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
     // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
     // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e9dd36436aec3b21$var$findShadowRoot(element.parentNode);
};
const $e9dd36436aec3b21$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e9dd36436aec3b21$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e9dd36436aec3b21$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $e9dd36436aec3b21$var$DOMContentLoadedCallbacks = [];
const $e9dd36436aec3b21$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$e9dd36436aec3b21$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $e9dd36436aec3b21$var$DOMContentLoadedCallbacks)callback();
        });
        $e9dd36436aec3b21$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e9dd36436aec3b21$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $e9dd36436aec3b21$var$defineJQueryPlugin = (plugin)=>{
    $e9dd36436aec3b21$var$onDOMContentLoaded(()=>{
        const $ = $e9dd36436aec3b21$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e9dd36436aec3b21$var$execute = (callback)=>{
    if (typeof callback === "function") callback();
};
const $e9dd36436aec3b21$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e9dd36436aec3b21$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e9dd36436aec3b21$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
        $e9dd36436aec3b21$var$execute(callback);
    };
    transitionElement.addEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e9dd36436aec3b21$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e9dd36436aec3b21$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement); // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e9dd36436aec3b21$var$stripNameRegex = /\..*/;
const $e9dd36436aec3b21$var$stripUidRegex = /::\d+$/;
const $e9dd36436aec3b21$var$eventRegistry = {}; // Events storage
let $e9dd36436aec3b21$var$uidEvent = 1;
const $e9dd36436aec3b21$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $e9dd36436aec3b21$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $e9dd36436aec3b21$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e9dd36436aec3b21$var$uidEvent++}` || element.uidEvent || $e9dd36436aec3b21$var$uidEvent++;
}
function $e9dd36436aec3b21$var$getElementEvents(element) {
    const uid = $e9dd36436aec3b21$var$makeEventUid(element);
    element.uidEvent = uid;
    $e9dd36436aec3b21$var$eventRegistry[uid] = $e9dd36436aec3b21$var$eventRegistry[uid] || {};
    return $e9dd36436aec3b21$var$eventRegistry[uid];
}
function $e9dd36436aec3b21$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e9dd36436aec3b21$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e9dd36436aec3b21$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e9dd36436aec3b21$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string"; // todo: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e9dd36436aec3b21$var$getTypeEvent(originalTypeEvent);
    if (!$e9dd36436aec3b21$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e9dd36436aec3b21$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction); // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e9dd36436aec3b21$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e9dd36436aec3b21$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e9dd36436aec3b21$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e9dd36436aec3b21$var$makeEventUid(callable, originalTypeEvent.replace($e9dd36436aec3b21$var$namespaceRegex, ""));
    const fn = isDelegated ? $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, handler, callable) : $e9dd36436aec3b21$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e9dd36436aec3b21$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const handlerKey of Object.keys(storeElementEvent))if (handlerKey.includes(namespace)) {
        const event = storeElementEvent[handlerKey];
        $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
    }
}
function $e9dd36436aec3b21$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e9dd36436aec3b21$var$stripNameRegex, "");
    return $e9dd36436aec3b21$var$customEvents[event] || event;
}
const $e9dd36436aec3b21$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e9dd36436aec3b21$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const keyHandlers of Object.keys(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e9dd36436aec3b21$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) {
                const event = storeElementEvent[keyHandlers];
                $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $e9dd36436aec3b21$var$getjQuery();
        const typeEvent = $e9dd36436aec3b21$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        let evt = new Event(event, {
            bubbles: bubbles,
            cancelable: true
        });
        evt = $e9dd36436aec3b21$var$hydrateObj(evt, args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e9dd36436aec3b21$var$hydrateObj(obj, meta) {
    for (const [key, value] of Object.entries(meta || {}))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$elementMap = new Map();
const $e9dd36436aec3b21$var$Data = {
    set (element, key, instance) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) $e9dd36436aec3b21$var$elementMap.set(element, new Map());
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element); // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e9dd36436aec3b21$var$elementMap.has(element)) return $e9dd36436aec3b21$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) return;
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        instanceMap.delete(key); // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e9dd36436aec3b21$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e9dd36436aec3b21$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e9dd36436aec3b21$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e9dd36436aec3b21$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $e9dd36436aec3b21$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e9dd36436aec3b21$var$normalizeData(element.getAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e9dd36436aec3b21$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const property of Object.keys(configTypes)){
            const expectedTypes = configTypes[property];
            const value = config[property];
            const valueType = $e9dd36436aec3b21$var$isElement(value) ? "element" : $e9dd36436aec3b21$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$VERSION = "5.2.3";
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$BaseComponent extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        element = $e9dd36436aec3b21$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e9dd36436aec3b21$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    dispose() {
        $e9dd36436aec3b21$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e9dd36436aec3b21$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    static getInstance(element) {
        return $e9dd36436aec3b21$var$Data.get($e9dd36436aec3b21$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $e9dd36436aec3b21$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e9dd36436aec3b21$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($e9dd36436aec3b21$var$isDisabled(this)) return;
        const target = $e9dd36436aec3b21$var$getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target); // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$f = "alert";
const $e9dd36436aec3b21$var$DATA_KEY$a = "bs.alert";
const $e9dd36436aec3b21$var$EVENT_KEY$b = `.${$e9dd36436aec3b21$var$DATA_KEY$a}`;
const $e9dd36436aec3b21$var$EVENT_CLOSE = `close${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$EVENT_CLOSED = `closed${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$5 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$caec2af78bcc877f extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$f;
    }
    close() {
        const closeEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    _destroyElement() {
        this._element.remove();
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSED);
        this.dispose();
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$e = "button";
const $e9dd36436aec3b21$var$DATA_KEY$9 = "bs.button";
const $e9dd36436aec3b21$var$EVENT_KEY$a = `.${$e9dd36436aec3b21$var$DATA_KEY$9}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$6 = ".data-api";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3 = "active";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6 = `click${$e9dd36436aec3b21$var$EVENT_KEY$a}${$e9dd36436aec3b21$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$353f5b6fc5456de1 extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$e;
    }
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3));
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$e9dd36436aec3b21$var$isDisabled(el) && $e9dd36436aec3b21$var$isVisible(el));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$d = "swipe";
const $e9dd36436aec3b21$var$EVENT_KEY$9 = ".bs.swipe";
const $e9dd36436aec3b21$var$EVENT_TOUCHSTART = `touchstart${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHMOVE = `touchmove${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHEND = `touchend${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERDOWN = `pointerdown${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERUP = `pointerup${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH = "touch";
const $e9dd36436aec3b21$var$POINTER_TYPE_PEN = "pen";
const $e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $e9dd36436aec3b21$var$SWIPE_THRESHOLD = 40;
const $e9dd36436aec3b21$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e9dd36436aec3b21$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Swipe extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e9dd36436aec3b21$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$c;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$c;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$d;
    }
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_KEY$9);
    }
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e9dd36436aec3b21$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e9dd36436aec3b21$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e9dd36436aec3b21$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_PEN || event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH);
    }
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$c = "carousel";
const $e9dd36436aec3b21$var$DATA_KEY$8 = "bs.carousel";
const $e9dd36436aec3b21$var$EVENT_KEY$8 = `.${$e9dd36436aec3b21$var$DATA_KEY$8}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$5 = ".data-api";
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e9dd36436aec3b21$var$ORDER_NEXT = "next";
const $e9dd36436aec3b21$var$ORDER_PREV = "prev";
const $e9dd36436aec3b21$var$DIRECTION_LEFT = "left";
const $e9dd36436aec3b21$var$DIRECTION_RIGHT = "right";
const $e9dd36436aec3b21$var$EVENT_SLIDE = `slide${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_SLID = `slid${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN$1 = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1 = `mouseenter${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_DRAG_START = `dragstart${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3 = `load${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5 = `click${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL = "carousel";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2 = "active";
const $e9dd36436aec3b21$var$CLASS_NAME_SLIDE = "slide";
const $e9dd36436aec3b21$var$CLASS_NAME_END = "carousel-item-end";
const $e9dd36436aec3b21$var$CLASS_NAME_START = "carousel-item-start";
const $e9dd36436aec3b21$var$CLASS_NAME_NEXT = "carousel-item-next";
const $e9dd36436aec3b21$var$CLASS_NAME_PREV = "carousel-item-prev";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE = ".active";
const $e9dd36436aec3b21$var$SELECTOR_ITEM = ".carousel-item";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM = $e9dd36436aec3b21$var$SELECTOR_ACTIVE + $e9dd36436aec3b21$var$SELECTOR_ITEM;
const $e9dd36436aec3b21$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $e9dd36436aec3b21$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $e9dd36436aec3b21$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e9dd36436aec3b21$var$KEY_TO_DIRECTION = {
    [$e9dd36436aec3b21$var$ARROW_LEFT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_RIGHT,
    [$e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_LEFT
};
const $e9dd36436aec3b21$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $e9dd36436aec3b21$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$144901db2ea8e967 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$b;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$b;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$c;
    }
    next() {
        this._slide($e9dd36436aec3b21$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e9dd36436aec3b21$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e9dd36436aec3b21$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e9dd36436aec3b21$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e9dd36436aec3b21$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM_IMG, this._element))$e9dd36436aec3b21$var$EventHandler.on(img, $e9dd36436aec3b21$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
             // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e9dd36436aec3b21$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e9dd36436aec3b21$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e9dd36436aec3b21$var$ORDER_NEXT;
        const nextElement = element || $e9dd36436aec3b21$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e9dd36436aec3b21$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e9dd36436aec3b21$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // todo: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_START : $e9dd36436aec3b21$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_NEXT : $e9dd36436aec3b21$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e9dd36436aec3b21$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e9dd36436aec3b21$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e9dd36436aec3b21$var$isRTL()) return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_PREV : $e9dd36436aec3b21$var$ORDER_NEXT;
        return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e9dd36436aec3b21$var$isRTL()) return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_LEFT : $e9dd36436aec3b21$var$DIRECTION_RIGHT;
        return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_RIGHT : $e9dd36436aec3b21$var$DIRECTION_LEFT;
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5, $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e9dd36436aec3b21$var$getElementFromSelector(this);
    if (!target || !target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e9dd36436aec3b21$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$b = "collapse";
const $e9dd36436aec3b21$var$DATA_KEY$7 = "bs.collapse";
const $e9dd36436aec3b21$var$EVENT_KEY$7 = `.${$e9dd36436aec3b21$var$DATA_KEY$7}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$4 = ".data-api";
const $e9dd36436aec3b21$var$EVENT_SHOW$6 = `show${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$6 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$6 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$6 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4 = `click${$e9dd36436aec3b21$var$EVENT_KEY$7}${$e9dd36436aec3b21$var$DATA_API_KEY$4}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE = "collapse";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING = "collapsing";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED = "collapsed";
const $e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE} .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE}`;
const $e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $e9dd36436aec3b21$var$WIDTH = "width";
const $e9dd36436aec3b21$var$HEIGHT = "height";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e9dd36436aec3b21$var$Default$a = {
    parent: null,
    toggle: true
};
const $e9dd36436aec3b21$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$78768a9af065a7b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e9dd36436aec3b21$var$getSelectorFromElement(elem);
            const filterElement = $e9dd36436aec3b21$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$a;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$a;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$b;
    }
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = []; // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e9dd36436aec3b21$var$getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e9dd36436aec3b21$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL) ? $e9dd36436aec3b21$var$WIDTH : $e9dd36436aec3b21$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e9dd36436aec3b21$var$getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent); // remove children if greater depth
        return $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    const selector = $e9dd36436aec3b21$var$getSelectorFromElement(this);
    const selectorElements = $e9dd36436aec3b21$var$SelectorEngine.find(selector);
    for (const element of selectorElements)$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$a = "dropdown";
const $e9dd36436aec3b21$var$DATA_KEY$6 = "bs.dropdown";
const $e9dd36436aec3b21$var$EVENT_KEY$6 = `.${$e9dd36436aec3b21$var$DATA_KEY$6}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$3 = ".data-api";
const $e9dd36436aec3b21$var$ESCAPE_KEY$2 = "Escape";
const $e9dd36436aec3b21$var$TAB_KEY$1 = "Tab";
const $e9dd36436aec3b21$var$ARROW_UP_KEY$1 = "ArrowUp";
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e9dd36436aec3b21$var$EVENT_HIDE$5 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$5 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$5 = `show${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$5 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3 = `click${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API = `keyup${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$6 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP = "dropup";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPEND = "dropend";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPSTART = "dropstart";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3}.${$e9dd36436aec3b21$var$CLASS_NAME_SHOW$6}`;
const $e9dd36436aec3b21$var$SELECTOR_MENU = ".dropdown-menu";
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR = ".navbar";
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $e9dd36436aec3b21$var$PLACEMENT_TOP = $e9dd36436aec3b21$var$isRTL() ? "top-end" : "top-start";
const $e9dd36436aec3b21$var$PLACEMENT_TOPEND = $e9dd36436aec3b21$var$isRTL() ? "top-start" : "top-end";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOM = $e9dd36436aec3b21$var$isRTL() ? "bottom-end" : "bottom-start";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND = $e9dd36436aec3b21$var$isRTL() ? "bottom-start" : "bottom-end";
const $e9dd36436aec3b21$var$PLACEMENT_RIGHT = $e9dd36436aec3b21$var$isRTL() ? "left-start" : "right-start";
const $e9dd36436aec3b21$var$PLACEMENT_LEFT = $e9dd36436aec3b21$var$isRTL() ? "right-start" : "left-start";
const $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER = "top";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $e9dd36436aec3b21$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $e9dd36436aec3b21$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$931cbfb6bfb85fc extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // todo: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.2/forms/input-group/
        this._menu = $e9dd36436aec3b21$var$SelectorEngine.next(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.prev(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$9;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$9;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$a;
    }
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper(); // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, "mouseover", $e9dd36436aec3b21$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    _completeHide(relatedTarget) {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
         // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, "mouseover", $e9dd36436aec3b21$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$e9dd36436aec3b21$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e9dd36436aec3b21$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $cc4ed71c4f27adbc$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($e9dd36436aec3b21$var$isElement(this._config.reference)) referenceElement = $e9dd36436aec3b21$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $cc4ed71c4f27adbc$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPEND)) return $e9dd36436aec3b21$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPSTART)) return $e9dd36436aec3b21$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER;
         // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP)) return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_TOPEND : $e9dd36436aec3b21$var$PLACEMENT_TOP;
        return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND : $e9dd36436aec3b21$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        }; // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $e9dd36436aec3b21$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // todo:v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...typeof this._config.popperConfig === "function" ? this._config.popperConfig(defaultBsPopperConfig) : this._config.popperConfig
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e9dd36436aec3b21$var$isVisible(element));
        if (!items.length) return;
         // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e9dd36436aec3b21$var$getNextActiveElement(items, target, key === $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $e9dd36436aec3b21$var$TAB_KEY$1) return;
        const openToggles = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
             // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $e9dd36436aec3b21$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e9dd36436aec3b21$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e9dd36436aec3b21$var$ARROW_UP_KEY$1,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault(); // todo: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.2/forms/input-group/
        const getToggleButton = this.matches($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3) ? this : $e9dd36436aec3b21$var$SelectorEngine.prev(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.next(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_MENU, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $e9dd36436aec3b21$var$PROPERTY_PADDING = "padding-right";
const $e9dd36436aec3b21$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow(); // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width); // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e9dd36436aec3b21$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, styleProperty); // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e9dd36436aec3b21$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$9 = "backdrop";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$4 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$5 = "show";
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e9dd36436aec3b21$var$NAME$9}`;
const $e9dd36436aec3b21$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $e9dd36436aec3b21$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Backdrop extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$8;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$8;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$9;
    }
    show(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e9dd36436aec3b21$var$reflow(element);
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e9dd36436aec3b21$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e9dd36436aec3b21$var$EventHandler.on(element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN, ()=>{
            $e9dd36436aec3b21$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$8 = "focustrap";
const $e9dd36436aec3b21$var$DATA_KEY$5 = "bs.focustrap";
const $e9dd36436aec3b21$var$EVENT_KEY$5 = `.${$e9dd36436aec3b21$var$DATA_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$2 = `focusin${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$TAB_KEY = "Tab";
const $e9dd36436aec3b21$var$TAB_NAV_FORWARD = "forward";
const $e9dd36436aec3b21$var$TAB_NAV_BACKWARD = "backward";
const $e9dd36436aec3b21$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e9dd36436aec3b21$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$FocusTrap extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$7;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$7;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$8;
    }
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5); // guard against infinite focus loop
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5);
    }
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e9dd36436aec3b21$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e9dd36436aec3b21$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e9dd36436aec3b21$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e9dd36436aec3b21$var$TAB_NAV_BACKWARD : $e9dd36436aec3b21$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$7 = "modal";
const $e9dd36436aec3b21$var$DATA_KEY$4 = "bs.modal";
const $e9dd36436aec3b21$var$EVENT_KEY$4 = `.${$e9dd36436aec3b21$var$DATA_KEY$4}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$2 = ".data-api";
const $e9dd36436aec3b21$var$ESCAPE_KEY$1 = "Escape";
const $e9dd36436aec3b21$var$EVENT_HIDE$4 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$4 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$4 = `show${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$4 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE$1 = `resize${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS = `click.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2 = `click${$e9dd36436aec3b21$var$EVENT_KEY$4}${$e9dd36436aec3b21$var$DATA_API_KEY$2}`;
const $e9dd36436aec3b21$var$CLASS_NAME_OPEN = "modal-open";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$3 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$4 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_STATIC = "modal-static";
const $e9dd36436aec3b21$var$OPEN_SELECTOR$1 = ".modal.show";
const $e9dd36436aec3b21$var$SELECTOR_DIALOG = ".modal-dialog";
const $e9dd36436aec3b21$var$SELECTOR_MODAL_BODY = ".modal-body";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e9dd36436aec3b21$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e9dd36436aec3b21$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$2b77a92f1a5ad772 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e9dd36436aec3b21$var$ScrollBarHelper();
        this._addEventListeners();
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$6;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$6;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$7;
    }
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        for (const htmlElement of [
            window,
            this._dialog
        ])$e9dd36436aec3b21$var$EventHandler.off(htmlElement, $e9dd36436aec3b21$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    _initializeBackDrop() {
        return new $e9dd36436aec3b21$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                event.preventDefault();
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY; // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e9dd36436aec3b21$var$getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$4, ()=>{
            if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
        });
    }); // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$6 = "offcanvas";
const $e9dd36436aec3b21$var$DATA_KEY$3 = "bs.offcanvas";
const $e9dd36436aec3b21$var$EVENT_KEY$3 = `.${$e9dd36436aec3b21$var$DATA_KEY$3}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$1 = ".data-api";
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2 = `load${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$ESCAPE_KEY = "Escape";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$3 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1 = "showing";
const $e9dd36436aec3b21$var$CLASS_NAME_HIDING = "hiding";
const $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $e9dd36436aec3b21$var$OPEN_SELECTOR = ".offcanvas.show";
const $e9dd36436aec3b21$var$EVENT_SHOW$3 = `show${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$3 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$3 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$3 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE = `resize${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1 = `click${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e9dd36436aec3b21$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e9dd36436aec3b21$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$591ca0244c9dfcd4 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$5;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$5;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$6;
    }
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3, $e9dd36436aec3b21$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        }; // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e9dd36436aec3b21$var$Backdrop({
            className: $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY) return;
            if (!this._config.keyboard) {
                $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        });
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e9dd36436aec3b21$var$getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
    }); // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e9dd36436aec3b21$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$OPEN_SELECTOR))$e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
const $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
/**
 * A pattern that recognizes a commonly useful subset of URLs that are safe.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
 */ const $e9dd36436aec3b21$var$SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
/**
 * A pattern that matches safe data URLs. Only matches image, video and audio types.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
 */ const $e9dd36436aec3b21$var$DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
const $e9dd36436aec3b21$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e9dd36436aec3b21$var$uriAttributes.has(attributeName)) return Boolean($e9dd36436aec3b21$var$SAFE_URL_PATTERN.test(attribute.nodeValue) || $e9dd36436aec3b21$var$DATA_URL_PATTERN.test(attribute.nodeValue));
        return true;
    } // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
const $e9dd36436aec3b21$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
function $e9dd36436aec3b21$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e9dd36436aec3b21$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$5 = "TemplateFactory";
const $e9dd36436aec3b21$var$Default$4 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $e9dd36436aec3b21$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $e9dd36436aec3b21$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$TemplateFactory extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$4;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$4;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$5;
    }
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e9dd36436aec3b21$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e9dd36436aec3b21$var$isElement(content)) {
            this._putElementInTemplate($e9dd36436aec3b21$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e9dd36436aec3b21$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return typeof arg === "function" ? arg(this) : arg;
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$4 = "tooltip";
const $e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$2 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_MODAL = "modal";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2 = "show";
const $e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $e9dd36436aec3b21$var$SELECTOR_MODAL = `.${$e9dd36436aec3b21$var$CLASS_NAME_MODAL}`;
const $e9dd36436aec3b21$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $e9dd36436aec3b21$var$TRIGGER_HOVER = "hover";
const $e9dd36436aec3b21$var$TRIGGER_FOCUS = "focus";
const $e9dd36436aec3b21$var$TRIGGER_CLICK = "click";
const $e9dd36436aec3b21$var$TRIGGER_MANUAL = "manual";
const $e9dd36436aec3b21$var$EVENT_HIDE$2 = "hide";
const $e9dd36436aec3b21$var$EVENT_HIDDEN$2 = "hidden";
const $e9dd36436aec3b21$var$EVENT_SHOW$2 = "show";
const $e9dd36436aec3b21$var$EVENT_SHOWN$2 = "shown";
const $e9dd36436aec3b21$var$EVENT_INSERTED = "inserted";
const $e9dd36436aec3b21$var$EVENT_CLICK$1 = "click";
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$1 = "focusin";
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT$1 = "focusout";
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER = "mouseenter";
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE = "mouseleave";
const $e9dd36436aec3b21$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $e9dd36436aec3b21$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $e9dd36436aec3b21$var$isRTL() ? "right" : "left"
};
const $e9dd36436aec3b21$var$Default$3 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        0
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $e9dd36436aec3b21$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$28c660c63b792dea extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        if (typeof $cc4ed71c4f27adbc$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config); // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null; // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$3;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$3;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$4;
    }
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e9dd36436aec3b21$var$EventHandler.off(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOW$2));
        const shadowRoot = $e9dd36436aec3b21$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
         // todo v6 remove this OR make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2); // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, "mouseover", $e9dd36436aec3b21$var$noop);
        const complete = ()=>{
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2); // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, "mouseover", $e9dd36436aec3b21$var$noop);
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml(); // todo: remove this check on v6
        if (!tip) return null;
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_FADE$2, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2); // todo: on v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e9dd36436aec3b21$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e9dd36436aec3b21$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = typeof this._config.placement === "function" ? this._config.placement.call(this, tip, this._element) : this._config.placement;
        const attachment = $e9dd36436aec3b21$var$AttachmentMap[placement.toUpperCase()];
        return $cc4ed71c4f27adbc$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return typeof arg === "function" ? arg.call(this._element) : arg;
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...typeof this._config.popperConfig === "function" ? this._config.popperConfig(defaultBsPopperConfig) : this._config.popperConfig
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $e9dd36436aec3b21$var$EventHandler.on(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $e9dd36436aec3b21$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSEENTER) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSOUT$1);
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e9dd36436aec3b21$var$EventHandler.on(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e9dd36436aec3b21$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e9dd36436aec3b21$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for(const key in this._config)if (this.constructor.Default[key] !== this._config[key]) config[key] = this._config[key];
        config.selector = false;
        config.trigger = "manual"; // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$3 = "popover";
const $e9dd36436aec3b21$var$SELECTOR_TITLE = ".popover-header";
const $e9dd36436aec3b21$var$SELECTOR_CONTENT = ".popover-body";
const $e9dd36436aec3b21$var$Default$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $e9dd36436aec3b21$var$DefaultType$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$5b6b19405a83ff9d extends $e9dd36436aec3b21$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$2;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$2;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$3;
    }
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TITLE]: this._getTitle(),
            [$e9dd36436aec3b21$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$2 = "scrollspy";
const $e9dd36436aec3b21$var$DATA_KEY$2 = "bs.scrollspy";
const $e9dd36436aec3b21$var$EVENT_KEY$2 = `.${$e9dd36436aec3b21$var$DATA_KEY$2}`;
const $e9dd36436aec3b21$var$DATA_API_KEY = ".data-api";
const $e9dd36436aec3b21$var$EVENT_ACTIVATE = `activate${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_CLICK = `click${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1 = `load${$e9dd36436aec3b21$var$EVENT_KEY$2}${$e9dd36436aec3b21$var$DATA_API_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1 = "active";
const $e9dd36436aec3b21$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS = "[href]";
const $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $e9dd36436aec3b21$var$SELECTOR_NAV_LINKS = ".nav-link";
const $e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS = `${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS} > ${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS}`;
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN = ".dropdown";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $e9dd36436aec3b21$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e9dd36436aec3b21$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$a6472a5298a374be extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config); // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default$1;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$1;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$2;
    }
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e9dd36436aec3b21$var$getElement(config.target) || document.body; // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
         // unregister any previous listeners
        $e9dd36436aec3b21$var$EventHandler.off(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK);
        $e9dd36436aec3b21$var$EventHandler.on(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK, $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                } // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop; // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry); // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            } // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e9dd36436aec3b21$var$isDisabled(anchor)) continue;
            const observableSection = $e9dd36436aec3b21$var$SelectorEngine.findOne(anchor.hash, this._element); // ensure that the observableSection exists & is visible
            if ($e9dd36436aec3b21$var$isVisible(observableSection)) {
                this._targetLinks.set(anchor.hash, anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e9dd36436aec3b21$var$SELECTOR_DROPDOWN)).classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e9dd36436aec3b21$var$SelectorEngine.parents(target, $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e9dd36436aec3b21$var$SelectorEngine.prev(listGroup, $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS))item.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e9dd36436aec3b21$var$SelectorEngine.find(`${$e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS}.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_SPY))$e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$1 = "tab";
const $e9dd36436aec3b21$var$DATA_KEY$1 = "bs.tab";
const $e9dd36436aec3b21$var$EVENT_KEY$1 = `.${$e9dd36436aec3b21$var$DATA_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$1 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$1 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$1 = `show${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$1 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API = `click${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API = `load${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY = "ArrowLeft";
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY = "ArrowRight";
const $e9dd36436aec3b21$var$ARROW_UP_KEY = "ArrowUp";
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY = "ArrowDown";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE = "active";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$1 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1 = "show";
const $e9dd36436aec3b21$var$CLASS_DROPDOWN = "dropdown";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(.dropdown-toggle)";
const $e9dd36436aec3b21$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e9dd36436aec3b21$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $e9dd36436aec3b21$var$SELECTOR_INNER = `.nav-link${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // todo:v6: could be only `tab`
const $e9dd36436aec3b21$var$SELECTOR_INNER_ELEM = `${$e9dd36436aec3b21$var$SELECTOR_INNER}, ${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$3e41faf802a29e71 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e9dd36436aec3b21$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return; // todo: should Throw exception on v6
         // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$1;
    }
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
         // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e9dd36436aec3b21$var$EventHandler.trigger(active, $e9dd36436aec3b21$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(innerElem, $e9dd36436aec3b21$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        this._activate($e9dd36436aec3b21$var$getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e9dd36436aec3b21$var$getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e9dd36436aec3b21$var$ARROW_LEFT_KEY,
            $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
            $e9dd36436aec3b21$var$ARROW_UP_KEY,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const isNext = [
            $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY
        ].includes(event.key);
        const nextActiveElement = $e9dd36436aec3b21$var$getNextActiveElement(this._getChildren().filter((element)=>!$e9dd36436aec3b21$var$isDisabled(element)), event.target, isNext, true);
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab"); // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e9dd36436aec3b21$var$getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `#${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e9dd36436aec3b21$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE, $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
    }
    _getInnerElement(elem) {
        return elem.matches($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM) ? elem : $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, elem);
    }
    _getOuterElement(elem) {
        return elem.closest($e9dd36436aec3b21$var$SELECTOR_OUTER) || elem;
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.2.3): toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME = "toast";
const $e9dd36436aec3b21$var$DATA_KEY = "bs.toast";
const $e9dd36436aec3b21$var$EVENT_KEY = `.${$e9dd36436aec3b21$var$DATA_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOVER = `mouseover${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOUT = `mouseout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN = `focusin${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT = `focusout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDE = `hide${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN = `hidden${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOW = `show${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN = `shown${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING = "showing";
const $e9dd36436aec3b21$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $e9dd36436aec3b21$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$8d8dc7d5f743331b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    static get Default() {
        return $e9dd36436aec3b21$var$Default;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME;
    }
    show() {
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW, $e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING, $e9dd36436aec3b21$var$CLASS_NAME_SHOW);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
    }
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$8d8dc7d5f743331b);


/**
 * NOTE Pannellum is not a module,
 * it should only be imported and instantiated once
 */ /*
 * Pannellum - An HTML5 based Panorama Viewer
 * Copyright (c) 2011-2019 Matthew Petroff
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ window.pannellum = function(window1, document1, undefined) {
    "use strict";
    /**
 * Creates a new panorama viewer.
 * @constructor
 * @param {HTMLElement|string} container - The container (div) element for the
 *      viewer, or its ID.
 * @param {Object} initialConfig - Inital configuration for viewer.
 */ function Viewer(container, initialConfig) {
        var _this = this;
        // Declare variables
        var config, renderer, preview, isUserInteracting = false, latestInteraction = Date.now(), onPointerDownPointerX = 0, onPointerDownPointerY = 0, onPointerDownPointerDist = -1, onPointerDownYaw = 0, onPointerDownPitch = 0, keysDown = new Array(10), fullscreenActive = false, loaded, error = false, isTimedOut = false, listenersAdded = false, panoImage, prevTime, speed = {
            "yaw": 0,
            "pitch": 0,
            "hfov": 0
        }, animating = false, orientation = false, orientationYawOffset = 0, autoRotateStart, autoRotateSpeed = 0, origHfov, origPitch, animatedMove = {}, externalEventListeners = {}, specifiedPhotoSphereExcludes = [], update = false, eps = 1e-6, hotspotsCreated = false, destroyed = false;
        var defaultConfig = {
            hfov: 100,
            minHfov: 50,
            multiResMinHfov: false,
            maxHfov: 120,
            pitch: 0,
            minPitch: undefined,
            maxPitch: undefined,
            yaw: 0,
            minYaw: -180,
            maxYaw: 180,
            roll: 0,
            haov: 360,
            vaov: 180,
            vOffset: 0,
            autoRotate: false,
            autoRotateInactivityDelay: -1,
            autoRotateStopDelay: undefined,
            type: "equirectangular",
            northOffset: 0,
            showFullscreenCtrl: true,
            dynamic: false,
            dynamicUpdate: false,
            doubleClickZoom: true,
            keyboardZoom: true,
            mouseZoom: true,
            showZoomCtrl: true,
            autoLoad: false,
            showControls: true,
            orientationOnByDefault: false,
            hotSpotDebug: false,
            backgroundColor: [
                0,
                0,
                0
            ],
            avoidShowingBackground: false,
            animationTimingFunction: timingFunction,
            draggable: true,
            disableKeyboardCtrl: false,
            crossOrigin: "anonymous",
            touchPanSpeedCoeffFactor: 1,
            capturedKeyNumbers: [
                16,
                17,
                27,
                37,
                38,
                39,
                40,
                61,
                65,
                68,
                83,
                87,
                107,
                109,
                173,
                187,
                189
            ],
            friction: 0.15
        };
        // Translatable / configurable strings
        // Some strings contain '%s', which is a placeholder for inserted values
        // When setting strings in external configuration, `\n` should be used instead of `<br>` to insert line breaks
        defaultConfig.strings = {
            // Labels
            loadButtonLabel: "Click to<br>Load<br>Panorama",
            loadingLabel: "Loading...",
            bylineLabel: "by %s",
            // Errors
            noPanoramaError: "No panorama image was specified.",
            fileAccessError: "The file %s could not be accessed.",
            malformedURLError: "There is something wrong with the panorama URL.",
            iOS8WebGLError: "Due to iOS 8's broken WebGL implementation, only progressive encoded JPEGs work for your device (this panorama uses standard encoding).",
            genericWebGLError: "Your browser does not have the necessary WebGL support to display this panorama.",
            textureSizeError: "This panorama is too big for your device! It's %spx wide, but your device only supports images up to %spx wide. Try another device. (If you're the author, try scaling down the image.)",
            unknownError: "Unknown error. Check developer console."
        };
        // Initialize container
        container = typeof container === "string" ? document1.getElementById(container) : container;
        container.classList.add("pnlm-container");
        container.tabIndex = 0;
        // Create container for ui
        var uiContainer = document1.createElement("div");
        uiContainer.className = "pnlm-ui";
        container.appendChild(uiContainer);
        // Create container for renderer
        var renderContainer = document1.createElement("div");
        renderContainer.className = "pnlm-render-container";
        container.appendChild(renderContainer);
        var dragFix = document1.createElement("div");
        dragFix.className = "pnlm-dragfix";
        uiContainer.appendChild(dragFix);
        // Display about information on right click
        var aboutMsg = document1.createElement("span");
        aboutMsg.className = "pnlm-about-msg";
        aboutMsg.innerHTML = '<a href="https://pannellum.org/" target="_blank">Pannellum</a>';
        uiContainer.appendChild(aboutMsg);
        dragFix.addEventListener("contextmenu", aboutMessage);
        // Create info display
        var infoDisplay = {};
        // Hot spot debug indicator
        var hotSpotDebugIndicator = document1.createElement("div");
        hotSpotDebugIndicator.className = "pnlm-sprite pnlm-hot-spot-debug-indicator";
        uiContainer.appendChild(hotSpotDebugIndicator);
        // Panorama info
        infoDisplay.container = document1.createElement("div");
        infoDisplay.container.className = "pnlm-panorama-info";
        infoDisplay.title = document1.createElement("div");
        infoDisplay.title.className = "pnlm-title-box";
        infoDisplay.container.appendChild(infoDisplay.title);
        infoDisplay.author = document1.createElement("div");
        infoDisplay.author.className = "pnlm-author-box";
        infoDisplay.container.appendChild(infoDisplay.author);
        uiContainer.appendChild(infoDisplay.container);
        // Load box
        infoDisplay.load = {};
        infoDisplay.load.box = document1.createElement("div");
        infoDisplay.load.box.className = "pnlm-load-box";
        infoDisplay.load.boxp = document1.createElement("p");
        infoDisplay.load.box.appendChild(infoDisplay.load.boxp);
        infoDisplay.load.lbox = document1.createElement("div");
        infoDisplay.load.lbox.className = "pnlm-lbox";
        infoDisplay.load.lbox.innerHTML = '<div class="pnlm-loading"></div>';
        infoDisplay.load.box.appendChild(infoDisplay.load.lbox);
        infoDisplay.load.lbar = document1.createElement("div");
        infoDisplay.load.lbar.className = "pnlm-lbar";
        infoDisplay.load.lbarFill = document1.createElement("div");
        infoDisplay.load.lbarFill.className = "pnlm-lbar-fill";
        infoDisplay.load.lbar.appendChild(infoDisplay.load.lbarFill);
        infoDisplay.load.box.appendChild(infoDisplay.load.lbar);
        infoDisplay.load.msg = document1.createElement("p");
        infoDisplay.load.msg.className = "pnlm-lmsg";
        infoDisplay.load.box.appendChild(infoDisplay.load.msg);
        uiContainer.appendChild(infoDisplay.load.box);
        // Error message
        infoDisplay.errorMsg = document1.createElement("div");
        infoDisplay.errorMsg.className = "pnlm-error-msg pnlm-info-box";
        uiContainer.appendChild(infoDisplay.errorMsg);
        // Create controls
        var controls = {};
        controls.container = document1.createElement("div");
        controls.container.className = "pnlm-controls-container";
        uiContainer.appendChild(controls.container);
        // Load button
        controls.load = document1.createElement("div");
        controls.load.className = "pnlm-load-button";
        controls.load.addEventListener("click", function() {
            processOptions();
            load();
        });
        uiContainer.appendChild(controls.load);
        // Zoom controls
        controls.zoom = document1.createElement("div");
        controls.zoom.className = "pnlm-zoom-controls pnlm-controls";
        controls.zoomIn = document1.createElement("div");
        controls.zoomIn.className = "pnlm-zoom-in pnlm-sprite pnlm-control";
        controls.zoomIn.addEventListener("click", zoomIn);
        controls.zoom.appendChild(controls.zoomIn);
        controls.zoomOut = document1.createElement("div");
        controls.zoomOut.className = "pnlm-zoom-out pnlm-sprite pnlm-control";
        controls.zoomOut.addEventListener("click", zoomOut);
        controls.zoom.appendChild(controls.zoomOut);
        controls.container.appendChild(controls.zoom);
        // Fullscreen toggle
        controls.fullscreen = document1.createElement("div");
        controls.fullscreen.addEventListener("click", toggleFullscreen);
        controls.fullscreen.className = "pnlm-fullscreen-toggle-button pnlm-sprite pnlm-fullscreen-toggle-button-inactive pnlm-controls pnlm-control";
        if (document1.fullscreenEnabled || document1.mozFullScreenEnabled || document1.webkitFullscreenEnabled || document1.msFullscreenEnabled) controls.container.appendChild(controls.fullscreen);
        // Device orientation toggle
        controls.orientation = document1.createElement("div");
        controls.orientation.addEventListener("click", function(e) {
            if (orientation) stopOrientation();
            else startOrientation();
        });
        controls.orientation.addEventListener("mousedown", function(e) {
            e.stopPropagation();
        });
        controls.orientation.addEventListener("touchstart", function(e) {
            e.stopPropagation();
        });
        controls.orientation.addEventListener("pointerdown", function(e) {
            e.stopPropagation();
        });
        controls.orientation.className = "pnlm-orientation-button pnlm-orientation-button-inactive pnlm-sprite pnlm-controls pnlm-control";
        var orientationSupport = false;
        if (window1.DeviceOrientationEvent && location.protocol == "https:" && navigator.userAgent.toLowerCase().indexOf("mobi") >= 0) {
            // This user agent check is here because there's no way to check if a
            // device has an inertia measurement unit. We used to be able to check if a
            // DeviceOrientationEvent had non-null values, but with iOS 13 requiring a
            // permission prompt to access such events, this is no longer possible.
            controls.container.appendChild(controls.orientation);
            orientationSupport = true;
        }
        // Compass
        var compass = document1.createElement("div");
        compass.className = "pnlm-compass pnlm-controls pnlm-control";
        uiContainer.appendChild(compass);
        // Load and process configuration
        if (initialConfig.firstScene) // Activate first scene if specified in URL
        mergeConfig(initialConfig.firstScene);
        else if (initialConfig.default && initialConfig.default.firstScene) // Activate first scene if specified in file
        mergeConfig(initialConfig.default.firstScene);
        else mergeConfig(null);
        processOptions(true);
        /**
 * Initializes viewer.
 * @private
 */ function init() {
            // Display an error for IE 9 as it doesn't work but also doesn't otherwise
            // show an error (older versions don't work at all)
            // Based on: http://stackoverflow.com/a/10965203
            var div = document1.createElement("div");
            div.innerHTML = "<!--[if lte IE 9]><i></i><![endif]-->";
            if (div.getElementsByTagName("i").length == 1) {
                anError();
                return;
            }
            origHfov = config.hfov;
            origPitch = config.pitch;
            var i, p;
            if (config.type == "cubemap") {
                panoImage = [];
                for(i = 0; i < 6; i++){
                    panoImage.push(new Image());
                    panoImage[i].crossOrigin = config.crossOrigin;
                }
                infoDisplay.load.lbox.style.display = "block";
                infoDisplay.load.lbar.style.display = "none";
            } else if (config.type == "multires") {
                var c = JSON.parse(JSON.stringify(config.multiRes)); // Deep copy
                // Avoid "undefined" in path, check (optional) multiRes.basePath, too
                // Use only multiRes.basePath if it's an absolute URL
                if (config.basePath && config.multiRes.basePath && !/^(?:[a-z]+:)?\/\//i.test(config.multiRes.basePath)) c.basePath = config.basePath + config.multiRes.basePath;
                else if (config.multiRes.basePath) c.basePath = config.multiRes.basePath;
                else if (config.basePath) c.basePath = config.basePath;
                panoImage = c;
            } else if (config.dynamic === true) panoImage = config.panorama;
            else {
                if (config.panorama === undefined) {
                    anError(config.strings.noPanoramaError);
                    return;
                }
                panoImage = new Image();
            }
            // Configure image loading
            if (config.type == "cubemap") {
                // Quick loading counter for synchronous loading
                var itemsToLoad = 6;
                var onLoad = function() {
                    itemsToLoad--;
                    if (itemsToLoad === 0) onImageLoad();
                };
                var onError = function(e) {
                    var a = document1.createElement("a");
                    a.href = e.target.src;
                    a.textContent = a.href;
                    anError(config.strings.fileAccessError.replace("%s", a.outerHTML));
                };
                for(i = 0; i < panoImage.length; i++){
                    p = config.cubeMap[i];
                    if (p == "null") {
                        console.log("Will use background instead of missing cubemap face " + i);
                        onLoad();
                    } else {
                        if (config.basePath && !absoluteURL(p)) p = config.basePath + p;
                        panoImage[i].onload = onLoad;
                        panoImage[i].onerror = onError;
                        panoImage[i].src = sanitizeURL(p);
                    }
                }
            } else if (config.type == "multires") onImageLoad();
            else {
                p = "";
                if (config.basePath) p = config.basePath;
                if (config.dynamic !== true) {
                    // Still image
                    p = absoluteURL(config.panorama) ? config.panorama : p + config.panorama;
                    panoImage.onload = function() {
                        window1.URL.revokeObjectURL(this.src); // Clean up
                        onImageLoad();
                    };
                    var xhr = new XMLHttpRequest();
                    xhr.onloadend = function() {
                        if (xhr.status != 200) {
                            // Display error if image can't be loaded
                            var a = document1.createElement("a");
                            a.href = p;
                            a.textContent = a.href;
                            anError(config.strings.fileAccessError.replace("%s", a.outerHTML));
                        }
                        var img = this.response;
                        parseGPanoXMP(img);
                        infoDisplay.load.msg.innerHTML = "";
                    };
                    xhr.onprogress = function(e) {
                        if (e.lengthComputable) {
                            // Display progress
                            var percent = e.loaded / e.total * 100;
                            infoDisplay.load.lbarFill.style.width = percent + "%";
                            var unit, numerator, denominator;
                            if (e.total > 1e6) {
                                unit = "MB";
                                numerator = (e.loaded / 1e6).toFixed(2);
                                denominator = (e.total / 1e6).toFixed(2);
                            } else if (e.total > 1e3) {
                                unit = "kB";
                                numerator = (e.loaded / 1e3).toFixed(1);
                                denominator = (e.total / 1e3).toFixed(1);
                            } else {
                                unit = "B";
                                numerator = e.loaded;
                                denominator = e.total;
                            }
                            infoDisplay.load.msg.innerHTML = numerator + " / " + denominator + " " + unit;
                        } else {
                            // Display loading spinner
                            infoDisplay.load.lbox.style.display = "block";
                            infoDisplay.load.lbar.style.display = "none";
                        }
                    };
                    try {
                        xhr.open("GET", p, true);
                    } catch (e) {
                        // Malformed URL
                        anError(config.strings.malformedURLError);
                    }
                    xhr.responseType = "blob";
                    xhr.setRequestHeader("Accept", "image/*,*/*;q=0.9");
                    xhr.withCredentials = config.crossOrigin === "use-credentials";
                    xhr.send();
                }
            }
            if (config.draggable) uiContainer.classList.add("pnlm-grab");
            uiContainer.classList.remove("pnlm-grabbing");
            // Properly handle switching to dynamic scenes
            update = config.dynamicUpdate === true;
            if (config.dynamic && update) {
                panoImage = config.panorama;
                onImageLoad();
            }
        }
        /**
 * Test if URL is absolute or relative.
 * @private
 * @param {string} url - URL to test
 * @returns {boolean} True if absolute, else false
 */ function absoluteURL(url) {
            // From http://stackoverflow.com/a/19709846
            return new RegExp("^(?:[a-z]+:)?//", "i").test(url) || url[0] == "/" || url.slice(0, 5) == "blob:";
        }
        /**
 * Create renderer and initialize event listeners once image is loaded.
 * @private
 */ function onImageLoad() {
            if (!renderer) renderer = new libpannellum.renderer(renderContainer);
            // Only add event listeners once
            if (!listenersAdded) {
                listenersAdded = true;
                dragFix.addEventListener("mousedown", onDocumentMouseDown, false);
                document1.addEventListener("mousemove", onDocumentMouseMove, false);
                document1.addEventListener("mouseup", onDocumentMouseUp, false);
                if (config.mouseZoom) {
                    uiContainer.addEventListener("mousewheel", onDocumentMouseWheel, false);
                    uiContainer.addEventListener("DOMMouseScroll", onDocumentMouseWheel, false);
                }
                if (config.doubleClickZoom) dragFix.addEventListener("dblclick", onDocumentDoubleClick, false);
                container.addEventListener("mozfullscreenchange", onFullScreenChange, false);
                container.addEventListener("webkitfullscreenchange", onFullScreenChange, false);
                container.addEventListener("msfullscreenchange", onFullScreenChange, false);
                container.addEventListener("fullscreenchange", onFullScreenChange, false);
                window1.addEventListener("resize", onDocumentResize, false);
                window1.addEventListener("orientationchange", onDocumentResize, false);
                if (!config.disableKeyboardCtrl) {
                    container.addEventListener("keydown", onDocumentKeyPress, false);
                    container.addEventListener("keyup", onDocumentKeyUp, false);
                    container.addEventListener("blur", clearKeys, false);
                }
                document1.addEventListener("mouseleave", onDocumentMouseUp, false);
                if (document1.documentElement.style.pointerAction === "" && document1.documentElement.style.touchAction === "") {
                    dragFix.addEventListener("pointerdown", onDocumentPointerDown, false);
                    dragFix.addEventListener("pointermove", onDocumentPointerMove, false);
                    dragFix.addEventListener("pointerup", onDocumentPointerUp, false);
                    dragFix.addEventListener("pointerleave", onDocumentPointerUp, false);
                } else {
                    dragFix.addEventListener("touchstart", onDocumentTouchStart, false);
                    dragFix.addEventListener("touchmove", onDocumentTouchMove, false);
                    dragFix.addEventListener("touchend", onDocumentTouchEnd, false);
                }
                // Deal with MS pointer events
                if (window1.navigator.pointerEnabled) container.style.touchAction = "none";
            }
            renderInit();
            setHfov(config.hfov); // possibly adapt hfov after configuration and canvas is complete; prevents empty space on top or bottom by zomming out too much
            setTimeout(function() {
                isTimedOut = true;
            }, 500);
        }
        /**
 * Parses Google Photo Sphere XMP Metadata.
 * https://developers.google.com/photo-sphere/metadata/
 * @private
 * @param {Image} image - Image to read XMP metadata from.
 */ function parseGPanoXMP(image) {
            var reader = new FileReader();
            reader.addEventListener("loadend", function() {
                var img = reader.result;
                // This awful browser specific test exists because iOS 8 does not work
                // with non-progressive encoded JPEGs.
                if (navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 8_/)) {
                    var flagIndex = img.indexOf("\xff\xc2");
                    if (flagIndex < 0 || flagIndex > 65536) anError(config.strings.iOS8WebGLError);
                }
                var start = img.indexOf("<x:xmpmeta");
                if (start > -1 && config.ignoreGPanoXMP !== true) {
                    var xmpData = img.substring(start, img.indexOf("</x:xmpmeta>") + 12);
                    // Extract the requested tag from the XMP data
                    var getTag = function(tag) {
                        var result;
                        if (xmpData.indexOf(tag + '="') >= 0) {
                            result = xmpData.substring(xmpData.indexOf(tag + '="') + tag.length + 2);
                            result = result.substring(0, result.indexOf('"'));
                        } else if (xmpData.indexOf(tag + ">") >= 0) {
                            result = xmpData.substring(xmpData.indexOf(tag + ">") + tag.length + 1);
                            result = result.substring(0, result.indexOf("<"));
                        }
                        if (result !== undefined) return Number(result);
                        return null;
                    };
                    // Relevant XMP data
                    var xmp = {
                        fullWidth: getTag("GPano:FullPanoWidthPixels"),
                        croppedWidth: getTag("GPano:CroppedAreaImageWidthPixels"),
                        fullHeight: getTag("GPano:FullPanoHeightPixels"),
                        croppedHeight: getTag("GPano:CroppedAreaImageHeightPixels"),
                        topPixels: getTag("GPano:CroppedAreaTopPixels"),
                        heading: getTag("GPano:PoseHeadingDegrees"),
                        horizonPitch: getTag("GPano:PosePitchDegrees"),
                        horizonRoll: getTag("GPano:PoseRollDegrees")
                    };
                    if (xmp.fullWidth !== null && xmp.croppedWidth !== null && xmp.fullHeight !== null && xmp.croppedHeight !== null && xmp.topPixels !== null) {
                        // Set up viewer using GPano XMP data
                        if (specifiedPhotoSphereExcludes.indexOf("haov") < 0) config.haov = xmp.croppedWidth / xmp.fullWidth * 360;
                        if (specifiedPhotoSphereExcludes.indexOf("vaov") < 0) config.vaov = xmp.croppedHeight / xmp.fullHeight * 180;
                        if (specifiedPhotoSphereExcludes.indexOf("vOffset") < 0) config.vOffset = ((xmp.topPixels + xmp.croppedHeight / 2) / xmp.fullHeight - 0.5) * -180;
                        if (xmp.heading !== null && specifiedPhotoSphereExcludes.indexOf("northOffset") < 0) {
                            // TODO: make sure this works correctly for partial panoramas
                            config.northOffset = xmp.heading;
                            if (config.compass !== false) config.compass = true;
                        }
                        if (xmp.horizonPitch !== null && xmp.horizonRoll !== null) {
                            if (specifiedPhotoSphereExcludes.indexOf("horizonPitch") < 0) config.horizonPitch = xmp.horizonPitch;
                            if (specifiedPhotoSphereExcludes.indexOf("horizonRoll") < 0) config.horizonRoll = xmp.horizonRoll;
                        }
                    // TODO: add support for initial view settings
                    }
                }
                // Load panorama
                panoImage.src = window1.URL.createObjectURL(image);
            });
            if (reader.readAsBinaryString !== undefined) reader.readAsBinaryString(image);
            else reader.readAsText(image);
        }
        /**
 * Displays an error message.
 * @private
 * @param {string} errorMsg - Error message to display. If not specified, a
 *      generic WebGL error is displayed.
 */ function anError(errorMsg) {
            if (errorMsg === undefined) errorMsg = config.strings.genericWebGLError;
            infoDisplay.errorMsg.innerHTML = "<p>" + errorMsg + "</p>";
            controls.load.style.display = "none";
            infoDisplay.load.box.style.display = "none";
            infoDisplay.errorMsg.style.display = "table";
            error = true;
            loaded = undefined;
            renderContainer.style.display = "none";
            fireEvent("error", errorMsg);
        }
        /**
 * Hides error message display.
 * @private
 */ function clearError() {
            if (error) {
                infoDisplay.load.box.style.display = "none";
                infoDisplay.errorMsg.style.display = "none";
                error = false;
                renderContainer.style.display = "block";
                fireEvent("errorcleared");
            }
        }
        /**
 * Displays about message.
 * @private
 * @param {MouseEvent} event - Right click location
 */ function aboutMessage(event1) {
            var pos = mousePosition(event1);
            aboutMsg.style.left = pos.x + "px";
            aboutMsg.style.top = pos.y + "px";
            clearTimeout(aboutMessage.t1);
            clearTimeout(aboutMessage.t2);
            aboutMsg.style.display = "block";
            aboutMsg.style.opacity = 1;
            aboutMessage.t1 = setTimeout(function() {
                aboutMsg.style.opacity = 0;
            }, 2000);
            aboutMessage.t2 = setTimeout(function() {
                aboutMsg.style.display = "none";
            }, 2500);
            event1.preventDefault();
        }
        /**
 * Calculate mouse position relative to top left of viewer container.
 * @private
 * @param {MouseEvent} event - Mouse event to use in calculation
 * @returns {Object} Calculated X and Y coordinates
 */ function mousePosition(event1) {
            var bounds = container.getBoundingClientRect();
            var pos = {};
            // pageX / pageY needed for iOS
            pos.x = (event1.clientX || event1.pageX) - bounds.left;
            pos.y = (event1.clientY || event1.pageY) - bounds.top;
            return pos;
        }
        /**
 * Event handler for mouse clicks. Initializes panning. Prints center and click
 * location coordinates when hot spot debugging is enabled.
 * @private
 * @param {MouseEvent} event - Document mouse down event.
 */ function onDocumentMouseDown(event1) {
            // Override default action
            event1.preventDefault();
            // But not all of it
            container.focus();
            // Only do something if the panorama is loaded
            if (!loaded || !config.draggable) return;
            // Calculate mouse position relative to top left of viewer container
            var pos = mousePosition(event1);
            // Log pitch / yaw of mouse click when debugging / placing hot spots
            if (config.hotSpotDebug) {
                var coords = mouseEventToCoords(event1);
                console.log("Pitch: " + coords[0] + ", Yaw: " + coords[1] + ", Center Pitch: " + config.pitch + ", Center Yaw: " + config.yaw + ", HFOV: " + config.hfov);
            }
            // Turn off auto-rotation if enabled
            stopAnimation();
            stopOrientation();
            config.roll = 0;
            speed.hfov = 0;
            isUserInteracting = true;
            latestInteraction = Date.now();
            onPointerDownPointerX = pos.x;
            onPointerDownPointerY = pos.y;
            onPointerDownYaw = config.yaw;
            onPointerDownPitch = config.pitch;
            uiContainer.classList.add("pnlm-grabbing");
            uiContainer.classList.remove("pnlm-grab");
            fireEvent("mousedown", event1);
            animateInit();
        }
        /**
 * Event handler for double clicks. Zooms in at clicked location
 * @private
 * @param {MouseEvent} event - Document mouse down event.
 */ function onDocumentDoubleClick(event1) {
            if (config.minHfov === config.hfov) _this.setHfov(origHfov, 1000);
            else {
                var coords = mouseEventToCoords(event1);
                _this.lookAt(coords[0], coords[1], config.minHfov, 1000);
            }
        }
        /**
 * Calculate panorama pitch and yaw from location of mouse event.
 * @private
 * @param {MouseEvent} event - Document mouse down event.
 * @returns {number[]} [pitch, yaw]
 */ function mouseEventToCoords(event1) {
            var pos = mousePosition(event1);
            var canvas = renderer.getCanvas();
            var canvasWidth = canvas.clientWidth, canvasHeight = canvas.clientHeight;
            var x = pos.x / canvasWidth * 2 - 1;
            var y = (1 - pos.y / canvasHeight * 2) * canvasHeight / canvasWidth;
            var focal = 1 / Math.tan(config.hfov * Math.PI / 360);
            var s = Math.sin(config.pitch * Math.PI / 180);
            var c = Math.cos(config.pitch * Math.PI / 180);
            var a = focal * c - y * s;
            var root = Math.sqrt(x * x + a * a);
            var pitch = Math.atan((y * c + focal * s) / root) * 180 / Math.PI;
            var yaw = Math.atan2(x / root, a / root) * 180 / Math.PI + config.yaw;
            if (yaw < -180) yaw += 360;
            if (yaw > 180) yaw -= 360;
            return [
                pitch,
                yaw
            ];
        }
        /**
 * Event handler for mouse moves. Pans center of view.
 * @private
 * @param {MouseEvent} event - Document mouse move event.
 */ function onDocumentMouseMove(event1) {
            if (isUserInteracting && loaded) {
                latestInteraction = Date.now();
                var canvas = renderer.getCanvas();
                var canvasWidth = canvas.clientWidth, canvasHeight = canvas.clientHeight;
                var pos = mousePosition(event1);
                //TODO: This still isn't quite right
                var yaw = (Math.atan(onPointerDownPointerX / canvasWidth * 2 - 1) - Math.atan(pos.x / canvasWidth * 2 - 1)) * 180 / Math.PI * config.hfov / 90 + onPointerDownYaw;
                speed.yaw = (yaw - config.yaw) % 360 * 0.2;
                config.yaw = yaw;
                var vfov = 2 * Math.atan(Math.tan(config.hfov / 360 * Math.PI) * canvasHeight / canvasWidth) * 180 / Math.PI;
                var pitch = (Math.atan(pos.y / canvasHeight * 2 - 1) - Math.atan(onPointerDownPointerY / canvasHeight * 2 - 1)) * 180 / Math.PI * vfov / 90 + onPointerDownPitch;
                speed.pitch = (pitch - config.pitch) * 0.2;
                config.pitch = pitch;
            }
        }
        /**
 * Event handler for mouse up events. Stops panning.
 * @private
 */ function onDocumentMouseUp(event1) {
            if (!isUserInteracting) return;
            isUserInteracting = false;
            if (Date.now() - latestInteraction > 15) // Prevents jump when user rapidly moves mouse, stops, and then
            // releases the mouse button
            speed.pitch = speed.yaw = 0;
            uiContainer.classList.add("pnlm-grab");
            uiContainer.classList.remove("pnlm-grabbing");
            latestInteraction = Date.now();
            fireEvent("mouseup", event1);
        }
        /**
 * Event handler for touches. Initializes panning if one touch or zooming if
 * two touches.
 * @private
 * @param {TouchEvent} event - Document touch start event.
 */ function onDocumentTouchStart(event1) {
            // Only do something if the panorama is loaded
            if (!loaded || !config.draggable) return;
            // Turn off auto-rotation if enabled
            stopAnimation();
            stopOrientation();
            config.roll = 0;
            speed.hfov = 0;
            // Calculate touch position relative to top left of viewer container
            var pos0 = mousePosition(event1.targetTouches[0]);
            onPointerDownPointerX = pos0.x;
            onPointerDownPointerY = pos0.y;
            if (event1.targetTouches.length == 2) {
                // Down pointer is the center of the two fingers
                var pos1 = mousePosition(event1.targetTouches[1]);
                onPointerDownPointerX += (pos1.x - pos0.x) * 0.5;
                onPointerDownPointerY += (pos1.y - pos0.y) * 0.5;
                onPointerDownPointerDist = Math.sqrt((pos0.x - pos1.x) * (pos0.x - pos1.x) + (pos0.y - pos1.y) * (pos0.y - pos1.y));
            }
            isUserInteracting = true;
            latestInteraction = Date.now();
            onPointerDownYaw = config.yaw;
            onPointerDownPitch = config.pitch;
            fireEvent("touchstart", event1);
            animateInit();
        }
        /**
 * Event handler for touch movements. Pans center of view if one touch or
 * adjusts zoom if two touches.
 * @private
 * @param {TouchEvent} event - Document touch move event.
 */ function onDocumentTouchMove(event1) {
            if (!config.draggable) return;
            // Override default action
            event1.preventDefault();
            if (loaded) latestInteraction = Date.now();
            if (isUserInteracting && loaded) {
                var pos0 = mousePosition(event1.targetTouches[0]);
                var clientX = pos0.x;
                var clientY = pos0.y;
                if (event1.targetTouches.length == 2 && onPointerDownPointerDist != -1) {
                    var pos1 = mousePosition(event1.targetTouches[1]);
                    clientX += (pos1.x - pos0.x) * 0.5;
                    clientY += (pos1.y - pos0.y) * 0.5;
                    var clientDist = Math.sqrt((pos0.x - pos1.x) * (pos0.x - pos1.x) + (pos0.y - pos1.y) * (pos0.y - pos1.y));
                    setHfov(config.hfov + (onPointerDownPointerDist - clientDist) * 0.1);
                    onPointerDownPointerDist = clientDist;
                }
                // The smaller the config.hfov value (the more zoomed-in the user is), the faster
                // yaw/pitch are perceived to change on one-finger touchmove (panning) events and vice versa.
                // To improve usability at both small and large zoom levels (config.hfov values)
                // we introduce a dynamic pan speed coefficient.
                //
                // Currently this seems to *roughly* keep initial drag/pan start position close to
                // the user's finger while panning regardless of zoom level / config.hfov value.
                var touchmovePanSpeedCoeff = config.hfov / 360 * config.touchPanSpeedCoeffFactor;
                var yaw = (onPointerDownPointerX - clientX) * touchmovePanSpeedCoeff + onPointerDownYaw;
                speed.yaw = (yaw - config.yaw) % 360 * 0.2;
                config.yaw = yaw;
                var pitch = (clientY - onPointerDownPointerY) * touchmovePanSpeedCoeff + onPointerDownPitch;
                speed.pitch = (pitch - config.pitch) * 0.2;
                config.pitch = pitch;
            }
        }
        /**
 * Event handler for end of touches. Stops panning and/or zooming.
 * @private
 */ function onDocumentTouchEnd() {
            isUserInteracting = false;
            if (Date.now() - latestInteraction > 150) speed.pitch = speed.yaw = 0;
            onPointerDownPointerDist = -1;
            latestInteraction = Date.now();
            fireEvent("touchend", event);
        }
        var pointerIDs = [], pointerCoordinates = [];
        /**
 * Event handler for touch starts in IE / Edge.
 * @private
 * @param {PointerEvent} event - Document pointer down event.
 */ function onDocumentPointerDown(event1) {
            if (event1.pointerType == "touch") {
                // Only do something if the panorama is loaded
                if (!loaded || !config.draggable) return;
                pointerIDs.push(event1.pointerId);
                pointerCoordinates.push({
                    clientX: event1.clientX,
                    clientY: event1.clientY
                });
                event1.targetTouches = pointerCoordinates;
                onDocumentTouchStart(event1);
                event1.preventDefault();
            }
        }
        /**
 * Event handler for touch moves in IE / Edge.
 * @private
 * @param {PointerEvent} event - Document pointer move event.
 */ function onDocumentPointerMove(event1) {
            if (event1.pointerType == "touch") {
                if (!config.draggable) return;
                for(var i = 0; i < pointerIDs.length; i++)if (event1.pointerId == pointerIDs[i]) {
                    pointerCoordinates[i].clientX = event1.clientX;
                    pointerCoordinates[i].clientY = event1.clientY;
                    event1.targetTouches = pointerCoordinates;
                    onDocumentTouchMove(event1);
                    event1.preventDefault();
                    return;
                }
            }
        }
        /**
 * Event handler for touch ends in IE / Edge.
 * @private
 * @param {PointerEvent} event - Document pointer up event.
 */ function onDocumentPointerUp(event1) {
            if (event1.pointerType == "touch") {
                var defined = false;
                for(var i = 0; i < pointerIDs.length; i++){
                    if (event1.pointerId == pointerIDs[i]) pointerIDs[i] = undefined;
                    if (pointerIDs[i]) defined = true;
                }
                if (!defined) {
                    pointerIDs = [];
                    pointerCoordinates = [];
                    onDocumentTouchEnd();
                }
                event1.preventDefault();
            }
        }
        /**
 * Event handler for mouse wheel. Changes zoom.
 * @private
 * @param {WheelEvent} event - Document mouse wheel event.
 */ function onDocumentMouseWheel(event1) {
            // Only do something if the panorama is loaded and mouse wheel zoom is enabled
            if (!loaded || config.mouseZoom == "fullscreenonly" && !fullscreenActive) return;
            event1.preventDefault();
            // Turn off auto-rotation if enabled
            stopAnimation();
            latestInteraction = Date.now();
            if (event1.wheelDeltaY) {
                // WebKit
                setHfov(config.hfov - event1.wheelDeltaY * 0.05);
                speed.hfov = event1.wheelDelta < 0 ? 1 : -1;
            } else if (event1.wheelDelta) {
                // Opera / Explorer 9
                setHfov(config.hfov - event1.wheelDelta * 0.05);
                speed.hfov = event1.wheelDelta < 0 ? 1 : -1;
            } else if (event1.detail) {
                // Firefox
                setHfov(config.hfov + event1.detail * 1.5);
                speed.hfov = event1.detail > 0 ? 1 : -1;
            }
            animateInit();
        }
        /**
 * Event handler for key presses. Updates list of currently pressed keys.
 * @private
 * @param {KeyboardEvent} event - Document key press event.
 */ function onDocumentKeyPress(event1) {
            // Turn off auto-rotation if enabled
            stopAnimation();
            latestInteraction = Date.now();
            stopOrientation();
            config.roll = 0;
            // Record key pressed
            var keynumber = event1.which || event1.keycode;
            // Override default action for keys that are used
            if (config.capturedKeyNumbers.indexOf(keynumber) < 0) return;
            event1.preventDefault();
            // If escape key is pressed
            if (keynumber == 27) // If in fullscreen mode
            {
                if (fullscreenActive) toggleFullscreen();
            } else // Change key
            changeKey(keynumber, true);
        }
        /**
 * Clears list of currently pressed keys.
 * @private
 */ function clearKeys() {
            for(var i = 0; i < 10; i++)keysDown[i] = false;
        }
        /**
 * Event handler for key releases. Updates list of currently pressed keys.
 * @private
 * @param {KeyboardEvent} event - Document key up event.
 */ function onDocumentKeyUp(event1) {
            // Record key pressed
            var keynumber = event1.which || event1.keycode;
            // Override default action for keys that are used
            if (config.capturedKeyNumbers.indexOf(keynumber) < 0) return;
            event1.preventDefault();
            // Change key
            changeKey(keynumber, false);
        }
        /**
 * Updates list of currently pressed keys.
 * @private
 * @param {number} keynumber - Key number.
 * @param {boolean} value - Whether or not key is pressed.
 */ function changeKey(keynumber, value) {
            var keyChanged = false;
            switch(keynumber){
                // If minus key is released
                case 109:
                case 189:
                case 17:
                case 173:
                    if (keysDown[0] != value) keyChanged = true;
                    keysDown[0] = value;
                    break;
                // If plus key is released
                case 107:
                case 187:
                case 16:
                case 61:
                    if (keysDown[1] != value) keyChanged = true;
                    keysDown[1] = value;
                    break;
                // If up arrow is released
                case 38:
                    if (keysDown[2] != value) keyChanged = true;
                    keysDown[2] = value;
                    break;
                // If "w" is released
                case 87:
                    if (keysDown[6] != value) keyChanged = true;
                    keysDown[6] = value;
                    break;
                // If down arrow is released
                case 40:
                    if (keysDown[3] != value) keyChanged = true;
                    keysDown[3] = value;
                    break;
                // If "s" is released
                case 83:
                    if (keysDown[7] != value) keyChanged = true;
                    keysDown[7] = value;
                    break;
                // If left arrow is released
                case 37:
                    if (keysDown[4] != value) keyChanged = true;
                    keysDown[4] = value;
                    break;
                // If "a" is released
                case 65:
                    if (keysDown[8] != value) keyChanged = true;
                    keysDown[8] = value;
                    break;
                // If right arrow is released
                case 39:
                    if (keysDown[5] != value) keyChanged = true;
                    keysDown[5] = value;
                    break;
                // If "d" is released
                case 68:
                    if (keysDown[9] != value) keyChanged = true;
                    keysDown[9] = value;
            }
            if (keyChanged && value) {
                if (typeof performance !== "undefined" && performance.now()) prevTime = performance.now();
                else prevTime = Date.now();
                animateInit();
            }
        }
        /**
 * Pans and/or zooms panorama based on currently pressed keys. Also handles
 * panorama "inertia" and auto rotation.
 * @private
 */ function keyRepeat() {
            // Only do something if the panorama is loaded
            if (!loaded) return;
            var isKeyDown = false;
            var prevPitch = config.pitch;
            var prevYaw = config.yaw;
            var prevZoom = config.hfov;
            var newTime;
            if (typeof performance !== "undefined" && performance.now()) newTime = performance.now();
            else newTime = Date.now();
            if (prevTime === undefined) prevTime = newTime;
            var diff = (newTime - prevTime) * config.hfov / 1700;
            diff = Math.min(diff, 1.0);
            // If minus key is down
            if (keysDown[0] && config.keyboardZoom === true) {
                setHfov(config.hfov + (speed.hfov * 0.8 + 0.5) * diff);
                isKeyDown = true;
            }
            // If plus key is down
            if (keysDown[1] && config.keyboardZoom === true) {
                setHfov(config.hfov + (speed.hfov * 0.8 - 0.2) * diff);
                isKeyDown = true;
            }
            // If up arrow or "w" is down
            if (keysDown[2] || keysDown[6]) {
                // Pan up
                config.pitch += (speed.pitch * 0.8 + 0.2) * diff;
                isKeyDown = true;
            }
            // If down arrow or "s" is down
            if (keysDown[3] || keysDown[7]) {
                // Pan down
                config.pitch += (speed.pitch * 0.8 - 0.2) * diff;
                isKeyDown = true;
            }
            // If left arrow or "a" is down
            if (keysDown[4] || keysDown[8]) {
                // Pan left
                config.yaw += (speed.yaw * 0.8 - 0.2) * diff;
                isKeyDown = true;
            }
            // If right arrow or "d" is down
            if (keysDown[5] || keysDown[9]) {
                // Pan right
                config.yaw += (speed.yaw * 0.8 + 0.2) * diff;
                isKeyDown = true;
            }
            if (isKeyDown) latestInteraction = Date.now();
            // If auto-rotate
            if (config.autoRotate) {
                // Pan
                if (newTime - prevTime > 0.001) {
                    var timeDiff = (newTime - prevTime) / 1000;
                    var yawDiff = (speed.yaw / timeDiff * diff - config.autoRotate * 0.2) * timeDiff;
                    yawDiff = (-config.autoRotate > 0 ? 1 : -1) * Math.min(Math.abs(config.autoRotate * timeDiff), Math.abs(yawDiff));
                    config.yaw += yawDiff;
                }
                // Deal with stopping auto rotation after a set delay
                if (config.autoRotateStopDelay) {
                    config.autoRotateStopDelay -= newTime - prevTime;
                    if (config.autoRotateStopDelay <= 0) {
                        config.autoRotateStopDelay = false;
                        autoRotateSpeed = config.autoRotate;
                        config.autoRotate = 0;
                    }
                }
            }
            // Animated moves
            if (animatedMove.pitch) {
                animateMove("pitch");
                prevPitch = config.pitch;
            }
            if (animatedMove.yaw) {
                animateMove("yaw");
                prevYaw = config.yaw;
            }
            if (animatedMove.hfov) {
                animateMove("hfov");
                prevZoom = config.hfov;
            }
            // "Inertia"
            if (diff > 0 && !config.autoRotate) {
                // "Friction"
                var slowDownFactor = 1 - config.friction;
                // Yaw
                if (!keysDown[4] && !keysDown[5] && !keysDown[8] && !keysDown[9] && !animatedMove.yaw) config.yaw += speed.yaw * diff * slowDownFactor;
                // Pitch
                if (!keysDown[2] && !keysDown[3] && !keysDown[6] && !keysDown[7] && !animatedMove.pitch) config.pitch += speed.pitch * diff * slowDownFactor;
                // Zoom
                if (!keysDown[0] && !keysDown[1] && !animatedMove.hfov) setHfov(config.hfov + speed.hfov * diff * slowDownFactor);
            }
            prevTime = newTime;
            if (diff > 0) {
                speed.yaw = speed.yaw * 0.8 + (config.yaw - prevYaw) / diff * 0.2;
                speed.pitch = speed.pitch * 0.8 + (config.pitch - prevPitch) / diff * 0.2;
                speed.hfov = speed.hfov * 0.8 + (config.hfov - prevZoom) / diff * 0.2;
                // Limit speed
                var maxSpeed = config.autoRotate ? Math.abs(config.autoRotate) : 5;
                speed.yaw = Math.min(maxSpeed, Math.max(speed.yaw, -maxSpeed));
                speed.pitch = Math.min(maxSpeed, Math.max(speed.pitch, -maxSpeed));
                speed.hfov = Math.min(maxSpeed, Math.max(speed.hfov, -maxSpeed));
            }
            // Stop movement if opposite controls are pressed
            if (keysDown[0] && keysDown[1]) speed.hfov = 0;
            if ((keysDown[2] || keysDown[6]) && (keysDown[3] || keysDown[7])) speed.pitch = 0;
            if ((keysDown[4] || keysDown[8]) && (keysDown[5] || keysDown[9])) speed.yaw = 0;
        }
        /**
 * Animates moves.
 * @param {string} axis - Axis to animate
 * @private
 */ function animateMove(axis) {
            var t = animatedMove[axis];
            var normTime = Math.min(1, Math.max((Date.now() - t.startTime) / 1000 / (t.duration / 1000), 0));
            var result = t.startPosition + config.animationTimingFunction(normTime) * (t.endPosition - t.startPosition);
            if (t.endPosition > t.startPosition && result >= t.endPosition || t.endPosition < t.startPosition && result <= t.endPosition || t.endPosition === t.startPosition) {
                result = t.endPosition;
                speed[axis] = 0;
                delete animatedMove[axis];
            }
            config[axis] = result;
        }
        /**
 * @param {number} t - Normalized time in animation
 * @return {number} Position in animation
 * @private
 */ function timingFunction(t) {
            // easeInOutQuad from https://gist.github.com/gre/1650294
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }
        /**
 * Event handler for document resizes. Updates viewer size and rerenders view.
 * @private
 */ function onDocumentResize() {
            // Resize panorama renderer (moved to onFullScreenChange)
            //renderer.resize();
            //animateInit();
            // Kludge to deal with WebKit regression: https://bugs.webkit.org/show_bug.cgi?id=93525
            onFullScreenChange("resize");
        }
        /**
 * Initializes animation.
 * @private
 */ function animateInit() {
            if (animating) return;
            animating = true;
            animate();
        }
        /**
 * Animates view, using requestAnimationFrame to trigger rendering.
 * @private
 */ function animate() {
            if (destroyed) return;
            render();
            if (autoRotateStart) clearTimeout(autoRotateStart);
            if (isUserInteracting || orientation === true) requestAnimationFrame(animate);
            else if (keysDown[0] || keysDown[1] || keysDown[2] || keysDown[3] || keysDown[4] || keysDown[5] || keysDown[6] || keysDown[7] || keysDown[8] || keysDown[9] || config.autoRotate || animatedMove.pitch || animatedMove.yaw || animatedMove.hfov || Math.abs(speed.yaw) > 0.01 || Math.abs(speed.pitch) > 0.01 || Math.abs(speed.hfov) > 0.01) {
                keyRepeat();
                if (config.autoRotateInactivityDelay >= 0 && autoRotateSpeed && Date.now() - latestInteraction > config.autoRotateInactivityDelay && !config.autoRotate) {
                    config.autoRotate = autoRotateSpeed;
                    _this.lookAt(origPitch, undefined, origHfov, 3000);
                }
                requestAnimationFrame(animate);
            } else if (renderer && (renderer.isLoading() || config.dynamic === true && update)) requestAnimationFrame(animate);
            else {
                fireEvent("animatefinished", {
                    pitch: _this.getPitch(),
                    yaw: _this.getYaw(),
                    hfov: _this.getHfov()
                });
                animating = false;
                prevTime = undefined;
                var autoRotateStartTime = config.autoRotateInactivityDelay - (Date.now() - latestInteraction);
                if (autoRotateStartTime > 0) autoRotateStart = setTimeout(function() {
                    config.autoRotate = autoRotateSpeed;
                    _this.lookAt(origPitch, undefined, origHfov, 3000);
                    animateInit();
                }, autoRotateStartTime);
                else if (config.autoRotateInactivityDelay >= 0 && autoRotateSpeed) {
                    config.autoRotate = autoRotateSpeed;
                    _this.lookAt(origPitch, undefined, origHfov, 3000);
                    animateInit();
                }
            }
        }
        /**
 * Renders panorama view.
 * @private
 */ function render() {
            var tmpyaw;
            if (loaded) {
                var canvas = renderer.getCanvas();
                if (config.autoRotate !== false) {
                    // When auto-rotating this check needs to happen first (see issue #764)
                    if (config.yaw > 360) config.yaw -= 360;
                    else if (config.yaw < -360) config.yaw += 360;
                }
                // Keep a tmp value of yaw for autoRotate comparison later
                tmpyaw = config.yaw;
                // Optionally avoid showing background (empty space) on left or right by adapting min/max yaw
                var hoffcut = 0, voffcut = 0;
                if (config.avoidShowingBackground) {
                    var hfov2 = config.hfov / 2, vfov2 = Math.atan2(Math.tan(hfov2 / 180 * Math.PI), canvas.width / canvas.height) * 180 / Math.PI, transposed = config.vaov > config.haov;
                    if (transposed) voffcut = vfov2 * (1 - Math.min(Math.cos((config.pitch - hfov2) / 180 * Math.PI), Math.cos((config.pitch + hfov2) / 180 * Math.PI)));
                    else hoffcut = hfov2 * (1 - Math.min(Math.cos((config.pitch - vfov2) / 180 * Math.PI), Math.cos((config.pitch + vfov2) / 180 * Math.PI)));
                }
                // Ensure the yaw is within min and max allowed
                var yawRange = config.maxYaw - config.minYaw, minYaw = -180, maxYaw = 180;
                if (yawRange < 360) {
                    minYaw = config.minYaw + config.hfov / 2 + hoffcut;
                    maxYaw = config.maxYaw - config.hfov / 2 - hoffcut;
                    if (yawRange < config.hfov) // Lock yaw to average of min and max yaw when both can be seen at once
                    minYaw = maxYaw = (minYaw + maxYaw) / 2;
                    config.yaw = Math.max(minYaw, Math.min(maxYaw, config.yaw));
                }
                if (!(config.autoRotate !== false)) {
                    // When not auto-rotating, this check needs to happen after the
                    // previous check (see issue #698)
                    if (config.yaw > 360) config.yaw -= 360;
                    else if (config.yaw < -360) config.yaw += 360;
                }
                // Check if we autoRotate in a limited by min and max yaw
                // If so reverse direction
                if (config.autoRotate !== false && tmpyaw != config.yaw && prevTime !== undefined) config.autoRotate *= -1;
                // Ensure the calculated pitch is within min and max allowed
                var vfov = 2 * Math.atan(Math.tan(config.hfov / 180 * Math.PI * 0.5) / (canvas.width / canvas.height)) / Math.PI * 180;
                var minPitch = config.minPitch + vfov / 2, maxPitch = config.maxPitch - vfov / 2;
                var pitchRange = config.maxPitch - config.minPitch;
                if (pitchRange < vfov) // Lock pitch to average of min and max pitch when both can be seen at once
                minPitch = maxPitch = (minPitch + maxPitch) / 2;
                if (isNaN(minPitch)) minPitch = -90;
                if (isNaN(maxPitch)) maxPitch = 90;
                config.pitch = Math.max(minPitch, Math.min(maxPitch, config.pitch));
                renderer.render(config.pitch * Math.PI / 180, config.yaw * Math.PI / 180, config.hfov * Math.PI / 180, {
                    roll: config.roll * Math.PI / 180
                });
                renderHotSpots();
                // Update compass
                if (config.compass) {
                    compass.style.transform = "rotate(" + (-config.yaw - config.northOffset) + "deg)";
                    compass.style.webkitTransform = "rotate(" + (-config.yaw - config.northOffset) + "deg)";
                }
            }
        }
        /**
 * Creates a new quaternion.
 * @private
 * @constructor
 * @param {Number} w - W value
 * @param {Number} x - X value
 * @param {Number} y - Y value
 * @param {Number} z - Z value
 */ function Quaternion(w, x, y, z) {
            this.w = w;
            this.x = x;
            this.y = y;
            this.z = z;
        }
        /**
 * Multiplies quaternions.
 * @private
 * @param {Quaternion} q - Quaternion to multiply
 * @returns {Quaternion} Result of multiplication
 */ Quaternion.prototype.multiply = function(q) {
            return new Quaternion(this.w * q.w - this.x * q.x - this.y * q.y - this.z * q.z, this.x * q.w + this.w * q.x + this.y * q.z - this.z * q.y, this.y * q.w + this.w * q.y + this.z * q.x - this.x * q.z, this.z * q.w + this.w * q.z + this.x * q.y - this.y * q.x);
        };
        /**
 * Converts quaternion to Euler angles.
 * @private
 * @returns {Number[]} [phi angle, theta angle, psi angle]
 */ Quaternion.prototype.toEulerAngles = function() {
            var phi = Math.atan2(2 * (this.w * this.x + this.y * this.z), 1 - 2 * (this.x * this.x + this.y * this.y)), theta = Math.asin(2 * (this.w * this.y - this.z * this.x)), psi = Math.atan2(2 * (this.w * this.z + this.x * this.y), 1 - 2 * (this.y * this.y + this.z * this.z));
            return [
                phi,
                theta,
                psi
            ];
        };
        /**
 * Converts device orientation API Tait-Bryan angles to a quaternion.
 * @private
 * @param {Number} alpha - Alpha angle (in degrees)
 * @param {Number} beta - Beta angle (in degrees)
 * @param {Number} gamma - Gamma angle (in degrees)
 * @returns {Quaternion} Orientation quaternion
 */ function taitBryanToQuaternion(alpha, beta, gamma) {
            var r = [
                beta ? beta * Math.PI / 180 / 2 : 0,
                gamma ? gamma * Math.PI / 180 / 2 : 0,
                alpha ? alpha * Math.PI / 180 / 2 : 0
            ];
            var c = [
                Math.cos(r[0]),
                Math.cos(r[1]),
                Math.cos(r[2])
            ], s = [
                Math.sin(r[0]),
                Math.sin(r[1]),
                Math.sin(r[2])
            ];
            return new Quaternion(c[0] * c[1] * c[2] - s[0] * s[1] * s[2], s[0] * c[1] * c[2] - c[0] * s[1] * s[2], c[0] * s[1] * c[2] + s[0] * c[1] * s[2], c[0] * c[1] * s[2] + s[0] * s[1] * c[2]);
        }
        /**
 * Computes current device orientation quaternion from device orientation API
 * Tait-Bryan angles.
 * @private
 * @param {Number} alpha - Alpha angle (in degrees)
 * @param {Number} beta - Beta angle (in degrees)
 * @param {Number} gamma - Gamma angle (in degrees)
 * @returns {Quaternion} Orientation quaternion
 */ function computeQuaternion(alpha, beta, gamma) {
            // Convert Tait-Bryan angles to quaternion
            var quaternion = taitBryanToQuaternion(alpha, beta, gamma);
            // Apply world transform
            quaternion = quaternion.multiply(new Quaternion(Math.sqrt(0.5), -Math.sqrt(0.5), 0, 0));
            // Apply screen transform
            var angle = window1.orientation ? -window1.orientation * Math.PI / 180 / 2 : 0;
            return quaternion.multiply(new Quaternion(Math.cos(angle), 0, -Math.sin(angle), 0));
        }
        /**
 * Event handler for device orientation API. Controls pointing.
 * @private
 * @param {DeviceOrientationEvent} event - Device orientation event.
 */ function orientationListener(e) {
            var q = computeQuaternion(e.alpha, e.beta, e.gamma).toEulerAngles();
            if (typeof orientation == "number" && orientation < 10) // This kludge is necessary because iOS sometimes provides a few stale
            // device orientation events when the listener is removed and then
            // readded. Thus, we skip the first 10 events to prevent this from
            // causing problems.
            orientation += 1;
            else if (orientation === 10) {
                // Record starting yaw to prevent jumping
                orientationYawOffset = q[2] / Math.PI * 180 + config.yaw;
                orientation = true;
                requestAnimationFrame(animate);
            } else {
                config.pitch = q[0] / Math.PI * 180;
                config.roll = -q[1] / Math.PI * 180;
                config.yaw = -q[2] / Math.PI * 180 + orientationYawOffset;
            }
        }
        /**
 * Initializes renderer.
 * @private
 */ function renderInit() {
            try {
                var params = {};
                if (config.horizonPitch !== undefined) params.horizonPitch = config.horizonPitch * Math.PI / 180;
                if (config.horizonRoll !== undefined) params.horizonRoll = config.horizonRoll * Math.PI / 180;
                if (config.backgroundColor !== undefined) params.backgroundColor = config.backgroundColor;
                renderer.init(panoImage, config.type, config.dynamic, config.haov * Math.PI / 180, config.vaov * Math.PI / 180, config.vOffset * Math.PI / 180, renderInitCallback, params);
                if (config.dynamic !== true) // Allow image to be garbage collected
                panoImage = undefined;
            } catch (event1) {
                // Panorama not loaded
                // Display error if there is a bad texture
                if (event1.type == "webgl error" || event1.type == "no webgl") anError();
                else if (event1.type == "webgl size error") anError(config.strings.textureSizeError.replace("%s", event1.width).replace("%s", event1.maxWidth));
                else {
                    anError(config.strings.unknownError);
                    throw event1;
                }
            }
        }
        /**
 * Triggered when render initialization finishes. Handles fading between
 * scenes as well as showing the compass and hotspots and hiding the loading
 * display.
 * @private
 */ function renderInitCallback() {
            // Fade if specified
            if (config.sceneFadeDuration && renderer.fadeImg !== undefined) {
                renderer.fadeImg.style.opacity = 0;
                // Remove image
                var fadeImg = renderer.fadeImg;
                delete renderer.fadeImg;
                setTimeout(function() {
                    renderContainer.removeChild(fadeImg);
                    fireEvent("scenechangefadedone");
                }, config.sceneFadeDuration);
            }
            // Show compass if applicable
            if (config.compass) compass.style.display = "inline";
            else compass.style.display = "none";
            // Show hotspots
            createHotSpots();
            // Hide loading display
            infoDisplay.load.box.style.display = "none";
            if (preview !== undefined) {
                renderContainer.removeChild(preview);
                preview = undefined;
            }
            loaded = true;
            fireEvent("load");
            animateInit();
        }
        /**
 * Creates hot spot element for the current scene.
 * @private
 * @param {Object} hs - The configuration for the hotspot
 */ function createHotSpot(hs) {
            // Make sure hot spot pitch and yaw are numbers
            hs.pitch = Number(hs.pitch) || 0;
            hs.yaw = Number(hs.yaw) || 0;
            var div = document1.createElement("div");
            div.className = "pnlm-hotspot-base";
            if (hs.cssClass) div.className += " " + hs.cssClass;
            else div.className += " pnlm-hotspot pnlm-sprite pnlm-" + escapeHTML(hs.type);
            var span = document1.createElement("span");
            if (hs.text) span.innerHTML = escapeHTML(hs.text);
            var a;
            if (hs.video) {
                var video = document1.createElement("video"), vidp = hs.video;
                if (config.basePath && !absoluteURL(vidp)) vidp = config.basePath + vidp;
                video.src = sanitizeURL(vidp);
                video.controls = true;
                video.style.width = hs.width + "px";
                renderContainer.appendChild(div);
                span.appendChild(video);
            } else if (hs.image) {
                var imgp = hs.image;
                if (config.basePath && !absoluteURL(imgp)) imgp = config.basePath + imgp;
                a = document1.createElement("a");
                a.href = sanitizeURL(hs.URL ? hs.URL : imgp, true);
                a.target = "_blank";
                span.appendChild(a);
                var image = document1.createElement("img");
                image.src = sanitizeURL(imgp);
                image.style.width = hs.width + "px";
                image.style.paddingTop = "5px";
                renderContainer.appendChild(div);
                a.appendChild(image);
                span.style.maxWidth = "initial";
            } else if (hs.URL) {
                a = document1.createElement("a");
                a.href = sanitizeURL(hs.URL, true);
                if (hs.attributes) for(var key in hs.attributes)a.setAttribute(key, hs.attributes[key]);
                else a.target = "_blank";
                renderContainer.appendChild(a);
                div.className += " pnlm-pointer";
                span.className += " pnlm-pointer";
                a.appendChild(div);
            } else {
                if (hs.sceneId) {
                    div.onclick = div.ontouchend = function() {
                        if (!div.clicked) {
                            div.clicked = true;
                            loadScene(hs.sceneId, hs.targetPitch, hs.targetYaw, hs.targetHfov);
                        }
                        return false;
                    };
                    div.className += " pnlm-pointer";
                    span.className += " pnlm-pointer";
                }
                renderContainer.appendChild(div);
            }
            if (hs.createTooltipFunc) hs.createTooltipFunc(div, hs.createTooltipArgs);
            else if (hs.text || hs.video || hs.image) {
                div.classList.add("pnlm-tooltip");
                div.appendChild(span);
                span.style.width = span.scrollWidth - 20 + "px";
                span.style.marginLeft = -(span.scrollWidth - div.offsetWidth) / 2 + "px";
                span.style.marginTop = -span.scrollHeight - 12 + "px";
            }
            if (hs.clickHandlerFunc) {
                div.addEventListener("click", function(e) {
                    hs.clickHandlerFunc(e, hs.clickHandlerArgs);
                }, "false");
                div.className += " pnlm-pointer";
                span.className += " pnlm-pointer";
            }
            hs.div = div;
        }
        /**
 * Creates hot spot elements for the current scene.
 * @private
 */ function createHotSpots() {
            if (hotspotsCreated) return;
            if (!config.hotSpots) config.hotSpots = [];
            else {
                // Sort by pitch so tooltip is never obscured by another hot spot
                config.hotSpots = config.hotSpots.sort(function(a, b) {
                    return a.pitch < b.pitch;
                });
                config.hotSpots.forEach(createHotSpot);
            }
            hotspotsCreated = true;
            renderHotSpots();
        }
        /**
 * Destroys currently created hot spot elements.
 * @private
 */ function destroyHotSpots() {
            var hs = config.hotSpots;
            hotspotsCreated = false;
            delete config.hotSpots;
            if (hs) for(var i = 0; i < hs.length; i++){
                var current = hs[i].div;
                if (current) {
                    while(current.parentNode && current.parentNode != renderContainer)current = current.parentNode;
                    renderContainer.removeChild(current);
                }
                delete hs[i].div;
            }
        }
        /**
 * Renders hot spot, updating its position and visibility.
 * @private
 */ function renderHotSpot(hs) {
            var hsPitchSin = Math.sin(hs.pitch * Math.PI / 180), hsPitchCos = Math.cos(hs.pitch * Math.PI / 180), configPitchSin = Math.sin(config.pitch * Math.PI / 180), configPitchCos = Math.cos(config.pitch * Math.PI / 180), yawCos = Math.cos((-hs.yaw + config.yaw) * Math.PI / 180);
            var z = hsPitchSin * configPitchSin + hsPitchCos * yawCos * configPitchCos;
            if (hs.yaw <= 90 && hs.yaw > -90 && z <= 0 || (hs.yaw > 90 || hs.yaw <= -90) && z <= 0) hs.div.style.visibility = "hidden";
            else {
                var yawSin = Math.sin((-hs.yaw + config.yaw) * Math.PI / 180), hfovTan = Math.tan(config.hfov * Math.PI / 360);
                hs.div.style.visibility = "visible";
                // Subpixel rendering doesn't work in Firefox
                // https://bugzilla.mozilla.org/show_bug.cgi?id=739176
                var canvas = renderer.getCanvas(), canvasWidth = canvas.clientWidth, canvasHeight = canvas.clientHeight;
                var coord = [
                    -canvasWidth / hfovTan * yawSin * hsPitchCos / z / 2,
                    -canvasWidth / hfovTan * (hsPitchSin * configPitchCos - hsPitchCos * yawCos * configPitchSin) / z / 2
                ];
                // Apply roll
                var rollSin = Math.sin(config.roll * Math.PI / 180), rollCos = Math.cos(config.roll * Math.PI / 180);
                coord = [
                    coord[0] * rollCos - coord[1] * rollSin,
                    coord[0] * rollSin + coord[1] * rollCos
                ];
                // Apply transform
                coord[0] += (canvasWidth - hs.div.offsetWidth) / 2;
                coord[1] += (canvasHeight - hs.div.offsetHeight) / 2;
                var transform = "translate(" + coord[0] + "px, " + coord[1] + "px) translateZ(9999px) rotate(" + config.roll + "deg)";
                if (hs.scale) transform += " scale(" + origHfov / config.hfov / z + ")";
                hs.div.style.webkitTransform = transform;
                hs.div.style.MozTransform = transform;
                hs.div.style.transform = transform;
            }
        }
        /**
 * Renders hot spots, updating their positions and visibility.
 * @private
 */ function renderHotSpots() {
            config.hotSpots.forEach(renderHotSpot);
        }
        /**
 * Merges a scene configuration into the current configuration.
 * @private
 * @param {string} sceneId - Identifier of scene configuration to merge in.
 */ function mergeConfig(sceneId) {
            config = {};
            var k, s;
            var photoSphereExcludes = [
                "haov",
                "vaov",
                "vOffset",
                "northOffset",
                "horizonPitch",
                "horizonRoll"
            ];
            specifiedPhotoSphereExcludes = [];
            // Merge default config
            for(k in defaultConfig)if (defaultConfig.hasOwnProperty(k)) config[k] = defaultConfig[k];
            // Merge default scene config
            for(k in initialConfig.default)if (initialConfig.default.hasOwnProperty(k)) {
                if (k == "strings") {
                    for(s in initialConfig.default.strings)if (initialConfig.default.strings.hasOwnProperty(s)) config.strings[s] = escapeHTML(initialConfig.default.strings[s]);
                } else {
                    config[k] = initialConfig.default[k];
                    if (photoSphereExcludes.indexOf(k) >= 0) specifiedPhotoSphereExcludes.push(k);
                }
            }
            // Merge current scene config
            if (sceneId !== null && sceneId !== "" && initialConfig.scenes && initialConfig.scenes[sceneId]) {
                var scene = initialConfig.scenes[sceneId];
                for(k in scene)if (scene.hasOwnProperty(k)) {
                    if (k == "strings") {
                        for(s in scene.strings)if (scene.strings.hasOwnProperty(s)) config.strings[s] = escapeHTML(scene.strings[s]);
                    } else {
                        config[k] = scene[k];
                        if (photoSphereExcludes.indexOf(k) >= 0) specifiedPhotoSphereExcludes.push(k);
                    }
                }
                config.scene = sceneId;
            }
            // Merge initial config
            for(k in initialConfig)if (initialConfig.hasOwnProperty(k)) {
                if (k == "strings") {
                    for(s in initialConfig.strings)if (initialConfig.strings.hasOwnProperty(s)) config.strings[s] = escapeHTML(initialConfig.strings[s]);
                } else {
                    config[k] = initialConfig[k];
                    if (photoSphereExcludes.indexOf(k) >= 0) specifiedPhotoSphereExcludes.push(k);
                }
            }
        }
        /**
 * Processes configuration options.
 * @param {boolean} [isPreview] - Whether or not the preview is being displayed
 * @private
 */ function processOptions(isPreview) {
            isPreview = isPreview ? isPreview : false;
            // Process preview first so it always loads before the browser hits its
            // maximum number of connections to a server as can happen with cubic
            // panoramas
            if (isPreview && "preview" in config) {
                var p = config.preview;
                if (config.basePath && !absoluteURL(p)) p = config.basePath + p;
                preview = document1.createElement("div");
                preview.className = "pnlm-preview-img";
                preview.style.backgroundImage = "url('" + sanitizeURLForCss(p) + "')";
                renderContainer.appendChild(preview);
            }
            // Handle different preview values
            var title = config.title, author = config.author;
            if (isPreview) {
                if ("previewTitle" in config) config.title = config.previewTitle;
                if ("previewAuthor" in config) config.author = config.previewAuthor;
            }
            // Reset title / author display
            if (!config.hasOwnProperty("title")) infoDisplay.title.innerHTML = "";
            if (!config.hasOwnProperty("author")) infoDisplay.author.innerHTML = "";
            if (!config.hasOwnProperty("title") && !config.hasOwnProperty("author")) infoDisplay.container.style.display = "none";
            // Fill in load button label and loading box text
            controls.load.innerHTML = "<p>" + config.strings.loadButtonLabel + "</p>";
            infoDisplay.load.boxp.innerHTML = config.strings.loadingLabel;
            // Process other options
            for(var key in config)if (config.hasOwnProperty(key)) switch(key){
                case "title":
                    infoDisplay.title.innerHTML = escapeHTML(config[key]);
                    infoDisplay.container.style.display = "inline";
                    break;
                case "author":
                    var authorText = escapeHTML(config[key]);
                    if (config.authorURL) {
                        var authorLink = document1.createElement("a");
                        authorLink.href = sanitizeURL(config["authorURL"], true);
                        authorLink.target = "_blank";
                        authorLink.innerHTML = escapeHTML(config[key]);
                        authorText = authorLink.outerHTML;
                    }
                    infoDisplay.author.innerHTML = config.strings.bylineLabel.replace("%s", authorText);
                    infoDisplay.container.style.display = "inline";
                    break;
                case "fallback":
                    var link = document1.createElement("a");
                    link.href = sanitizeURL(config[key], true);
                    link.target = "_blank";
                    link.textContent = "Click here to view this panorama in an alternative viewer.";
                    var message = document1.createElement("p");
                    message.textContent = "Your browser does not support WebGL.";
                    message.appendChild(document1.createElement("br"));
                    message.appendChild(link);
                    infoDisplay.errorMsg.innerHTML = ""; // Removes all children nodes
                    infoDisplay.errorMsg.appendChild(message);
                    break;
                case "hfov":
                    setHfov(Number(config[key]));
                    break;
                case "autoLoad":
                    if (config[key] === true && renderer === undefined) {
                        // Show loading box
                        infoDisplay.load.box.style.display = "inline";
                        // Hide load button
                        controls.load.style.display = "none";
                        // Initialize
                        init();
                    }
                    break;
                case "showZoomCtrl":
                    if (config[key] && config.showControls != false) // Show zoom controls
                    controls.zoom.style.display = "block";
                    else // Hide zoom controls
                    controls.zoom.style.display = "none";
                    break;
                case "showFullscreenCtrl":
                    if (config[key] && config.showControls != false && ("fullscreen" in document1 || "mozFullScreen" in document1 || "webkitIsFullScreen" in document1 || "msFullscreenElement" in document1)) // Show fullscreen control
                    controls.fullscreen.style.display = "block";
                    else // Hide fullscreen control
                    controls.fullscreen.style.display = "none";
                    break;
                case "hotSpotDebug":
                    if (config[key]) hotSpotDebugIndicator.style.display = "block";
                    else hotSpotDebugIndicator.style.display = "none";
                    break;
                case "showControls":
                    if (!config[key]) {
                        controls.orientation.style.display = "none";
                        controls.zoom.style.display = "none";
                        controls.fullscreen.style.display = "none";
                    }
                    break;
                case "orientationOnByDefault":
                    if (config[key]) startOrientation();
                    break;
            }
            if (isPreview) {
                // Restore original values if changed for preview
                if (title) config.title = title;
                else delete config.title;
                if (author) config.author = author;
                else delete config.author;
            }
        }
        /**
 * Toggles fullscreen mode.
 * @private
 */ function toggleFullscreen() {
            if (loaded && !error) {
                if (!fullscreenActive) try {
                    if (container.requestFullscreen) container.requestFullscreen();
                    else if (container.mozRequestFullScreen) container.mozRequestFullScreen();
                    else if (container.msRequestFullscreen) container.msRequestFullscreen();
                    else container.webkitRequestFullScreen();
                } catch (event1) {
                // Fullscreen doesn't work
                }
                else {
                    if (document1.exitFullscreen) document1.exitFullscreen();
                    else if (document1.mozCancelFullScreen) document1.mozCancelFullScreen();
                    else if (document1.webkitCancelFullScreen) document1.webkitCancelFullScreen();
                    else if (document1.msExitFullscreen) document1.msExitFullscreen();
                }
            }
        }
        /**
 * Event handler for fullscreen changes.
 * @private
 */ function onFullScreenChange(resize) {
            if (document1.fullscreenElement || document1.fullscreen || document1.mozFullScreen || document1.webkitIsFullScreen || document1.msFullscreenElement) {
                controls.fullscreen.classList.add("pnlm-fullscreen-toggle-button-active");
                fullscreenActive = true;
            } else {
                controls.fullscreen.classList.remove("pnlm-fullscreen-toggle-button-active");
                fullscreenActive = false;
            }
            if (resize !== "resize") fireEvent("fullscreenchange", fullscreenActive);
            // Resize renderer (deal with browser quirks and fixes #155)
            renderer.resize();
            setHfov(config.hfov);
            animateInit();
        }
        /**
 * Increases panorama zoom. For use with zoom button.
 * @private
 */ function zoomIn() {
            if (loaded) {
                setHfov(config.hfov - 5);
                animateInit();
            }
        }
        /**
 * Decreases panorama zoom. For use with zoom button.
 * @private
 */ function zoomOut() {
            if (loaded) {
                setHfov(config.hfov + 5);
                animateInit();
            }
        }
        /**
 * Clamps horzontal field of view to viewer's limits.
 * @private
 * @param {number} hfov - Input horizontal field of view (in degrees)
 * @return {number} - Clamped horizontal field of view (in degrees)
 */ function constrainHfov(hfov) {
            // Keep field of view within bounds
            var minHfov = config.minHfov;
            if (config.type == "multires" && renderer && !config.multiResMinHfov) minHfov = Math.min(minHfov, renderer.getCanvas().width / (config.multiRes.cubeResolution / 90 * 0.9));
            if (minHfov > config.maxHfov) {
                // Don't change view if bounds don't make sense
                console.log("HFOV bounds do not make sense (minHfov > maxHfov).");
                return config.hfov;
            }
            var newHfov = config.hfov;
            if (hfov < minHfov) newHfov = minHfov;
            else if (hfov > config.maxHfov) newHfov = config.maxHfov;
            else newHfov = hfov;
            // Optionally avoid showing background (empty space) on top or bottom by adapting newHfov
            if (config.avoidShowingBackground && renderer) {
                var canvas = renderer.getCanvas();
                newHfov = Math.min(newHfov, Math.atan(Math.tan((config.maxPitch - config.minPitch) / 360 * Math.PI) / canvas.height * canvas.width) * 360 / Math.PI);
            }
            return newHfov;
        }
        /**
 * Sets viewer's horizontal field of view.
 * @private
 * @param {number} hfov - Desired horizontal field of view in degrees.
 */ function setHfov(hfov) {
            config.hfov = constrainHfov(hfov);
            fireEvent("zoomchange", config.hfov);
        }
        /**
 * Stops auto rotation and animated moves.
 * @private
 */ function stopAnimation() {
            animatedMove = {};
            autoRotateSpeed = config.autoRotate ? config.autoRotate : autoRotateSpeed;
            config.autoRotate = false;
        }
        /**
 * Loads panorama.
 * @private
 */ function load() {
            // Since WebGL error handling is very general, first we clear any error box
            // since it is a new scene and the error from previous maybe because of lacking
            // memory etc and not because of a lack of WebGL support etc
            clearError();
            loaded = false;
            controls.load.style.display = "none";
            infoDisplay.load.box.style.display = "inline";
            init();
        }
        /**
 * Loads scene.
 * @private
 * @param {string} sceneId - Identifier of scene configuration to merge in.
 * @param {number} targetPitch - Pitch viewer should be centered on once scene loads.
 * @param {number} targetYaw - Yaw viewer should be centered on once scene loads.
 * @param {number} targetHfov - HFOV viewer should use once scene loads.
 * @param {boolean} [fadeDone] - If `true`, fade setup is skipped.
 */ function loadScene(sceneId, targetPitch, targetYaw, targetHfov, fadeDone) {
            if (!loaded) fadeDone = true; // Don't try to fade when there isn't a scene loaded
            loaded = false;
            animatedMove = {};
            // Set up fade if specified
            var fadeImg, workingPitch, workingYaw, workingHfov;
            if (config.sceneFadeDuration && !fadeDone) {
                var data = renderer.render(config.pitch * Math.PI / 180, config.yaw * Math.PI / 180, config.hfov * Math.PI / 180, {
                    returnImage: true
                });
                if (data !== undefined) {
                    fadeImg = new Image();
                    fadeImg.className = "pnlm-fade-img";
                    fadeImg.style.transition = "opacity " + config.sceneFadeDuration / 1000 + "s";
                    fadeImg.style.width = "100%";
                    fadeImg.style.height = "100%";
                    fadeImg.onload = function() {
                        loadScene(sceneId, targetPitch, targetYaw, targetHfov, true);
                    };
                    fadeImg.src = data;
                    renderContainer.appendChild(fadeImg);
                    renderer.fadeImg = fadeImg;
                    return;
                }
            }
            // Set new pointing
            if (targetPitch === "same") workingPitch = config.pitch;
            else workingPitch = targetPitch;
            if (targetYaw === "same") workingYaw = config.yaw;
            else if (targetYaw === "sameAzimuth") workingYaw = config.yaw + (config.northOffset || 0) - (initialConfig.scenes[sceneId].northOffset || 0);
            else workingYaw = targetYaw;
            if (targetHfov === "same") workingHfov = config.hfov;
            else workingHfov = targetHfov;
            // Destroy hot spots from previous scene
            destroyHotSpots();
            // Create the new config for the scene
            mergeConfig(sceneId);
            // Stop motion
            speed.yaw = speed.pitch = speed.hfov = 0;
            // Reload scene
            processOptions();
            if (workingPitch !== undefined) config.pitch = workingPitch;
            if (workingYaw !== undefined) config.yaw = workingYaw;
            if (workingHfov !== undefined) config.hfov = workingHfov;
            fireEvent("scenechange", sceneId);
            load();
        }
        /**
 * Stop using device orientation.
 * @private
 */ function stopOrientation() {
            window1.removeEventListener("deviceorientation", orientationListener);
            controls.orientation.classList.remove("pnlm-orientation-button-active");
            orientation = false;
        }
        /**
 * Start using device orientation.
 * @private
 */ function startOrientation() {
            if (typeof DeviceMotionEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then(function(response) {
                if (response == "granted") {
                    orientation = 1;
                    window1.addEventListener("deviceorientation", orientationListener);
                    controls.orientation.classList.add("pnlm-orientation-button-active");
                }
            });
            else {
                orientation = 1;
                window1.addEventListener("deviceorientation", orientationListener);
                controls.orientation.classList.add("pnlm-orientation-button-active");
            }
        }
        /**
 * Escapes HTML string (to mitigate possible DOM XSS attacks).
 * @private
 * @param {string} s - String to escape
 * @returns {string} Escaped string
 */ function escapeHTML(s) {
            if (!initialConfig.escapeHTML) return String(s).split("\n").join("<br>");
            return String(s).split(/&/g).join("&amp;").split('"').join("&quot;").split("'").join("&#39;").split("<").join("&lt;").split(">").join("&gt;").split("/").join("&#x2f;").split("\n").join("<br>"); // Allow line breaks
        }
        /**
 * Removes possibility of XSS attacks with URLs.
 * The URL cannot be of protocol 'javascript'.
 * @private
 * @param {string} url - URL to sanitize
 * @param {boolean} href - True if URL is for link (blocks data URIs)
 * @returns {string} Sanitized URL
 */ function sanitizeURL(url, href) {
            try {
                var decoded_url = decodeURIComponent(unescape(url)).replace(/[^\w:]/g, "").toLowerCase();
            } catch (e) {
                return "about:blank";
            }
            if (decoded_url.indexOf("javascript:") === 0 || decoded_url.indexOf("vbscript:") === 0) {
                console.log("Script URL removed.");
                return "about:blank";
            }
            if (href && decoded_url.indexOf("data:") === 0) {
                console.log("Data URI removed from link.");
                return "about:blank";
            }
            return url;
        }
        /**
 * Unescapes HTML entities.
 * Copied from Marked.js 0.7.0.
 * @private
 * @param {string} url - URL to sanitize
 * @param {boolean} href - True if URL is for link (blocks data URIs)
 * @returns {string} Sanitized URL
 */ function unescape(html) {
            // Explicitly match decimal, hex, and named HTML entities
            return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function(_, n) {
                n = n.toLowerCase();
                if (n === "colon") return ":";
                if (n.charAt(0) === "#") return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
                return "";
            });
        }
        /**
 * Removes possibility of XSS atacks with URLs for CSS.
 * The URL will be sanitized with `sanitizeURL()` and single quotes
 * and double quotes escaped.
 * @private
 * @param {string} url - URL to sanitize
 * @returns {string} Sanitized URL
 */ function sanitizeURLForCss(url) {
            return sanitizeURL(url).replace(/"/g, "%22").replace(/'/g, "%27");
        }
        /**
 * Checks whether or not a panorama is loaded.
 * @memberof Viewer
 * @instance
 * @returns {boolean} `true` if a panorama is loaded, else `false`
 */ this.isLoaded = function() {
            return Boolean(loaded);
        };
        /**
 * Returns the pitch of the center of the view.
 * @memberof Viewer
 * @instance
 * @returns {number} Pitch in degrees
 */ this.getPitch = function() {
            return config.pitch;
        };
        /**
 * Sets the pitch of the center of the view.
 * @memberof Viewer
 * @instance
 * @param {number} pitch - Pitch in degrees
 * @param {boolean|number} [animated=1000] - Animation duration in milliseconds or false for no animation
 * @param {function} [callback] - Function to call when animation finishes
 * @param {object} [callbackArgs] - Arguments to pass to callback function
 * @returns {Viewer} `this`
 */ this.setPitch = function(pitch, animated, callback, callbackArgs) {
            latestInteraction = Date.now();
            if (Math.abs(pitch - config.pitch) <= eps) {
                if (typeof callback == "function") callback(callbackArgs);
                return this;
            }
            animated = animated == undefined ? 1000 : Number(animated);
            if (animated) {
                animatedMove.pitch = {
                    "startTime": Date.now(),
                    "startPosition": config.pitch,
                    "endPosition": pitch,
                    "duration": animated
                };
                if (typeof callback == "function") setTimeout(function() {
                    callback(callbackArgs);
                }, animated);
            } else config.pitch = pitch;
            animateInit();
            return this;
        };
        /**
 * Returns the minimum and maximum allowed pitches (in degrees).
 * @memberof Viewer
 * @instance
 * @returns {number[]} [minimum pitch, maximum pitch]
 */ this.getPitchBounds = function() {
            return [
                config.minPitch,
                config.maxPitch
            ];
        };
        /**
 * Set the minimum and maximum allowed pitches (in degrees).
 * @memberof Viewer
 * @instance
 * @param {number[]} bounds - [minimum pitch, maximum pitch]
 * @returns {Viewer} `this`
 */ this.setPitchBounds = function(bounds) {
            config.minPitch = Math.max(-90, Math.min(bounds[0], 90));
            config.maxPitch = Math.max(-90, Math.min(bounds[1], 90));
            return this;
        };
        /**
 * Returns the yaw of the center of the view.
 * @memberof Viewer
 * @instance
 * @returns {number} Yaw in degrees
 */ this.getYaw = function() {
            return (config.yaw + 540) % 360 - 180;
        };
        /**
 * Sets the yaw of the center of the view.
 * @memberof Viewer
 * @instance
 * @param {number} yaw - Yaw in degrees [-180, 180]
 * @param {boolean|number} [animated=1000] - Animation duration in milliseconds or false for no animation
 * @param {function} [callback] - Function to call when animation finishes
 * @param {object} [callbackArgs] - Arguments to pass to callback function
 * @returns {Viewer} `this`
 */ this.setYaw = function(yaw, animated, callback, callbackArgs) {
            latestInteraction = Date.now();
            if (Math.abs(yaw - config.yaw) <= eps) {
                if (typeof callback == "function") callback(callbackArgs);
                return this;
            }
            animated = animated == undefined ? 1000 : Number(animated);
            yaw = (yaw + 180) % 360 - 180; // Keep in bounds
            if (animated) {
                // Animate in shortest direction
                if (config.yaw - yaw > 180) yaw += 360;
                else if (yaw - config.yaw > 180) yaw -= 360;
                animatedMove.yaw = {
                    "startTime": Date.now(),
                    "startPosition": config.yaw,
                    "endPosition": yaw,
                    "duration": animated
                };
                if (typeof callback == "function") setTimeout(function() {
                    callback(callbackArgs);
                }, animated);
            } else config.yaw = yaw;
            animateInit();
            return this;
        };
        /**
 * Returns the minimum and maximum allowed pitches (in degrees).
 * @memberof Viewer
 * @instance
 * @returns {number[]} [yaw pitch, maximum yaw]
 */ this.getYawBounds = function() {
            return [
                config.minYaw,
                config.maxYaw
            ];
        };
        /**
 * Set the minimum and maximum allowed yaws (in degrees [-360, 360]).
 * @memberof Viewer
 * @instance
 * @param {number[]} bounds - [minimum yaw, maximum yaw]
 * @returns {Viewer} `this`
 */ this.setYawBounds = function(bounds) {
            config.minYaw = Math.max(-360, Math.min(bounds[0], 360));
            config.maxYaw = Math.max(-360, Math.min(bounds[1], 360));
            return this;
        };
        /**
 * Returns the horizontal field of view.
 * @memberof Viewer
 * @instance
 * @returns {number} Horizontal field of view in degrees
 */ this.getHfov = function() {
            return config.hfov;
        };
        /**
 * Sets the horizontal field of view.
 * @memberof Viewer
 * @instance
 * @param {number} hfov - Horizontal field of view in degrees
 * @param {boolean|number} [animated=1000] - Animation duration in milliseconds or false for no animation
 * @param {function} [callback] - Function to call when animation finishes
 * @param {object} [callbackArgs] - Arguments to pass to callback function
 * @returns {Viewer} `this`
 */ this.setHfov = function(hfov, animated, callback, callbackArgs) {
            latestInteraction = Date.now();
            if (Math.abs(hfov - config.hfov) <= eps) {
                if (typeof callback == "function") callback(callbackArgs);
                return this;
            }
            animated = animated == undefined ? 1000 : Number(animated);
            if (animated) {
                animatedMove.hfov = {
                    "startTime": Date.now(),
                    "startPosition": config.hfov,
                    "endPosition": constrainHfov(hfov),
                    "duration": animated
                };
                if (typeof callback == "function") setTimeout(function() {
                    callback(callbackArgs);
                }, animated);
            } else setHfov(hfov);
            animateInit();
            return this;
        };
        /**
 * Returns the minimum and maximum allowed horizontal fields of view
 * (in degrees).
 * @memberof Viewer
 * @instance
 * @returns {number[]} [minimum hfov, maximum hfov]
 */ this.getHfovBounds = function() {
            return [
                config.minHfov,
                config.maxHfov
            ];
        };
        /**
 * Set the minimum and maximum allowed horizontal fields of view (in degrees).
 * @memberof Viewer
 * @instance
 * @param {number[]} bounds - [minimum hfov, maximum hfov]
 * @returns {Viewer} `this`
 */ this.setHfovBounds = function(bounds) {
            config.minHfov = Math.max(0, bounds[0]);
            config.maxHfov = Math.max(0, bounds[1]);
            return this;
        };
        /**
 * Set a new view. Any parameters not specified remain the same.
 * @memberof Viewer
 * @instance
 * @param {number} [pitch] - Target pitch
 * @param {number} [yaw] - Target yaw
 * @param {number} [hfov] - Target hfov
 * @param {boolean|number} [animated=1000] - Animation duration in milliseconds or false for no animation
 * @param {function} [callback] - Function to call when animation finishes
 * @param {object} [callbackArgs] - Arguments to pass to callback function
 * @returns {Viewer} `this`
 */ this.lookAt = function(pitch, yaw, hfov, animated, callback, callbackArgs) {
            animated = animated == undefined ? 1000 : Number(animated);
            if (pitch !== undefined && Math.abs(pitch - config.pitch) > eps) {
                this.setPitch(pitch, animated, callback, callbackArgs);
                callback = undefined;
            }
            if (yaw !== undefined && Math.abs(yaw - config.yaw) > eps) {
                this.setYaw(yaw, animated, callback, callbackArgs);
                callback = undefined;
            }
            if (hfov !== undefined && Math.abs(hfov - config.hfov) > eps) {
                this.setHfov(hfov, animated, callback, callbackArgs);
                callback = undefined;
            }
            if (typeof callback == "function") callback(callbackArgs);
            return this;
        };
        /**
 * Returns the panorama's north offset.
 * @memberof Viewer
 * @instance
 * @returns {number} North offset in degrees
 */ this.getNorthOffset = function() {
            return config.northOffset;
        };
        /**
 * Sets the panorama's north offset.
 * @memberof Viewer
 * @instance
 * @param {number} heading - North offset in degrees
 * @returns {Viewer} `this`
 */ this.setNorthOffset = function(heading) {
            config.northOffset = Math.min(360, Math.max(0, heading));
            animateInit();
            return this;
        };
        /**
 * Returns the panorama's horizon roll.
 * @memberof Viewer
 * @instance
 * @returns {number} Horizon roll in degrees
 */ this.getHorizonRoll = function() {
            return config.horizonRoll;
        };
        /**
 * Sets the panorama's horizon roll.
 * @memberof Viewer
 * @instance
 * @param {number} roll - Horizon roll in degrees [-90, 90]
 * @returns {Viewer} `this`
 */ this.setHorizonRoll = function(roll) {
            config.horizonRoll = Math.min(90, Math.max(-90, roll));
            renderer.setPose(config.horizonPitch * Math.PI / 180, config.horizonRoll * Math.PI / 180);
            animateInit();
            return this;
        };
        /**
 * Returns the panorama's horizon pitch.
 * @memberof Viewer
 * @instance
 * @returns {number} Horizon pitch in degrees
 */ this.getHorizonPitch = function() {
            return config.horizonPitch;
        };
        /**
 * Sets the panorama's horizon pitch.
 * @memberof Viewer
 * @instance
 * @param {number} pitch - Horizon pitch in degrees [-90, 90]
 * @returns {Viewer} `this`
 */ this.setHorizonPitch = function(pitch) {
            config.horizonPitch = Math.min(90, Math.max(-90, pitch));
            renderer.setPose(config.horizonPitch * Math.PI / 180, config.horizonRoll * Math.PI / 180);
            animateInit();
            return this;
        };
        /**
 * Start auto rotation.
 *
 * Before starting rotation, the viewer is panned to `pitch`.
 * @memberof Viewer
 * @instance
 * @param {number} [speed] - Auto rotation speed / direction. If not specified, previous value is used.
 * @param {number} [pitch] - The pitch to rotate at. If not specified, inital pitch is used.
 * @returns {Viewer} `this`
 */ this.startAutoRotate = function(speed, pitch) {
            speed = speed || autoRotateSpeed || 1;
            pitch = pitch === undefined ? origPitch : pitch;
            config.autoRotate = speed;
            _this.lookAt(pitch, undefined, origHfov, 3000);
            animateInit();
            return this;
        };
        /**
 * Stop auto rotation.
 * @memberof Viewer
 * @instance
 * @returns {Viewer} `this`
 */ this.stopAutoRotate = function() {
            autoRotateSpeed = config.autoRotate ? config.autoRotate : autoRotateSpeed;
            config.autoRotate = false;
            config.autoRotateInactivityDelay = -1;
            return this;
        };
        /**
 * Stops all movement.
 * @memberof Viewer
 * @instance
 */ this.stopMovement = function() {
            stopAnimation();
            speed = {
                "yaw": 0,
                "pitch": 0,
                "hfov": 0
            };
        };
        /**
 * Returns the panorama renderer.
 * @memberof Viewer
 * @instance
 * @returns {Renderer}
 */ this.getRenderer = function() {
            return renderer;
        };
        /**
 * Sets update flag for dynamic content.
 * @memberof Viewer
 * @instance
 * @param {boolean} bool - Whether or not viewer should update even when still
 * @returns {Viewer} `this`
 */ this.setUpdate = function(bool) {
            update = bool === true;
            if (renderer === undefined) onImageLoad();
            else animateInit();
            return this;
        };
        /**
 * Calculate panorama pitch and yaw from location of mouse event.
 * @memberof Viewer
 * @instance
 * @param {MouseEvent} event - Document mouse down event.
 * @returns {number[]} [pitch, yaw]
 */ this.mouseEventToCoords = function(event1) {
            return mouseEventToCoords(event1);
        };
        /**
 * Change scene being viewed.
 * @memberof Viewer
 * @instance
 * @param {string} sceneId - Identifier of scene to switch to.
 * @param {number} [pitch] - Pitch to use with new scene
 * @param {number} [yaw] - Yaw to use with new scene
 * @param {number} [hfov] - HFOV to use with new scene
 * @returns {Viewer} `this`
 */ this.loadScene = function(sceneId, pitch, yaw, hfov) {
            if (loaded !== false) loadScene(sceneId, pitch, yaw, hfov);
            return this;
        };
        /**
 * Get ID of current scene.
 * @memberof Viewer
 * @instance
 * @returns {string} ID of current scene
 */ this.getScene = function() {
            return config.scene;
        };
        /**
 * Add a new scene.
 * @memberof Viewer
 * @instance
 * @param {string} sceneId - The ID of the new scene
 * @param {string} config - The configuration of the new scene
 * @returns {Viewer} `this`
 */ this.addScene = function(sceneId, config) {
            initialConfig.scenes[sceneId] = config;
            return this;
        };
        /**
 * Remove a scene.
 * @memberof Viewer
 * @instance
 * @param {string} sceneId - The ID of the scene
 * @returns {boolean} False if the scene is the current scene or if the scene doesn't exists, else true
 */ this.removeScene = function(sceneId) {
            if (config.scene === sceneId || !initialConfig.scenes.hasOwnProperty(sceneId)) return false;
            delete initialConfig.scenes[sceneId];
            return true;
        };
        /**
 * Toggle fullscreen.
 * @memberof Viewer
 * @instance
 * @returns {Viewer} `this`
 */ this.toggleFullscreen = function() {
            toggleFullscreen();
            return this;
        };
        /**
 * Get configuration of current scene.
 * @memberof Viewer
 * @instance
 * @returns {Object} Configuration of current scene
 */ this.getConfig = function() {
            return config;
        };
        /**
 * Get viewer's container element.
 * @memberof Viewer
 * @instance
 * @returns {HTMLElement} Container `div` element
 */ this.getContainer = function() {
            return container;
        };
        /**
 * Add a new hot spot.
 * @memberof Viewer
 * @instance
 * @param {Object} hs - The configuration for the hot spot
 * @param {string} [sceneId] - Adds hot spot to specified scene if provided, else to current scene
 * @returns {Viewer} `this`
 * @throws Throws an error if the scene ID is provided but invalid
 */ this.addHotSpot = function(hs, sceneId) {
            if (sceneId === undefined && config.scene === undefined) // Not a tour
            config.hotSpots.push(hs);
            else {
                // Tour
                var id = sceneId !== undefined ? sceneId : config.scene;
                if (initialConfig.scenes.hasOwnProperty(id)) {
                    if (!initialConfig.scenes[id].hasOwnProperty("hotSpots")) {
                        initialConfig.scenes[id].hotSpots = []; // Create hot spots array if needed
                        if (id == config.scene) config.hotSpots = initialConfig.scenes[id].hotSpots; // Link to current config
                    }
                    initialConfig.scenes[id].hotSpots.push(hs); // Add hot spot to config
                } else throw "Invalid scene ID!";
            }
            if (sceneId === undefined || config.scene == sceneId) {
                // Add to current scene
                createHotSpot(hs);
                if (loaded) renderHotSpot(hs);
            }
            return this;
        };
        /**
 * Remove a hot spot.
 * @memberof Viewer
 * @instance
 * @param {string} hotSpotId - The ID of the hot spot
 * @param {string} [sceneId] - Removes hot spot from specified scene if provided, else from current scene
 * @returns {boolean} True if deletion is successful, else false
 */ this.removeHotSpot = function(hotSpotId, sceneId) {
            if (sceneId === undefined || config.scene == sceneId) {
                if (!config.hotSpots) return false;
                for(var i = 0; i < config.hotSpots.length; i++)if (config.hotSpots[i].hasOwnProperty("id") && config.hotSpots[i].id === hotSpotId) {
                    // Delete hot spot DOM elements
                    var current = config.hotSpots[i].div;
                    while(current.parentNode != renderContainer)current = current.parentNode;
                    renderContainer.removeChild(current);
                    delete config.hotSpots[i].div;
                    // Remove hot spot from configuration
                    config.hotSpots.splice(i, 1);
                    return true;
                }
            } else {
                if (initialConfig.scenes.hasOwnProperty(sceneId)) {
                    if (!initialConfig.scenes[sceneId].hasOwnProperty("hotSpots")) return false;
                    for(var j = 0; j < initialConfig.scenes[sceneId].hotSpots.length; j++)if (initialConfig.scenes[sceneId].hotSpots[j].hasOwnProperty("id") && initialConfig.scenes[sceneId].hotSpots[j].id === hotSpotId) {
                        // Remove hot spot from configuration
                        initialConfig.scenes[sceneId].hotSpots.splice(j, 1);
                        return true;
                    }
                } else return false;
            }
        };
        /**
 * This method should be called if the viewer's container is resized.
 * @memberof Viewer
 * @instance
 */ this.resize = function() {
            if (renderer) onDocumentResize();
        };
        /**
 * Check if a panorama is loaded.
 * @memberof Viewer
 * @instance
 * @returns {boolean} True if a panorama is loaded, else false
 */ this.isLoaded = function() {
            return loaded;
        };
        /**
 * Check if device orientation control is supported.
 * @memberof Viewer
 * @instance
 * @returns {boolean} True if supported, else false
 */ this.isOrientationSupported = function() {
            return orientationSupport || false;
        };
        /**
 * Stop using device orientation.
 * @memberof Viewer
 * @instance
 */ this.stopOrientation = function() {
            stopOrientation();
        };
        /**
 * Start using device orientation (does nothing if not supported).
 * @memberof Viewer
 * @instance
 */ this.startOrientation = function() {
            if (orientationSupport) startOrientation();
        };
        /**
 * Check if device orientation control is currently activated.
 * @memberof Viewer
 * @instance
 * @returns {boolean} True if active, else false
 */ this.isOrientationActive = function() {
            return Boolean(orientation);
        };
        /**
 * Subscribe listener to specified event.
 * @memberof Viewer
 * @instance
 * @param {string} type - Type of event to subscribe to.
 * @param {Function} listener - Listener function to subscribe to event.
 * @returns {Viewer} `this`
 */ this.on = function(type, listener) {
            externalEventListeners[type] = externalEventListeners[type] || [];
            externalEventListeners[type].push(listener);
            return this;
        };
        /**
 * Remove an event listener (or listeners).
 * @memberof Viewer
 * @param {string} [type] - Type of event to remove listeners from. If not specified, all listeners are removed.
 * @param {Function} [listener] - Listener function to remove. If not specified, all listeners of specified type are removed.
 * @returns {Viewer} `this`
 */ this.off = function(type, listener) {
            if (!type) {
                // Remove all listeners if type isn't specified
                externalEventListeners = {};
                return this;
            }
            if (listener) {
                var i = externalEventListeners[type].indexOf(listener);
                if (i >= 0) // Remove listener if found
                externalEventListeners[type].splice(i, 1);
                if (externalEventListeners[type].length == 0) // Remove category if empty
                delete externalEventListeners[type];
            } else // Remove category of listeners if listener isn't specified
            delete externalEventListeners[type];
            return this;
        };
        /**
 * Fire listeners attached to specified event.
 * @private
 * @param {string} [type] - Type of event to fire listeners for.
 */ function fireEvent(type) {
            if (type in externalEventListeners) // Reverse iteration is useful, if event listener is removed inside its definition
            for(var i = externalEventListeners[type].length; i > 0; i--)externalEventListeners[type][externalEventListeners[type].length - i].apply(null, [].slice.call(arguments, 1));
        }
        /**
 * Destructor.
 * @instance
 * @memberof Viewer
 */ this.destroy = function() {
            destroyed = true;
            clearTimeout(autoRotateStart);
            if (renderer) renderer.destroy();
            if (listenersAdded) {
                document1.removeEventListener("mousemove", onDocumentMouseMove, false);
                document1.removeEventListener("mouseup", onDocumentMouseUp, false);
                container.removeEventListener("mozfullscreenchange", onFullScreenChange, false);
                container.removeEventListener("webkitfullscreenchange", onFullScreenChange, false);
                container.removeEventListener("msfullscreenchange", onFullScreenChange, false);
                container.removeEventListener("fullscreenchange", onFullScreenChange, false);
                window1.removeEventListener("resize", onDocumentResize, false);
                window1.removeEventListener("orientationchange", onDocumentResize, false);
                container.removeEventListener("keydown", onDocumentKeyPress, false);
                container.removeEventListener("keyup", onDocumentKeyUp, false);
                container.removeEventListener("blur", clearKeys, false);
                document1.removeEventListener("mouseleave", onDocumentMouseUp, false);
            }
            container.innerHTML = "";
            container.classList.remove("pnlm-container");
        };
    }
    return {
        viewer: function(container, config) {
            return new Viewer(container, config);
        }
    };
}(window, document);


/*
 * libpannellum - A WebGL and CSS 3D transform based Panorama Renderer
 * Copyright (c) 2012-2019 Matthew Petroff
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ window.libpannellum = function(window1, document1, undefined) {
    "use strict";
    /**
 * Creates a new panorama renderer.
 * @constructor
 * @param {HTMLElement} container - The container element for the renderer.
 */ function Renderer(container) {
        var canvas = document1.createElement("canvas");
        canvas.style.width = canvas.style.height = "100%";
        container.appendChild(canvas);
        var program, gl, vs, fs;
        var fallbackImgSize;
        var world;
        var vtmps;
        var pose;
        var image, imageType, dynamic;
        var texCoordBuffer, cubeVertBuf, cubeVertTexCoordBuf, cubeVertIndBuf;
        var globalParams;
        /**
     * Initialize renderer.
     * @memberof Renderer
     * @instance
     * @param {Image|Array|Object} image - Input image; format varies based on
     *      `imageType`. For `equirectangular`, this is an image; for
     *      `cubemap`, this is an array of images for the cube faces in the
     *      order [+z, +x, -z, -x, +y, -y]; for `multires`, this is a
     *      configuration object.
     * @param {string} imageType - The type of the image: `equirectangular`,
     *      `cubemap`, or `multires`.
     * @param {boolean} dynamic - Whether or not the image is dynamic (e.g. video).
     * @param {number} haov - Initial horizontal angle of view.
     * @param {number} vaov - Initial vertical angle of view.
     * @param {number} voffset - Initial vertical offset angle.
     * @param {function} callback - Load callback function.
     * @param {Object} [params] - Other configuration parameters (`horizonPitch`, `horizonRoll`, `backgroundColor`).
     */ this.init = function(_image, _imageType, _dynamic, haov, vaov, voffset, callback, params) {
            // Default argument for image type
            if (_imageType === undefined) _imageType = "equirectangular";
            if (_imageType != "equirectangular" && _imageType != "cubemap" && _imageType != "multires") {
                console.log("Error: invalid image type specified!");
                throw {
                    type: "config error"
                };
            }
            imageType = _imageType;
            image = _image;
            dynamic = _dynamic;
            globalParams = params || {};
            // Clear old data
            if (program) {
                if (vs) {
                    gl.detachShader(program, vs);
                    gl.deleteShader(vs);
                }
                if (fs) {
                    gl.detachShader(program, fs);
                    gl.deleteShader(fs);
                }
                gl.bindBuffer(gl.ARRAY_BUFFER, null);
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
                if (program.texture) gl.deleteTexture(program.texture);
                if (program.nodeCache) for(var i = 0; i < program.nodeCache.length; i++)gl.deleteTexture(program.nodeCache[i].texture);
                gl.deleteProgram(program);
                program = undefined;
            }
            pose = undefined;
            var s;
            var faceMissing = false;
            var cubeImgWidth;
            if (imageType == "cubemap") {
                for(s = 0; s < 6; s++)if (image[s].width > 0) {
                    if (cubeImgWidth === undefined) cubeImgWidth = image[s].width;
                    if (cubeImgWidth != image[s].width) console.log("Cube faces have inconsistent widths: " + cubeImgWidth + " vs. " + image[s].width);
                } else faceMissing = true;
            }
            function fillMissingFaces(imgSize) {
                if (faceMissing) {
                    var nbytes = imgSize * imgSize * 4; // RGB, plus non-functional alpha
                    var imageArray = new Uint8ClampedArray(nbytes);
                    var rgb = params.backgroundColor ? params.backgroundColor : [
                        0,
                        0,
                        0
                    ];
                    rgb[0] *= 255;
                    rgb[1] *= 255;
                    rgb[2] *= 255;
                    // Maybe filling could be done faster, see e.g. https://stackoverflow.com/questions/1295584/most-efficient-way-to-create-a-zero-filled-javascript-array
                    for(var i = 0; i < nbytes; i++){
                        imageArray[i++] = rgb[0];
                        imageArray[i++] = rgb[1];
                        imageArray[i++] = rgb[2];
                    }
                    var backgroundSquare = new ImageData(imageArray, imgSize, imgSize);
                    for(s = 0; s < 6; s++)if (image[s].width == 0) image[s] = backgroundSquare;
                }
            }
            // This awful browser specific test exists because iOS 8/9 and IE 11
            // don't display non-power-of-two cubemap textures but also don't
            // throw an error (tested on an iPhone 5c / iOS 8.1.3 / iOS 9.2 /
            // iOS 10.3.1).
            // Therefore, the WebGL context is never created for these browsers for
            // NPOT cubemaps, and the CSS 3D transform fallback renderer is used
            // instead.
            if (!(imageType == "cubemap" && (cubeImgWidth & cubeImgWidth - 1) !== 0 && (navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 8_/) || navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 9_/) || navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 10_/) || navigator.userAgent.match(/Trident.*rv[ :]*11\./)))) {
                // Enable WebGL on canvas
                if (!gl) gl = canvas.getContext("experimental-webgl", {
                    alpha: false,
                    depth: false
                });
                if (gl && gl.getError() == 1286) handleWebGLError1286();
            }
            // If there is no WebGL, fall back to CSS 3D transform renderer.
            // This will discard the image loaded so far and load the fallback image.
            // While browser specific tests are usually frowned upon, the
            // fallback viewer only really works with WebKit/Blink and IE 10/11
            // (it doesn't work properly in Firefox).
            if (!gl && (imageType == "multires" && image.hasOwnProperty("fallbackPath") || imageType == "cubemap") && ("WebkitAppearance" in document1.documentElement.style || navigator.userAgent.match(/Trident.*rv[ :]*11\./) || navigator.appVersion.indexOf("MSIE 10") !== -1)) {
                // Remove old world if it exists
                if (world) container.removeChild(world);
                // Initialize renderer
                world = document1.createElement("div");
                world.className = "pnlm-world";
                // Add images
                var path;
                if (image.basePath) path = image.basePath + image.fallbackPath;
                else path = image.fallbackPath;
                var sides = [
                    "f",
                    "r",
                    "b",
                    "l",
                    "u",
                    "d"
                ];
                var loaded = 0;
                var onLoad = function() {
                    // Draw image on canvas
                    var faceCanvas = document1.createElement("canvas");
                    faceCanvas.className = "pnlm-face pnlm-" + sides[this.side] + "face";
                    world.appendChild(faceCanvas);
                    var faceContext = faceCanvas.getContext("2d");
                    faceCanvas.style.width = this.width + 4 + "px";
                    faceCanvas.style.height = this.height + 4 + "px";
                    faceCanvas.width = this.width + 4;
                    faceCanvas.height = this.height + 4;
                    faceContext.drawImage(this, 2, 2);
                    var imgData = faceContext.getImageData(0, 0, faceCanvas.width, faceCanvas.height);
                    var data = imgData.data;
                    // Duplicate edge pixels
                    var i;
                    var j;
                    for(i = 2; i < faceCanvas.width - 2; i++)for(j = 0; j < 4; j++){
                        data[(i + faceCanvas.width) * 4 + j] = data[(i + faceCanvas.width * 2) * 4 + j];
                        data[(i + faceCanvas.width * (faceCanvas.height - 2)) * 4 + j] = data[(i + faceCanvas.width * (faceCanvas.height - 3)) * 4 + j];
                    }
                    for(i = 2; i < faceCanvas.height - 2; i++)for(j = 0; j < 4; j++){
                        data[(i * faceCanvas.width + 1) * 4 + j] = data[(i * faceCanvas.width + 2) * 4 + j];
                        data[((i + 1) * faceCanvas.width - 2) * 4 + j] = data[((i + 1) * faceCanvas.width - 3) * 4 + j];
                    }
                    for(j = 0; j < 4; j++){
                        data[(faceCanvas.width + 1) * 4 + j] = data[(faceCanvas.width * 2 + 2) * 4 + j];
                        data[(faceCanvas.width * 2 - 2) * 4 + j] = data[(faceCanvas.width * 3 - 3) * 4 + j];
                        data[(faceCanvas.width * (faceCanvas.height - 2) + 1) * 4 + j] = data[(faceCanvas.width * (faceCanvas.height - 3) + 2) * 4 + j];
                        data[(faceCanvas.width * (faceCanvas.height - 1) - 2) * 4 + j] = data[(faceCanvas.width * (faceCanvas.height - 2) - 3) * 4 + j];
                    }
                    for(i = 1; i < faceCanvas.width - 1; i++)for(j = 0; j < 4; j++){
                        data[i * 4 + j] = data[(i + faceCanvas.width) * 4 + j];
                        data[(i + faceCanvas.width * (faceCanvas.height - 1)) * 4 + j] = data[(i + faceCanvas.width * (faceCanvas.height - 2)) * 4 + j];
                    }
                    for(i = 1; i < faceCanvas.height - 1; i++)for(j = 0; j < 4; j++){
                        data[i * faceCanvas.width * 4 + j] = data[(i * faceCanvas.width + 1) * 4 + j];
                        data[((i + 1) * faceCanvas.width - 1) * 4 + j] = data[((i + 1) * faceCanvas.width - 2) * 4 + j];
                    }
                    for(j = 0; j < 4; j++){
                        data[j] = data[(faceCanvas.width + 1) * 4 + j];
                        data[(faceCanvas.width - 1) * 4 + j] = data[(faceCanvas.width * 2 - 2) * 4 + j];
                        data[faceCanvas.width * (faceCanvas.height - 1) * 4 + j] = data[(faceCanvas.width * (faceCanvas.height - 2) + 1) * 4 + j];
                        data[(faceCanvas.width * faceCanvas.height - 1) * 4 + j] = data[(faceCanvas.width * (faceCanvas.height - 1) - 2) * 4 + j];
                    }
                    // Draw image width duplicated edge pixels on canvas
                    faceContext.putImageData(imgData, 0, 0);
                    incLoaded.call(this);
                };
                var incLoaded = function() {
                    if (this.width > 0) {
                        if (fallbackImgSize === undefined) fallbackImgSize = this.width;
                        if (fallbackImgSize != this.width) console.log("Fallback faces have inconsistent widths: " + fallbackImgSize + " vs. " + this.width);
                    } else faceMissing = true;
                    loaded++;
                    if (loaded == 6) {
                        fallbackImgSize = this.width;
                        container.appendChild(world);
                        callback();
                    }
                };
                faceMissing = false;
                for(s = 0; s < 6; s++){
                    var faceImg = new Image();
                    faceImg.crossOrigin = globalParams.crossOrigin ? globalParams.crossOrigin : "anonymous";
                    faceImg.side = s;
                    faceImg.onload = onLoad;
                    faceImg.onerror = incLoaded; // ignore missing face to support partial fallback image
                    if (imageType == "multires") faceImg.src = path.replace("%s", sides[s]) + "." + image.extension;
                    else faceImg.src = image[s].src;
                }
                fillMissingFaces(fallbackImgSize);
                return;
            } else if (!gl) {
                console.log("Error: no WebGL support detected!");
                throw {
                    type: "no webgl"
                };
            }
            if (imageType == "cubemap") fillMissingFaces(cubeImgWidth);
            if (image.basePath) image.fullpath = image.basePath + image.path;
            else image.fullpath = image.path;
            image.invTileResolution = 1 / image.tileResolution;
            var vertices = createCube();
            vtmps = [];
            for(s = 0; s < 6; s++){
                vtmps[s] = vertices.slice(s * 12, s * 12 + 12);
                vertices = createCube();
            }
            // Make sure image isn't too big
            var maxWidth = 0;
            if (imageType == "equirectangular") {
                maxWidth = gl.getParameter(gl.MAX_TEXTURE_SIZE);
                if (Math.max(image.width / 2, image.height) > maxWidth) {
                    console.log("Error: The image is too big; it's " + image.width + "px wide, " + "but this device's maximum supported size is " + maxWidth * 2 + "px.");
                    throw {
                        type: "webgl size error",
                        width: image.width,
                        maxWidth: maxWidth * 2
                    };
                }
            } else if (imageType == "cubemap") {
                if (cubeImgWidth > gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE)) {
                    console.log("Error: The image is too big; it's " + cubeImgWidth + "px wide, " + "but this device's maximum supported size is " + maxWidth + "px.");
                    throw {
                        type: "webgl size error",
                        width: cubeImgWidth,
                        maxWidth: maxWidth
                    };
                }
            }
            // Store horizon pitch and roll if applicable
            if (params !== undefined && (params.horizonPitch !== undefined || params.horizonRoll !== undefined)) pose = [
                params.horizonPitch == undefined ? 0 : params.horizonPitch,
                params.horizonRoll == undefined ? 0 : params.horizonRoll
            ];
            // Set 2d texture binding
            var glBindType = gl.TEXTURE_2D;
            // Create viewport for entire canvas
            gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
            // Check precision support
            if (gl.getShaderPrecisionFormat) {
                var precision = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                if (precision && precision.precision < 1) // `highp` precision not supported; https://stackoverflow.com/a/33308927
                fragEquiCubeBase = fragEquiCubeBase.replace("highp", "mediump");
            }
            // Create vertex shader
            vs = gl.createShader(gl.VERTEX_SHADER);
            var vertexSrc = v;
            if (imageType == "multires") vertexSrc = vMulti;
            gl.shaderSource(vs, vertexSrc);
            gl.compileShader(vs);
            // Create fragment shader
            fs = gl.createShader(gl.FRAGMENT_SHADER);
            var fragmentSrc = fragEquirectangular;
            if (imageType == "cubemap") {
                glBindType = gl.TEXTURE_CUBE_MAP;
                fragmentSrc = fragCube;
            } else if (imageType == "multires") fragmentSrc = fragMulti;
            gl.shaderSource(fs, fragmentSrc);
            gl.compileShader(fs);
            // Link WebGL program
            program = gl.createProgram();
            gl.attachShader(program, vs);
            gl.attachShader(program, fs);
            gl.linkProgram(program);
            // Log errors
            if (!gl.getShaderParameter(vs, gl.COMPILE_STATUS)) console.log(gl.getShaderInfoLog(vs));
            if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS)) console.log(gl.getShaderInfoLog(fs));
            if (!gl.getProgramParameter(program, gl.LINK_STATUS)) console.log(gl.getProgramInfoLog(program));
            // Use WebGL program
            gl.useProgram(program);
            program.drawInProgress = false;
            // Set background clear color (does not apply to cubemap/fallback image)
            var color = params.backgroundColor ? params.backgroundColor : [
                0,
                0,
                0
            ];
            gl.clearColor(color[0], color[1], color[2], 1.0);
            gl.clear(gl.COLOR_BUFFER_BIT);
            // Look up texture coordinates location
            program.texCoordLocation = gl.getAttribLocation(program, "a_texCoord");
            gl.enableVertexAttribArray(program.texCoordLocation);
            if (imageType != "multires") {
                // Provide texture coordinates for rectangle
                if (!texCoordBuffer) texCoordBuffer = gl.createBuffer();
                gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
                gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
                    -1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ]), gl.STATIC_DRAW);
                gl.vertexAttribPointer(program.texCoordLocation, 2, gl.FLOAT, false, 0, 0);
                // Pass aspect ratio
                program.aspectRatio = gl.getUniformLocation(program, "u_aspectRatio");
                gl.uniform1f(program.aspectRatio, gl.drawingBufferWidth / gl.drawingBufferHeight);
                // Locate psi, theta, focal length, horizontal extent, vertical extent, and vertical offset
                program.psi = gl.getUniformLocation(program, "u_psi");
                program.theta = gl.getUniformLocation(program, "u_theta");
                program.f = gl.getUniformLocation(program, "u_f");
                program.h = gl.getUniformLocation(program, "u_h");
                program.v = gl.getUniformLocation(program, "u_v");
                program.vo = gl.getUniformLocation(program, "u_vo");
                program.rot = gl.getUniformLocation(program, "u_rot");
                // Pass horizontal extent, vertical extent, and vertical offset
                gl.uniform1f(program.h, haov / (Math.PI * 2.0));
                gl.uniform1f(program.v, vaov / Math.PI);
                gl.uniform1f(program.vo, voffset / Math.PI * 2);
                // Set background color
                if (imageType == "equirectangular") {
                    program.backgroundColor = gl.getUniformLocation(program, "u_backgroundColor");
                    gl.uniform4fv(program.backgroundColor, color.concat([
                        1
                    ]));
                }
                // Create texture
                program.texture = gl.createTexture();
                gl.bindTexture(glBindType, program.texture);
                // Upload images to texture depending on type
                if (imageType == "cubemap") {
                    // Load all six sides of the cube map
                    gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[1]);
                    gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_X, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[3]);
                    gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_Y, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[4]);
                    gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_Y, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[5]);
                    gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_Z, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[0]);
                    gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_Z, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image[2]);
                } else if (image.width <= maxWidth) {
                    gl.uniform1i(gl.getUniformLocation(program, "u_splitImage"), 0);
                    // Upload image to the texture
                    gl.texImage2D(glBindType, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image);
                } else {
                    // Image needs to be split into two parts due to texture size limits
                    gl.uniform1i(gl.getUniformLocation(program, "u_splitImage"), 1);
                    // Draw image on canvas
                    var cropCanvas = document1.createElement("canvas");
                    cropCanvas.width = image.width / 2;
                    cropCanvas.height = image.height;
                    var cropContext = cropCanvas.getContext("2d");
                    cropContext.drawImage(image, 0, 0);
                    // Upload first half of image to the texture
                    var cropImage = cropContext.getImageData(0, 0, image.width / 2, image.height);
                    gl.texImage2D(glBindType, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, cropImage);
                    // Create and bind texture for second half of image
                    program.texture2 = gl.createTexture();
                    gl.activeTexture(gl.TEXTURE1);
                    gl.bindTexture(glBindType, program.texture2);
                    gl.uniform1i(gl.getUniformLocation(program, "u_image1"), 1);
                    // Upload second half of image to the texture
                    cropContext.drawImage(image, -image.width / 2, 0);
                    cropImage = cropContext.getImageData(0, 0, image.width / 2, image.height);
                    gl.texImage2D(glBindType, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, cropImage);
                    // Set parameters for rendering any size
                    gl.texParameteri(glBindType, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    gl.texParameteri(glBindType, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    gl.texParameteri(glBindType, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                    gl.texParameteri(glBindType, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                    // Reactivate first texture unit
                    gl.activeTexture(gl.TEXTURE0);
                }
                // Set parameters for rendering any size
                gl.texParameteri(glBindType, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(glBindType, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                gl.texParameteri(glBindType, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                gl.texParameteri(glBindType, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            } else {
                // Look up vertex coordinates location
                program.vertPosLocation = gl.getAttribLocation(program, "a_vertCoord");
                gl.enableVertexAttribArray(program.vertPosLocation);
                // Create buffers
                if (!cubeVertBuf) cubeVertBuf = gl.createBuffer();
                if (!cubeVertTexCoordBuf) cubeVertTexCoordBuf = gl.createBuffer();
                if (!cubeVertIndBuf) cubeVertIndBuf = gl.createBuffer();
                // Bind texture coordinate buffer and pass coordinates to WebGL
                gl.bindBuffer(gl.ARRAY_BUFFER, cubeVertTexCoordBuf);
                gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    1
                ]), gl.STATIC_DRAW);
                // Bind square index buffer and pass indicies to WebGL
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, cubeVertIndBuf);
                gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array([
                    0,
                    1,
                    2,
                    0,
                    2,
                    3
                ]), gl.STATIC_DRAW);
                // Find uniforms
                program.perspUniform = gl.getUniformLocation(program, "u_perspMatrix");
                program.cubeUniform = gl.getUniformLocation(program, "u_cubeMatrix");
                //program.colorUniform = gl.getUniformLocation(program, 'u_color');
                program.level = -1;
                program.currentNodes = [];
                program.nodeCache = [];
                program.nodeCacheTimestamp = 0;
            }
            // Check if there was an error
            var err = gl.getError();
            if (err !== 0) {
                console.log("Error: Something went wrong with WebGL!", err);
                throw {
                    type: "webgl error"
                };
            }
            callback();
        };
        /**
     * Destroy renderer.
     * @memberof Renderer
     * @instance
     */ this.destroy = function() {
            if (container !== undefined) {
                if (canvas !== undefined && container.contains(canvas)) container.removeChild(canvas);
                if (world !== undefined && container.contains(world)) container.removeChild(world);
            }
            if (gl) {
                // The spec says this is only supposed to simulate losing the WebGL
                // context, but in practice it tends to actually free the memory.
                var extension = gl.getExtension("WEBGL_lose_context");
                if (extension) extension.loseContext();
            }
        };
        /**
     * Resize renderer (call after resizing container).
     * @memberof Renderer
     * @instance
     */ this.resize = function() {
            var pixelRatio = window1.devicePixelRatio || 1;
            canvas.width = canvas.clientWidth * pixelRatio;
            canvas.height = canvas.clientHeight * pixelRatio;
            if (gl) {
                if (gl.getError() == 1286) handleWebGLError1286();
                gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
                if (imageType != "multires") gl.uniform1f(program.aspectRatio, canvas.clientWidth / canvas.clientHeight);
            }
        };
        // Initialize canvas size
        this.resize();
        /**
     * Set renderer horizon pitch and roll.
     * @memberof Renderer
     * @instance
     */ this.setPose = function(horizonPitch, horizonRoll) {
            pose = [
                horizonPitch,
                horizonRoll
            ];
        };
        /**
     * Render new view of panorama.
     * @memberof Renderer
     * @instance
     * @param {number} pitch - Pitch to render at (in radians).
     * @param {number} yaw - Yaw to render at (in radians).
     * @param {number} hfov - Horizontal field of view to render with (in radians).
     * @param {Object} [params] - Extra configuration parameters. 
     * @param {number} [params.roll] - Camera roll (in radians).
     * @param {boolean} [params.returnImage] - Return rendered image?
     */ this.render = function(pitch, yaw, hfov, params) {
            var focal, i, s, roll = 0;
            if (params === undefined) params = {};
            if (params.roll) roll = params.roll;
            // Apply pitch and roll transformation if applicable
            if (pose !== undefined) {
                var horizonPitch = pose[0], horizonRoll = pose[1];
                // Calculate new pitch and yaw
                var orig_pitch = pitch, orig_yaw = yaw, x = Math.cos(horizonRoll) * Math.sin(pitch) * Math.sin(horizonPitch) + Math.cos(pitch) * (Math.cos(horizonPitch) * Math.cos(yaw) + Math.sin(horizonRoll) * Math.sin(horizonPitch) * Math.sin(yaw)), y = -Math.sin(pitch) * Math.sin(horizonRoll) + Math.cos(pitch) * Math.cos(horizonRoll) * Math.sin(yaw), z = Math.cos(horizonRoll) * Math.cos(horizonPitch) * Math.sin(pitch) + Math.cos(pitch) * (-Math.cos(yaw) * Math.sin(horizonPitch) + Math.cos(horizonPitch) * Math.sin(horizonRoll) * Math.sin(yaw));
                pitch = Math.asin(Math.max(Math.min(z, 1), -1));
                yaw = Math.atan2(y, x);
                // Calculate roll
                var v = [
                    Math.cos(orig_pitch) * (Math.sin(horizonRoll) * Math.sin(horizonPitch) * Math.cos(orig_yaw) - Math.cos(horizonPitch) * Math.sin(orig_yaw)),
                    Math.cos(orig_pitch) * Math.cos(horizonRoll) * Math.cos(orig_yaw),
                    Math.cos(orig_pitch) * (Math.cos(horizonPitch) * Math.sin(horizonRoll) * Math.cos(orig_yaw) + Math.sin(orig_yaw) * Math.sin(horizonPitch))
                ], w = [
                    -Math.cos(pitch) * Math.sin(yaw),
                    Math.cos(pitch) * Math.cos(yaw)
                ];
                var roll_adj = Math.acos(Math.max(Math.min((v[0] * w[0] + v[1] * w[1]) / (Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]) * Math.sqrt(w[0] * w[0] + w[1] * w[1])), 1), -1));
                if (v[2] < 0) roll_adj = 2 * Math.PI - roll_adj;
                roll += roll_adj;
            }
            // If no WebGL
            if (!gl && (imageType == "multires" || imageType == "cubemap")) {
                // Determine face transforms
                s = fallbackImgSize / 2;
                var transforms = {
                    f: "translate3d(-" + (s + 2) + "px, -" + (s + 2) + "px, -" + s + "px)",
                    b: "translate3d(" + (s + 2) + "px, -" + (s + 2) + "px, " + s + "px) rotateX(180deg) rotateZ(180deg)",
                    u: "translate3d(-" + (s + 2) + "px, -" + s + "px, " + (s + 2) + "px) rotateX(270deg)",
                    d: "translate3d(-" + (s + 2) + "px, " + s + "px, -" + (s + 2) + "px) rotateX(90deg)",
                    l: "translate3d(-" + s + "px, -" + (s + 2) + "px, " + (s + 2) + "px) rotateX(180deg) rotateY(90deg) rotateZ(180deg)",
                    r: "translate3d(" + s + "px, -" + (s + 2) + "px, -" + (s + 2) + "px) rotateY(270deg)"
                };
                focal = 1 / Math.tan(hfov / 2);
                var zoom = focal * canvas.clientWidth / 2 + "px";
                var transform = "perspective(" + zoom + ") translateZ(" + zoom + ") rotateX(" + pitch + "rad) rotateY(" + yaw + "rad) ";
                // Apply face transforms
                var faces = Object.keys(transforms);
                for(i = 0; i < 6; i++){
                    var face = world.querySelector(".pnlm-" + faces[i] + "face");
                    if (!face) continue; // ignore missing face to support partial cubemap/fallback image
                    face.style.webkitTransform = transform + transforms[faces[i]];
                    face.style.transform = transform + transforms[faces[i]];
                }
                return;
            }
            if (imageType != "multires") {
                // Calculate focal length from vertical field of view
                var vfov = 2 * Math.atan(Math.tan(hfov * 0.5) / (gl.drawingBufferWidth / gl.drawingBufferHeight));
                focal = 1 / Math.tan(vfov * 0.5);
                // Pass psi, theta, roll, and focal length
                gl.uniform1f(program.psi, yaw);
                gl.uniform1f(program.theta, pitch);
                gl.uniform1f(program.rot, roll);
                gl.uniform1f(program.f, focal);
                if (dynamic === true) // Update texture if dynamic
                {
                    if (imageType == "equirectangular") {
                        gl.bindTexture(gl.TEXTURE_2D, program.texture);
                        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, image);
                    }
                }
                // Draw using current buffer
                gl.drawArrays(gl.TRIANGLES, 0, 6);
            } else {
                // Create perspective matrix
                var perspMatrix = makePersp(hfov, gl.drawingBufferWidth / gl.drawingBufferHeight, 0.1, 100.0);
                // Find correct zoom level
                checkZoom(hfov);
                // Create rotation matrix
                var matrix = identityMatrix3();
                matrix = rotateMatrix(matrix, -roll, "z");
                matrix = rotateMatrix(matrix, -pitch, "x");
                matrix = rotateMatrix(matrix, yaw, "y");
                matrix = makeMatrix4(matrix);
                // Set matrix uniforms
                gl.uniformMatrix4fv(program.perspUniform, false, new Float32Array(transposeMatrix4(perspMatrix)));
                gl.uniformMatrix4fv(program.cubeUniform, false, new Float32Array(transposeMatrix4(matrix)));
                // Find current nodes
                var rotPersp = rotatePersp(perspMatrix, matrix);
                program.nodeCache.sort(multiresNodeSort);
                if (program.nodeCache.length > 200 && program.nodeCache.length > program.currentNodes.length + 50) {
                    // Remove older nodes from cache
                    var removed = program.nodeCache.splice(200, program.nodeCache.length - 200);
                    for(var j = 0; j < removed.length; j++)// Explicitly delete textures
                    gl.deleteTexture(removed[j].texture);
                }
                program.currentNodes = [];
                var sides = [
                    "f",
                    "b",
                    "u",
                    "d",
                    "l",
                    "r"
                ];
                for(s = 0; s < 6; s++){
                    var ntmp = new MultiresNode(vtmps[s], sides[s], 1, 0, 0, image.fullpath);
                    testMultiresNode(rotPersp, ntmp, pitch, yaw, hfov);
                }
                program.currentNodes.sort(multiresNodeRenderSort);
                // Unqueue any pending requests for nodes that are no longer visible
                for(i = pendingTextureRequests.length - 1; i >= 0; i--)if (program.currentNodes.indexOf(pendingTextureRequests[i].node) === -1) {
                    pendingTextureRequests[i].node.textureLoad = false;
                    pendingTextureRequests.splice(i, 1);
                }
                // Allow one request to be pending, so that we can create a texture buffer for that in advance of loading actually beginning
                if (pendingTextureRequests.length === 0) for(i = 0; i < program.currentNodes.length; i++){
                    var node = program.currentNodes[i];
                    if (!node.texture && !node.textureLoad) {
                        node.textureLoad = true;
                        setTimeout(processNextTile, 0, node);
                        break;
                    }
                }
                // Draw tiles
                multiresDraw();
            }
            if (params.returnImage !== undefined) return canvas.toDataURL("image/png");
        };
        /**
     * Check if images are loading.
     * @memberof Renderer
     * @instance
     * @returns {boolean} Whether or not images are loading.
     */ this.isLoading = function() {
            if (gl && imageType == "multires") for(var i = 0; i < program.currentNodes.length; i++){
                if (!program.currentNodes[i].textureLoaded) return true;
            }
            return false;
        };
        /**
     * Retrieve renderer's canvas.
     * @memberof Renderer
     * @instance
     * @returns {HTMLElement} Renderer's canvas.
     */ this.getCanvas = function() {
            return canvas;
        };
        /**
     * Sorting method for multires nodes.
     * @private
     * @param {MultiresNode} a - First node.
     * @param {MultiresNode} b - Second node.
     * @returns {number} Base tiles first, then higher timestamp first.
     */ function multiresNodeSort(a, b) {
            // Base tiles are always first
            if (a.level == 1 && b.level != 1) return -1;
            if (b.level == 1 && a.level != 1) return 1;
            // Higher timestamp first
            return b.timestamp - a.timestamp;
        }
        /**
     * Sorting method for multires node rendering.
     * @private
     * @param {MultiresNode} a - First node.
     * @param {MultiresNode} b - Second node.
     * @returns {number} Lower zoom levels first, then closest to center first.
     */ function multiresNodeRenderSort(a, b) {
            // Lower zoom levels first
            if (a.level != b.level) return a.level - b.level;
            // Lower distance from center first
            return a.diff - b.diff;
        }
        /**
     * Draws multires nodes.
     * @private
     */ function multiresDraw() {
            if (!program.drawInProgress) {
                program.drawInProgress = true;
                gl.clear(gl.COLOR_BUFFER_BIT);
                for(var i = 0; i < program.currentNodes.length; i++)if (program.currentNodes[i].textureLoaded > 1) {
                    //var color = program.currentNodes[i].color;
                    //gl.uniform4f(program.colorUniform, color[0], color[1], color[2], 1.0);
                    // Bind vertex buffer and pass vertices to WebGL
                    gl.bindBuffer(gl.ARRAY_BUFFER, cubeVertBuf);
                    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(program.currentNodes[i].vertices), gl.STATIC_DRAW);
                    gl.vertexAttribPointer(program.vertPosLocation, 3, gl.FLOAT, false, 0, 0);
                    // Prep for texture
                    gl.bindBuffer(gl.ARRAY_BUFFER, cubeVertTexCoordBuf);
                    gl.vertexAttribPointer(program.texCoordLocation, 2, gl.FLOAT, false, 0, 0);
                    // Bind texture and draw tile
                    gl.bindTexture(gl.TEXTURE_2D, program.currentNodes[i].texture); // Bind program.currentNodes[i].texture to TEXTURE0
                    gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
                }
                program.drawInProgress = false;
            }
        }
        /**
     * Creates new multires node.
     * @constructor
     * @private
     * @param {number[]} vertices - Node's verticies.
     * @param {string} side - Node's cube face.
     * @param {number} level - Node's zoom level.
     * @param {number} x - Node's x position.
     * @param {number} y - Node's y position.
     * @param {string} path - Node's path.
     */ function MultiresNode(vertices, side, level, x, y, path) {
            this.vertices = vertices;
            this.side = side;
            this.level = level;
            this.x = x;
            this.y = y;
            this.path = path.replace("%s", side).replace("%l", level).replace("%x", x).replace("%y", y);
        }
        /**
     * Test if multires node is visible. If it is, add it to current nodes,
     * load its texture, and load appropriate child nodes.
     * @private
     * @param {number[]} rotPersp - Rotated perspective matrix.
     * @param {MultiresNode} node - Multires node to check.
     * @param {number} pitch - Pitch to check at.
     * @param {number} yaw - Yaw to check at.
     * @param {number} hfov - Horizontal field of view to check at.
     */ function testMultiresNode(rotPersp, node, pitch, yaw, hfov) {
            if (checkSquareInView(rotPersp, node.vertices)) {
                // Calculate central angle between center of view and center of tile
                var v = node.vertices;
                var x = v[0] + v[3] + v[6] + v[9];
                var y = v[1] + v[4] + v[7] + v[10];
                var z = v[2] + v[5] + v[8] + v[11];
                var r = Math.sqrt(x * x + y * y + z * z);
                var theta = Math.asin(z / r);
                var phi = Math.atan2(y, x);
                var ydiff = phi - yaw;
                ydiff += ydiff > Math.PI ? -2 * Math.PI : ydiff < -Math.PI ? 2 * Math.PI : 0;
                ydiff = Math.abs(ydiff);
                node.diff = Math.acos(Math.sin(pitch) * Math.sin(theta) + Math.cos(pitch) * Math.cos(theta) * Math.cos(ydiff));
                // Add node to current nodes and load texture if needed
                var inCurrent = false;
                for(var k = 0; k < program.nodeCache.length; k++)if (program.nodeCache[k].path == node.path) {
                    inCurrent = true;
                    program.nodeCache[k].timestamp = program.nodeCacheTimestamp++;
                    program.nodeCache[k].diff = node.diff;
                    program.currentNodes.push(program.nodeCache[k]);
                    break;
                }
                if (!inCurrent) {
                    //node.color = [Math.random(), Math.random(), Math.random()];
                    node.timestamp = program.nodeCacheTimestamp++;
                    program.currentNodes.push(node);
                    program.nodeCache.push(node);
                }
                // TODO: Test error
                // Create child nodes
                if (node.level < program.level) {
                    var cubeSize = image.cubeResolution * Math.pow(2, node.level - image.maxLevel);
                    var numTiles = Math.ceil(cubeSize * image.invTileResolution) - 1;
                    var doubleTileSize = cubeSize % image.tileResolution * 2;
                    var lastTileSize = cubeSize * 2 % image.tileResolution;
                    if (lastTileSize === 0) lastTileSize = image.tileResolution;
                    if (doubleTileSize === 0) doubleTileSize = image.tileResolution * 2;
                    var f = 0.5;
                    if (node.x == numTiles || node.y == numTiles) f = 1.0 - image.tileResolution / (image.tileResolution + lastTileSize);
                    var i = 1.0 - f;
                    var children = [];
                    var vtmp, ntmp;
                    var f1 = f, f2 = f, f3 = f, i1 = i, i2 = i, i3 = i;
                    // Handle non-symmetric tiles
                    if (lastTileSize < image.tileResolution) {
                        if (node.x == numTiles && node.y != numTiles) {
                            f2 = 0.5;
                            i2 = 0.5;
                            if (node.side == "d" || node.side == "u") {
                                f3 = 0.5;
                                i3 = 0.5;
                            }
                        } else if (node.x != numTiles && node.y == numTiles) {
                            f1 = 0.5;
                            i1 = 0.5;
                            if (node.side == "l" || node.side == "r") {
                                f3 = 0.5;
                                i3 = 0.5;
                            }
                        }
                    }
                    // Handle small tiles that have fewer than four children
                    if (doubleTileSize <= image.tileResolution) {
                        if (node.x == numTiles) {
                            f1 = 0;
                            i1 = 1;
                            if (node.side == "l" || node.side == "r") {
                                f3 = 0;
                                i3 = 1;
                            }
                        }
                        if (node.y == numTiles) {
                            f2 = 0;
                            i2 = 1;
                            if (node.side == "d" || node.side == "u") {
                                f3 = 0;
                                i3 = 1;
                            }
                        }
                    }
                    vtmp = [
                        v[0],
                        v[1],
                        v[2],
                        v[0] * f1 + v[3] * i1,
                        v[1] * f + v[4] * i,
                        v[2] * f3 + v[5] * i3,
                        v[0] * f1 + v[6] * i1,
                        v[1] * f2 + v[7] * i2,
                        v[2] * f3 + v[8] * i3,
                        v[0] * f + v[9] * i,
                        v[1] * f2 + v[10] * i2,
                        v[2] * f3 + v[11] * i3
                    ];
                    ntmp = new MultiresNode(vtmp, node.side, node.level + 1, node.x * 2, node.y * 2, image.fullpath);
                    children.push(ntmp);
                    if (!(node.x == numTiles && doubleTileSize <= image.tileResolution)) {
                        vtmp = [
                            v[0] * f1 + v[3] * i1,
                            v[1] * f + v[4] * i,
                            v[2] * f3 + v[5] * i3,
                            v[3],
                            v[4],
                            v[5],
                            v[3] * f + v[6] * i,
                            v[4] * f2 + v[7] * i2,
                            v[5] * f3 + v[8] * i3,
                            v[0] * f1 + v[6] * i1,
                            v[1] * f2 + v[7] * i2,
                            v[2] * f3 + v[8] * i3
                        ];
                        ntmp = new MultiresNode(vtmp, node.side, node.level + 1, node.x * 2 + 1, node.y * 2, image.fullpath);
                        children.push(ntmp);
                    }
                    if (!(node.x == numTiles && doubleTileSize <= image.tileResolution) && !(node.y == numTiles && doubleTileSize <= image.tileResolution)) {
                        vtmp = [
                            v[0] * f1 + v[6] * i1,
                            v[1] * f2 + v[7] * i2,
                            v[2] * f3 + v[8] * i3,
                            v[3] * f + v[6] * i,
                            v[4] * f2 + v[7] * i2,
                            v[5] * f3 + v[8] * i3,
                            v[6],
                            v[7],
                            v[8],
                            v[9] * f1 + v[6] * i1,
                            v[10] * f + v[7] * i,
                            v[11] * f3 + v[8] * i3
                        ];
                        ntmp = new MultiresNode(vtmp, node.side, node.level + 1, node.x * 2 + 1, node.y * 2 + 1, image.fullpath);
                        children.push(ntmp);
                    }
                    if (!(node.y == numTiles && doubleTileSize <= image.tileResolution)) {
                        vtmp = [
                            v[0] * f + v[9] * i,
                            v[1] * f2 + v[10] * i2,
                            v[2] * f3 + v[11] * i3,
                            v[0] * f1 + v[6] * i1,
                            v[1] * f2 + v[7] * i2,
                            v[2] * f3 + v[8] * i3,
                            v[9] * f1 + v[6] * i1,
                            v[10] * f + v[7] * i,
                            v[11] * f3 + v[8] * i3,
                            v[9],
                            v[10],
                            v[11]
                        ];
                        ntmp = new MultiresNode(vtmp, node.side, node.level + 1, node.x * 2, node.y * 2 + 1, image.fullpath);
                        children.push(ntmp);
                    }
                    for(var j = 0; j < children.length; j++)testMultiresNode(rotPersp, children[j], pitch, yaw, hfov);
                }
            }
        }
        /**
     * Creates cube vertex array.
     * @private
     * @returns {number[]} Cube vertex array.
     */ function createCube() {
            return [
                -1,
                1,
                -1,
                1,
                1,
                -1,
                1,
                -1,
                -1,
                -1,
                -1,
                -1,
                1,
                1,
                1,
                -1,
                1,
                1,
                -1,
                -1,
                1,
                1,
                -1,
                1,
                -1,
                1,
                1,
                1,
                1,
                1,
                1,
                1,
                -1,
                -1,
                1,
                -1,
                -1,
                -1,
                -1,
                1,
                -1,
                -1,
                1,
                -1,
                1,
                -1,
                -1,
                1,
                -1,
                1,
                1,
                -1,
                1,
                -1,
                -1,
                -1,
                -1,
                -1,
                -1,
                1,
                1,
                1,
                -1,
                1,
                1,
                1,
                1,
                -1,
                1,
                1,
                -1,
                -1 // Right face
            ];
        }
        /**
     * Creates 3x3 identity matrix.
     * @private
     * @returns {number[]} Identity matrix.
     */ function identityMatrix3() {
            return [
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ];
        }
        /**
     * Rotates a 3x3 matrix.
     * @private
     * @param {number[]} m - Matrix to rotate.
     * @param {number[]} angle - Angle to rotate by in radians.
     * @param {string} axis - Axis to rotate about (`x`, `y`, or `z`).
     * @returns {number[]} Rotated matrix.
     */ function rotateMatrix(m, angle, axis) {
            var s = Math.sin(angle);
            var c = Math.cos(angle);
            if (axis == "x") return [
                m[0],
                c * m[1] + s * m[2],
                c * m[2] - s * m[1],
                m[3],
                c * m[4] + s * m[5],
                c * m[5] - s * m[4],
                m[6],
                c * m[7] + s * m[8],
                c * m[8] - s * m[7]
            ];
            if (axis == "y") return [
                c * m[0] - s * m[2],
                m[1],
                c * m[2] + s * m[0],
                c * m[3] - s * m[5],
                m[4],
                c * m[5] + s * m[3],
                c * m[6] - s * m[8],
                m[7],
                c * m[8] + s * m[6]
            ];
            if (axis == "z") return [
                c * m[0] + s * m[1],
                c * m[1] - s * m[0],
                m[2],
                c * m[3] + s * m[4],
                c * m[4] - s * m[3],
                m[5],
                c * m[6] + s * m[7],
                c * m[7] - s * m[6],
                m[8]
            ];
        }
        /**
     * Turns a 3x3 matrix into a 4x4 matrix.
     * @private
     * @param {number[]} m - Input matrix.
     * @returns {number[]} Expanded matrix.
     */ function makeMatrix4(m) {
            return [
                m[0],
                m[1],
                m[2],
                0,
                m[3],
                m[4],
                m[5],
                0,
                m[6],
                m[7],
                m[8],
                0,
                0,
                0,
                0,
                1
            ];
        }
        /**
     * Transposes a 4x4 matrix.
     * @private
     * @param {number[]} m - Input matrix.
     * @returns {number[]} Transposed matrix.
     */ function transposeMatrix4(m) {
            return [
                m[0],
                m[4],
                m[8],
                m[12],
                m[1],
                m[5],
                m[9],
                m[13],
                m[2],
                m[6],
                m[10],
                m[14],
                m[3],
                m[7],
                m[11],
                m[15]
            ];
        }
        /**
     * Creates a perspective matrix.
     * @private
     * @param {number} hfov - Desired horizontal field of view.
     * @param {number} aspect - Desired aspect ratio.
     * @param {number} znear - Near distance.
     * @param {number} zfar - Far distance.
     * @returns {number[]} Generated perspective matrix.
     */ function makePersp(hfov, aspect, znear, zfar) {
            var fovy = 2 * Math.atan(Math.tan(hfov / 2) * gl.drawingBufferHeight / gl.drawingBufferWidth);
            var f = 1 / Math.tan(fovy / 2);
            return [
                f / aspect,
                0,
                0,
                0,
                0,
                f,
                0,
                0,
                0,
                0,
                (zfar + znear) / (znear - zfar),
                2 * zfar * znear / (znear - zfar),
                0,
                0,
                -1,
                0
            ];
        }
        /**
     * Processes a loaded texture image into a WebGL texture.
     * @private
     * @param {Image} img - Input image.
     * @param {WebGLTexture} tex - Texture to bind image to.
     */ function processLoadedTexture(img, tex) {
            gl.bindTexture(gl.TEXTURE_2D, tex);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.bindTexture(gl.TEXTURE_2D, null);
        }
        var pendingTextureRequests = [];
        // Based on http://blog.tojicode.com/2012/03/javascript-memory-optimization-and.html
        var loadTexture = function() {
            var cacheTop = 4; // Maximum number of concurrents loads
            var textureImageCache = {};
            var crossOrigin;
            function TextureImageLoader() {
                var self = this;
                this.texture = this.callback = null;
                this.image = new Image();
                this.image.crossOrigin = crossOrigin ? crossOrigin : "anonymous";
                var loadFn = function() {
                    if (self.image.width > 0 && self.image.height > 0) {
                        processLoadedTexture(self.image, self.texture);
                        self.callback(self.texture, true);
                    } else self.callback(self.texture, false);
                    releaseTextureImageLoader(self);
                };
                this.image.addEventListener("load", loadFn);
                this.image.addEventListener("error", loadFn); // ignore missing tile file to support partial image, otherwise retry loop causes high CPU load
            }
            TextureImageLoader.prototype.loadTexture = function(src, texture, callback) {
                this.texture = texture;
                this.callback = callback;
                this.image.src = src;
            };
            function PendingTextureRequest(node, src, texture, callback) {
                this.node = node;
                this.src = src;
                this.texture = texture;
                this.callback = callback;
            }
            function releaseTextureImageLoader(til) {
                if (pendingTextureRequests.length) {
                    var req = pendingTextureRequests.shift();
                    til.loadTexture(req.src, req.texture, req.callback);
                } else textureImageCache[cacheTop++] = til;
            }
            for(var i = 0; i < cacheTop; i++)textureImageCache[i] = new TextureImageLoader();
            return function(node, src, callback, _crossOrigin) {
                crossOrigin = _crossOrigin;
                var texture = gl.createTexture();
                if (cacheTop) textureImageCache[--cacheTop].loadTexture(src, texture, callback);
                else pendingTextureRequests.push(new PendingTextureRequest(node, src, texture, callback));
                return texture;
            };
        }();
        /**
     * Loads image and creates texture for a multires node / tile.
     * @private
     * @param {MultiresNode} node - Input node.
     */ function processNextTile(node) {
            loadTexture(node, node.path + "." + image.extension, function(texture, loaded) {
                node.texture = texture;
                node.textureLoaded = loaded ? 2 : 1;
            }, globalParams.crossOrigin);
        }
        /**
     * Finds and applies optimal multires zoom level.
     * @private
     * @param {number} hfov - Horizontal field of view to check at.
     */ function checkZoom(hfov) {
            // Find optimal level
            var newLevel = 1;
            while(newLevel < image.maxLevel && gl.drawingBufferWidth > image.tileResolution * Math.pow(2, newLevel - 1) * Math.tan(hfov / 2) * 0.707)newLevel++;
            // Apply change
            program.level = newLevel;
        }
        /**
     * Rotates perspective matrix.
     * @private
     * @param {number[]} p - Perspective matrix.
     * @param {number[]} r - Rotation matrix.
     * @returns {number[]} Rotated matrix.
     */ function rotatePersp(p, r) {
            return [
                p[0] * r[0],
                p[0] * r[1],
                p[0] * r[2],
                0,
                p[5] * r[4],
                p[5] * r[5],
                p[5] * r[6],
                0,
                p[10] * r[8],
                p[10] * r[9],
                p[10] * r[10],
                p[11],
                -r[8],
                -r[9],
                -r[10],
                0
            ];
        }
        /**
     * Applies rotated perspective matrix to a 3-vector
     * (last element is inverted).
     * @private
     * @param {number[]} m - Rotated perspective matrix.
     * @param {number[]} v - Input 3-vector.
     * @returns {number[]} Resulting 4-vector.
     */ function applyRotPerspToVec(m, v) {
            return [
                m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
                m[4] * v[0] + m[5] * v[1] + m[6] * v[2],
                m[11] + m[8] * v[0] + m[9] * v[1] + m[10] * v[2],
                1 / (m[12] * v[0] + m[13] * v[1] + m[14] * v[2])
            ];
        }
        /**
     * Checks if a vertex is visible.
     * @private
     * @param {number[]} m - Rotated perspective matrix.
     * @param {number[]} v - Input vertex.
     * @returns {number} 1 or -1 if the vertex is or is not visible,
     *      respectively.
     */ function checkInView(m, v) {
            var vpp = applyRotPerspToVec(m, v);
            var winX = vpp[0] * vpp[3];
            var winY = vpp[1] * vpp[3];
            var winZ = vpp[2] * vpp[3];
            var ret = [
                0,
                0,
                0
            ];
            if (winX < -1) ret[0] = -1;
            if (winX > 1) ret[0] = 1;
            if (winY < -1) ret[1] = -1;
            if (winY > 1) ret[1] = 1;
            if (winZ < -1 || winZ > 1) ret[2] = 1;
            return ret;
        }
        /**
     * Checks if a square (tile) is visible.
     * @private
     * @param {number[]} m - Rotated perspective matrix.
     * @param {number[]} v - Square's vertex array.
     * @returns {boolean} Whether or not the square is visible.
     */ function checkSquareInView(m, v) {
            var check1 = checkInView(m, v.slice(0, 3));
            var check2 = checkInView(m, v.slice(3, 6));
            var check3 = checkInView(m, v.slice(6, 9));
            var check4 = checkInView(m, v.slice(9, 12));
            var testX = check1[0] + check2[0] + check3[0] + check4[0];
            if (testX == -4 || testX == 4) return false;
            var testY = check1[1] + check2[1] + check3[1] + check4[1];
            if (testY == -4 || testY == 4) return false;
            var testZ = check1[2] + check2[2] + check3[2] + check4[2];
            return testZ != 4;
        }
        /**
     * On iOS (iPhone 5c, iOS 10.3), this WebGL error occurs when the canvas is
     * too big. Unfortuately, there's no way to test for this beforehand, so we
     * reduce the canvas size if this error is thrown.
     * @private
     */ function handleWebGLError1286() {
            console.log("Reducing canvas size due to error 1286!");
            canvas.width = Math.round(canvas.width / 2);
            canvas.height = Math.round(canvas.height / 2);
        }
    }
    // Vertex shader for equirectangular and cube
    var v = [
        "attribute vec2 a_texCoord;",
        "varying vec2 v_texCoord;",
        "void main() {",
        // Set position
        "gl_Position = vec4(a_texCoord, 0.0, 1.0);",
        // Pass the coordinates to the fragment shader
        "v_texCoord = a_texCoord;",
        "}"
    ].join("");
    // Vertex shader for multires
    var vMulti = [
        "attribute vec3 a_vertCoord;",
        "attribute vec2 a_texCoord;",
        "uniform mat4 u_cubeMatrix;",
        "uniform mat4 u_perspMatrix;",
        "varying mediump vec2 v_texCoord;",
        "void main(void) {",
        // Set position
        "gl_Position = u_perspMatrix * u_cubeMatrix * vec4(a_vertCoord, 1.0);",
        // Pass the coordinates to the fragment shader
        "v_texCoord = a_texCoord;",
        "}"
    ].join("");
    // Fragment shader
    var fragEquiCubeBase = [
        "precision highp float;",
        "uniform float u_aspectRatio;",
        "uniform float u_psi;",
        "uniform float u_theta;",
        "uniform float u_f;",
        "uniform float u_h;",
        "uniform float u_v;",
        "uniform float u_vo;",
        "uniform float u_rot;",
        "const float PI = 3.14159265358979323846264;",
        // Texture
        "uniform sampler2D u_image0;",
        "uniform sampler2D u_image1;",
        "uniform bool u_splitImage;",
        "uniform samplerCube u_imageCube;",
        // Coordinates passed in from vertex shader
        "varying vec2 v_texCoord;",
        // Background color (display for partial panoramas)
        "uniform vec4 u_backgroundColor;",
        "void main() {",
        // Map canvas/camera to sphere
        "float x = v_texCoord.x * u_aspectRatio;",
        "float y = v_texCoord.y;",
        "float sinrot = sin(u_rot);",
        "float cosrot = cos(u_rot);",
        "float rot_x = x * cosrot - y * sinrot;",
        "float rot_y = x * sinrot + y * cosrot;",
        "float sintheta = sin(u_theta);",
        "float costheta = cos(u_theta);",
        "float a = u_f * costheta - rot_y * sintheta;",
        "float root = sqrt(rot_x * rot_x + a * a);",
        "float lambda = atan(rot_x / root, a / root) + u_psi;",
        "float phi = atan((rot_y * costheta + u_f * sintheta) / root);"
    ].join("\n");
    // Fragment shader
    var fragCube = fragEquiCubeBase + [
        // Look up color from texture
        "float cosphi = cos(phi);",
        "gl_FragColor = textureCube(u_imageCube, vec3(cosphi*sin(lambda), sin(phi), cosphi*cos(lambda)));",
        "}"
    ].join("\n");
    // Fragment shader
    var fragEquirectangular = fragEquiCubeBase + [
        // Wrap image
        "lambda = mod(lambda + PI, PI * 2.0) - PI;",
        // Map texture to sphere
        "vec2 coord = vec2(lambda / PI, phi / (PI / 2.0));",
        // Look up color from texture
        // Map from [-1,1] to [0,1] and flip y-axis
        "if(coord.x < -u_h || coord.x > u_h || coord.y < -u_v + u_vo || coord.y > u_v + u_vo)",
        "gl_FragColor = u_backgroundColor;",
        "else {",
        "if(u_splitImage) {",
        // Image was split into two textures to work around texture size limits
        "if(coord.x < 0.0)",
        "gl_FragColor = texture2D(u_image0, vec2((coord.x + u_h) / u_h, (-coord.y + u_v + u_vo) / (u_v * 2.0)));",
        "else",
        "gl_FragColor = texture2D(u_image1, vec2((coord.x + u_h) / u_h - 1.0, (-coord.y + u_v + u_vo) / (u_v * 2.0)));",
        "} else {",
        "gl_FragColor = texture2D(u_image0, vec2((coord.x + u_h) / (u_h * 2.0), (-coord.y + u_v + u_vo) / (u_v * 2.0)));",
        "}",
        "}",
        "}"
    ].join("\n");
    // Fragment shader
    var fragMulti = [
        "varying mediump vec2 v_texCoord;",
        "uniform sampler2D u_sampler;",
        //'uniform mediump vec4 u_color;',
        "void main(void) {",
        // Look up color from texture
        "gl_FragColor = texture2D(u_sampler, v_texCoord);",
        //    'gl_FragColor = u_color;',
        "}"
    ].join("");
    return {
        renderer: function(container, image, imagetype, dynamic) {
            return new Renderer(container, image, imagetype, dynamic);
        }
    };
}(window, document);


const $528105fcba5f9f10$export$2cf81d87fa45b315 = window.pannellum;


/*! @vimeo/player v2.20.1 | (c) 2023 Vimeo | MIT License | https://github.com/vimeo/player.js */ function $e2699dd4b9c01f75$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e2699dd4b9c01f75$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e2699dd4b9c01f75$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e2699dd4b9c01f75$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e2699dd4b9c01f75$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e2699dd4b9c01f75$var$_regeneratorRuntime() {
    $e2699dd4b9c01f75$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self1, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self1, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self1, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self1, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self1, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $e2699dd4b9c01f75$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $e2699dd4b9c01f75$var$_asyncToGenerator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                $e2699dd4b9c01f75$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $e2699dd4b9c01f75$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $e2699dd4b9c01f75$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e2699dd4b9c01f75$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e2699dd4b9c01f75$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e2699dd4b9c01f75$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e2699dd4b9c01f75$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e2699dd4b9c01f75$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e2699dd4b9c01f75$var$_defineProperty(obj, key, value) {
    key = $e2699dd4b9c01f75$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e2699dd4b9c01f75$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e2699dd4b9c01f75$var$_setPrototypeOf(subClass, superClass);
}
function $e2699dd4b9c01f75$var$_getPrototypeOf(o) {
    $e2699dd4b9c01f75$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e2699dd4b9c01f75$var$_getPrototypeOf(o);
}
function $e2699dd4b9c01f75$var$_setPrototypeOf(o, p) {
    $e2699dd4b9c01f75$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e2699dd4b9c01f75$var$_setPrototypeOf(o, p);
}
function $e2699dd4b9c01f75$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e2699dd4b9c01f75$var$_construct(Parent, args, Class) {
    if ($e2699dd4b9c01f75$var$_isNativeReflectConstruct()) $e2699dd4b9c01f75$var$_construct = Reflect.construct.bind();
    else $e2699dd4b9c01f75$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $e2699dd4b9c01f75$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $e2699dd4b9c01f75$var$_construct.apply(null, arguments);
}
function $e2699dd4b9c01f75$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $e2699dd4b9c01f75$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $e2699dd4b9c01f75$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$e2699dd4b9c01f75$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $e2699dd4b9c01f75$var$_construct(Class, arguments, $e2699dd4b9c01f75$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $e2699dd4b9c01f75$var$_setPrototypeOf(Wrapper, Class);
    };
    return $e2699dd4b9c01f75$var$_wrapNativeSuper(Class);
}
function $e2699dd4b9c01f75$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $e2699dd4b9c01f75$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e2699dd4b9c01f75$var$_assertThisInitialized(self1);
}
function $e2699dd4b9c01f75$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e2699dd4b9c01f75$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e2699dd4b9c01f75$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e2699dd4b9c01f75$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e2699dd4b9c01f75$var$_possibleConstructorReturn(this, result);
    };
}
function $e2699dd4b9c01f75$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e2699dd4b9c01f75$var$_toPropertyKey(arg) {
    var key = $e2699dd4b9c01f75$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
/**
 * @module lib/functions
 */ /**
 * Check to see this is a node environment.
 * @type {Boolean}
 */ /* global global */ var $e2699dd4b9c01f75$var$isNode = typeof $parcel$global !== "undefined" && ({}).toString.call($parcel$global) === "[object global]";
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */ function $e2699dd4b9c01f75$var$getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) return prop;
    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */ function $e2699dd4b9c01f75$var$isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && "nodeName" in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */ function $e2699dd4b9c01f75$var$isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $e2699dd4b9c01f75$var$isVimeoUrl(url) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $e2699dd4b9c01f75$var$isVimeoEmbed(url) {
    var expr = /^https:\/\/player\.vimeo\.com\/video\/\d+/;
    return expr.test(url);
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */ function $e2699dd4b9c01f75$var$getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;
    if (!idOrUrl) throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
    if ($e2699dd4b9c01f75$var$isInteger(idOrUrl)) return "https://vimeo.com/".concat(idOrUrl);
    if ($e2699dd4b9c01f75$var$isVimeoUrl(idOrUrl)) return idOrUrl.replace("http:", "https:");
    if (id) throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}
/* eslint-disable max-params */ /**
 * A utility method for attaching and detaching event handlers
 *
 * @param {EventTarget} target
 * @param {string | string[]} eventName
 * @param {function} callback
 * @param {'addEventListener' | 'on'} onName
 * @param {'removeEventListener' | 'off'} offName
 * @return {{cancel: (function(): void)}}
 */ var $e2699dd4b9c01f75$var$subscribe = function subscribe(target, eventName, callback) {
    var onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "addEventListener";
    var offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "removeEventListener";
    var eventNames = typeof eventName === "string" ? [
        eventName
    ] : eventName;
    eventNames.forEach(function(evName) {
        target[onName](evName, callback);
    });
    return {
        cancel: function cancel() {
            return eventNames.forEach(function(evName) {
                return target[offName](evName, callback);
            });
        }
    };
};
var $e2699dd4b9c01f75$var$arrayIndexOfSupport = typeof Array.prototype.indexOf !== "undefined";
var $e2699dd4b9c01f75$var$postMessageSupport = typeof window !== "undefined" && typeof window.postMessage !== "undefined";
if (!$e2699dd4b9c01f75$var$isNode && (!$e2699dd4b9c01f75$var$arrayIndexOfSupport || !$e2699dd4b9c01f75$var$postMessageSupport)) throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var $e2699dd4b9c01f75$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $e2699dd4b9c01f75$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */ (function(self1) {
    if (self1.WeakMap) return;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var hasDefine = Object.defineProperty && function() {
        try {
            // Avoid IE8's broken Object.defineProperty
            return Object.defineProperty({}, "x", {
                value: 1
            }).x === 1;
        } catch (e) {}
    }();
    var defineProperty = function(object, name, value) {
        if (hasDefine) Object.defineProperty(object, name, {
            configurable: true,
            writable: true,
            value: value
        });
        else object[name] = value;
    };
    self1.WeakMap = function() {
        // ECMA-262 23.3 WeakMap Objects
        function WeakMap1() {
            if (this === void 0) throw new TypeError("Constructor WeakMap requires 'new'");
            defineProperty(this, "_id", genId("_WeakMap"));
            // ECMA-262 23.3.1.1 WeakMap([iterable])
            if (arguments.length > 0) // Currently, WeakMap `iterable` argument is not supported
            throw new TypeError("WeakMap iterable is not supported");
        }
        // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
        defineProperty(WeakMap1.prototype, "delete", function(key) {
            checkInstance(this, "delete");
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                delete key[this._id];
                return true;
            }
            return false;
        });
        // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
        defineProperty(WeakMap1.prototype, "get", function(key) {
            checkInstance(this, "get");
            if (!isObject(key)) return void 0;
            var entry = key[this._id];
            if (entry && entry[0] === key) return entry[1];
            return void 0;
        });
        // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
        defineProperty(WeakMap1.prototype, "has", function(key) {
            checkInstance(this, "has");
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) return true;
            return false;
        });
        // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
        defineProperty(WeakMap1.prototype, "set", function(key, value) {
            checkInstance(this, "set");
            if (!isObject(key)) throw new TypeError("Invalid value used as weak map key");
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                entry[1] = value;
                return this;
            }
            defineProperty(key, this._id, [
                key,
                value
            ]);
            return this;
        });
        function checkInstance(x, methodName) {
            if (!isObject(x) || !hasOwnProperty.call(x, "_id")) throw new TypeError(methodName + " method called on incompatible receiver " + typeof x);
        }
        function genId(prefix) {
            return prefix + "_" + rand() + "." + rand();
        }
        function rand() {
            return Math.random().toString().substring(2);
        }
        defineProperty(WeakMap1, "_polyfill", true);
        return WeakMap1;
    }();
    function isObject(x) {
        return Object(x) === x;
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $e2699dd4b9c01f75$var$commonjsGlobal !== "undefined" ? $e2699dd4b9c01f75$var$commonjsGlobal : $e2699dd4b9c01f75$var$commonjsGlobal);
var $e2699dd4b9c01f75$var$npo_src = $e2699dd4b9c01f75$var$createCommonjsModule(function(module) {
    /*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/ (function UMD(name, context, definition) {
        // special form of UMD for polyfilling across evironments
        context[name] = context[name] || definition();
        if (module.exports) module.exports = context[name];
    })("Promise", typeof $e2699dd4b9c01f75$var$commonjsGlobal != "undefined" ? $e2699dd4b9c01f75$var$commonjsGlobal : $e2699dd4b9c01f75$var$commonjsGlobal, function DEF() {
        var builtInProp, cycle, scheduling_queue, ToString = Object.prototype.toString, timer = typeof setImmediate != "undefined" ? function timer(fn) {
            return setImmediate(fn);
        } : setTimeout;
        // dammit, IE8.
        try {
            Object.defineProperty({}, "x", {});
            builtInProp = function builtInProp(obj, name, val, config) {
                return Object.defineProperty(obj, name, {
                    value: val,
                    writable: true,
                    configurable: config !== false
                });
            };
        } catch (err) {
            builtInProp = function builtInProp(obj, name, val) {
                obj[name] = val;
                return obj;
            };
        }
        // Note: using a queue instead of array for efficiency
        scheduling_queue = function Queue() {
            var first, last, item;
            function Item(fn, self1) {
                this.fn = fn;
                this.self = self1;
                this.next = void 0;
            }
            return {
                add: function add(fn, self1) {
                    item = new Item(fn, self1);
                    if (last) last.next = item;
                    else first = item;
                    last = item;
                    item = void 0;
                },
                drain: function drain() {
                    var f = first;
                    first = last = cycle = void 0;
                    while(f){
                        f.fn.call(f.self);
                        f = f.next;
                    }
                }
            };
        }();
        function schedule(fn, self1) {
            scheduling_queue.add(fn, self1);
            if (!cycle) cycle = timer(scheduling_queue.drain);
        }
        // promise duck typing
        function isThenable(o) {
            var _then, o_type = typeof o;
            if (o != null && (o_type == "object" || o_type == "function")) _then = o.then;
            return typeof _then == "function" ? _then : false;
        }
        function notify() {
            for(var i = 0; i < this.chain.length; i++)notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
            this.chain.length = 0;
        }
        // NOTE: This is a separate function to isolate
        // the `try..catch` so that other code can be
        // optimized better
        function notifyIsolated(self1, cb, chain) {
            var ret, _then;
            try {
                if (cb === false) chain.reject(self1.msg);
                else {
                    if (cb === true) ret = self1.msg;
                    else ret = cb.call(void 0, self1.msg);
                    if (ret === chain.promise) chain.reject(TypeError("Promise-chain cycle"));
                    else if (_then = isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
                    else chain.resolve(ret);
                }
            } catch (err) {
                chain.reject(err);
            }
        }
        function resolve(msg) {
            var _then, self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            try {
                if (_then = isThenable(msg)) schedule(function() {
                    var def_wrapper = new MakeDefWrapper(self1);
                    try {
                        _then.call(msg, function $resolve$() {
                            resolve.apply(def_wrapper, arguments);
                        }, function $reject$() {
                            reject.apply(def_wrapper, arguments);
                        });
                    } catch (err) {
                        reject.call(def_wrapper, err);
                    }
                });
                else {
                    self1.msg = msg;
                    self1.state = 1;
                    if (self1.chain.length > 0) schedule(notify, self1);
                }
            } catch (err) {
                reject.call(new MakeDefWrapper(self1), err);
            }
        }
        function reject(msg) {
            var self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            self1.msg = msg;
            self1.state = 2;
            if (self1.chain.length > 0) schedule(notify, self1);
        }
        function iteratePromises(Constructor, arr, resolver, rejecter) {
            for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
                Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
                    resolver(idx, msg);
                }, rejecter);
            })(idx);
        }
        function MakeDefWrapper(self1) {
            this.def = self1;
            this.triggered = false;
        }
        function MakeDef(self1) {
            this.promise = self1;
            this.state = 0;
            this.triggered = false;
            this.chain = [];
            this.msg = void 0;
        }
        function Promise1(executor) {
            if (typeof executor != "function") throw TypeError("Not a function");
            if (this.__NPO__ !== 0) throw TypeError("Not a promise");
            // instance shadowing the inherited "brand"
            // to signal an already "initialized" promise
            this.__NPO__ = 1;
            var def = new MakeDef(this);
            this["then"] = function then(success, failure) {
                var o = {
                    success: typeof success == "function" ? success : true,
                    failure: typeof failure == "function" ? failure : false
                };
                // Note: `then(..)` itself can be borrowed to be used against
                // a different promise constructor for making the chained promise,
                // by substituting a different `this` binding.
                o.promise = new this.constructor(function extractChain(resolve, reject) {
                    if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                    o.resolve = resolve;
                    o.reject = reject;
                });
                def.chain.push(o);
                if (def.state !== 0) schedule(notify, def);
                return o.promise;
            };
            this["catch"] = function $catch$(failure) {
                return this.then(void 0, failure);
            };
            try {
                executor.call(void 0, function publicResolve(msg) {
                    resolve.call(def, msg);
                }, function publicReject(msg) {
                    reject.call(def, msg);
                });
            } catch (err) {
                reject.call(def, err);
            }
        }
        var PromisePrototype = builtInProp({}, "constructor", Promise1, /*configurable=*/ false);
        // Note: Android 4 cannot use `Object.defineProperty(..)` here
        Promise1.prototype = PromisePrototype;
        // built-in "brand" to signal an "uninitialized" promise
        builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/ false);
        builtInProp(Promise1, "resolve", function Promise$resolve(msg) {
            var Constructor = this;
            // spec mandated checks
            // note: best "isPromise" check that's practical for now
            if (msg && typeof msg == "object" && msg.__NPO__ === 1) return msg;
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                resolve(msg);
            });
        });
        builtInProp(Promise1, "reject", function Promise$reject(msg) {
            return new this(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                reject(msg);
            });
        });
        builtInProp(Promise1, "all", function Promise$all(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            if (arr.length === 0) return Constructor.resolve([]);
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                var len = arr.length, msgs = Array(len), count = 0;
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    msgs[idx] = msg;
                    if (++count === len) resolve(msgs);
                }, reject);
            });
        });
        builtInProp(Promise1, "race", function Promise$race(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    resolve(msg);
                }, reject);
            });
        });
        return Promise1;
    });
});
/**
 * @module lib/callbacks
 */ var $e2699dd4b9c01f75$var$callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$storeCallback(player, name, callback) {
    var playerCallbacks = $e2699dd4b9c01f75$var$callbackMap.get(player.element) || {};
    if (!(name in playerCallbacks)) playerCallbacks[name] = [];
    playerCallbacks[name].push(callback);
    $e2699dd4b9c01f75$var$callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */ function $e2699dd4b9c01f75$var$getCallbacks(player, name) {
    var playerCallbacks = $e2699dd4b9c01f75$var$callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */ function $e2699dd4b9c01f75$var$removeCallback(player, name, callback) {
    var playerCallbacks = $e2699dd4b9c01f75$var$callbackMap.get(player.element) || {};
    if (!playerCallbacks[name]) return true;
    // If no callback is passed, remove all callbacks for the event
    if (!callback) {
        playerCallbacks[name] = [];
        $e2699dd4b9c01f75$var$callbackMap.set(player.element, playerCallbacks);
        return true;
    }
    var index = playerCallbacks[name].indexOf(callback);
    if (index !== -1) playerCallbacks[name].splice(index, 1);
    $e2699dd4b9c01f75$var$callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */ function $e2699dd4b9c01f75$var$shiftCallbacks(player, name) {
    var playerCallbacks = $e2699dd4b9c01f75$var$getCallbacks(player, name);
    if (playerCallbacks.length < 1) return false;
    var callback = playerCallbacks.shift();
    $e2699dd4b9c01f75$var$removeCallback(player, name, callback);
    return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$swapCallbacks(oldElement, newElement) {
    var playerCallbacks = $e2699dd4b9c01f75$var$callbackMap.get(oldElement);
    $e2699dd4b9c01f75$var$callbackMap.set(newElement, playerCallbacks);
    $e2699dd4b9c01f75$var$callbackMap.delete(oldElement);
}
/**
 * @module lib/postmessage
 */ /**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */ function $e2699dd4b9c01f75$var$parseMessageData(data) {
    if (typeof data === "string") try {
        data = JSON.parse(data);
    } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
    }
    return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) return;
    var message = {
        method: method
    };
    if (params !== undefined) message.value = params;
    // IE 8 and 9 do not support passing messages, so stringify them
    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    if (ieVersion >= 8 && ieVersion < 10) message = JSON.stringify(message);
    player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$processData(player, data) {
    data = $e2699dd4b9c01f75$var$parseMessageData(data);
    var callbacks = [];
    var param;
    if (data.event) {
        if (data.event === "error") {
            var promises = $e2699dd4b9c01f75$var$getCallbacks(player, data.data.method);
            promises.forEach(function(promise) {
                var error = new Error(data.data.message);
                error.name = data.data.name;
                promise.reject(error);
                $e2699dd4b9c01f75$var$removeCallback(player, data.data.method, promise);
            });
        }
        callbacks = $e2699dd4b9c01f75$var$getCallbacks(player, "event:".concat(data.event));
        param = data.data;
    } else if (data.method) {
        var callback = $e2699dd4b9c01f75$var$shiftCallbacks(player, data.method);
        if (callback) {
            callbacks.push(callback);
            param = data.value;
        }
    }
    callbacks.forEach(function(callback) {
        try {
            if (typeof callback === "function") {
                callback.call(player, param);
                return;
            }
            callback.resolve(param);
        } catch (e) {
        // empty
        }
    });
}
/**
 * @module lib/embed
 */ var $e2699dd4b9c01f75$var$oEmbedParameters = [
    "autopause",
    "autoplay",
    "background",
    "byline",
    "color",
    "colors",
    "controls",
    "dnt",
    "height",
    "id",
    "interactive_params",
    "keyboard",
    "loop",
    "maxheight",
    "maxwidth",
    "muted",
    "playsinline",
    "portrait",
    "responsive",
    "speed",
    "texttrack",
    "title",
    "transparent",
    "url",
    "width"
];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */ function $e2699dd4b9c01f75$var$getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $e2699dd4b9c01f75$var$oEmbedParameters.reduce(function(params, param) {
        var value = element.getAttribute("data-vimeo-".concat(param));
        if (value || value === "") params[param] = value === "" ? 1 : value;
        return params;
    }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */ function $e2699dd4b9c01f75$var$createEmbed(_ref, element) {
    var html = _ref.html;
    if (!element) throw new TypeError("An element must be provided");
    if (element.getAttribute("data-vimeo-initialized") !== null) return element.querySelector("iframe");
    var div = document.createElement("div");
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute("data-vimeo-initialized", "true");
    return element.querySelector("iframe");
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */ function $e2699dd4b9c01f75$var$getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function(resolve, reject) {
        if (!$e2699dd4b9c01f75$var$isVimeoUrl(videoUrl)) throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
        var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));
        for(var param in params)if (params.hasOwnProperty(param)) url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        var xhr = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function() {
            if (xhr.status === 404) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
                return;
            }
            if (xhr.status === 403) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                return;
            }
            try {
                var json = JSON.parse(xhr.responseText);
                // Check api response for 403 on oembed
                if (json.domain_status_code === 403) {
                    // We still want to create the embed to give users visual feedback
                    $e2699dd4b9c01f75$var$createEmbed(json, element);
                    reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                    return;
                }
                resolve(json);
            } catch (error) {
                reject(error);
            }
        };
        xhr.onerror = function() {
            var status = xhr.status ? " (".concat(xhr.status, ")") : "";
            reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
        };
        xhr.send();
    });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll("[data-vimeo-id], [data-vimeo-url]"));
    var handleError = function handleError(error) {
        if ("console" in window && console.error) console.error("There was an error creating an embed: ".concat(error));
    };
    elements.forEach(function(element) {
        try {
            // Skip any that have data-vimeo-defer
            if (element.getAttribute("data-vimeo-defer") !== null) return;
            var params = $e2699dd4b9c01f75$var$getOEmbedParameters(element);
            var url = $e2699dd4b9c01f75$var$getVimeoUrl(params);
            $e2699dd4b9c01f75$var$getOEmbedData(url, params, element).then(function(data) {
                return $e2699dd4b9c01f75$var$createEmbed(data, element);
            }).catch(handleError);
        } catch (error) {
            handleError(error);
        }
    });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) return;
    window.VimeoPlayerResizeEmbeds_ = true;
    var onMessage = function onMessage(event) {
        if (!$e2699dd4b9c01f75$var$isVimeoUrl(event.origin)) return;
        // 'spacechange' is fired only on embeds with cards
        if (!event.data || event.data.event !== "spacechange") return;
        var iframes = parent.querySelectorAll("iframe");
        for(var i = 0; i < iframes.length; i++){
            if (iframes[i].contentWindow !== event.source) continue;
            // Change padding-bottom of the enclosing div to accommodate
            // card carousel without distorting aspect ratio
            var space = iframes[i].parentElement;
            space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
            break;
        }
    };
    window.addEventListener("message", onMessage);
}
/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$initAppendVideoMetadata() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoSeoMetadataAppended) return;
    window.VimeoSeoMetadataAppended = true;
    var onMessage = function onMessage(event) {
        if (!$e2699dd4b9c01f75$var$isVimeoUrl(event.origin)) return;
        var data = $e2699dd4b9c01f75$var$parseMessageData(event.data);
        if (!data || data.event !== "ready") return;
        var iframes = parent.querySelectorAll("iframe");
        for(var i = 0; i < iframes.length; i++){
            var iframe = iframes[i];
            // Initiate appendVideoMetadata if iframe is a Vimeo embed
            var isValidMessageSource = iframe.contentWindow === event.source;
            if ($e2699dd4b9c01f75$var$isVimeoEmbed(iframe.src) && isValidMessageSource) {
                var player = new $e2699dd4b9c01f75$var$Player(iframe);
                player.callMethod("appendVideoMetadata", window.location.href);
            }
        }
    };
    window.addEventListener("message", onMessage);
}
/**
 * Seek to time indicated by vimeo_t query parameter if present in URL
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $e2699dd4b9c01f75$var$checkUrlTimeParam() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoCheckedUrlTimeParam) return;
    window.VimeoCheckedUrlTimeParam = true;
    var handleError = function handleError(error) {
        if ("console" in window && console.error) console.error("There was an error getting video Id: ".concat(error));
    };
    var onMessage = function onMessage(event) {
        if (!$e2699dd4b9c01f75$var$isVimeoUrl(event.origin)) return;
        var data = $e2699dd4b9c01f75$var$parseMessageData(event.data);
        if (!data || data.event !== "ready") return;
        var iframes = parent.querySelectorAll("iframe");
        var _loop = function _loop() {
            var iframe = iframes[i];
            var isValidMessageSource = iframe.contentWindow === event.source;
            if ($e2699dd4b9c01f75$var$isVimeoEmbed(iframe.src) && isValidMessageSource) {
                var player = new $e2699dd4b9c01f75$var$Player(iframe);
                player.getVideoId().then(function(videoId) {
                    var matches = new RegExp("[?&]vimeo_t_".concat(videoId, "=([^&#]*)")).exec(window.location.href);
                    if (matches && matches[1]) {
                        var sec = decodeURI(matches[1]);
                        player.setCurrentTime(sec);
                    }
                    return;
                }).catch(handleError);
            }
        };
        for(var i = 0; i < iframes.length; i++)_loop();
    };
    window.addEventListener("message", onMessage);
}
/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */ function $e2699dd4b9c01f75$var$initializeScreenfull() {
    var fn = function() {
        var val;
        var fnMap = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            // New WebKit
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            // Old WebKit
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    var eventNameMap = {
        fullscreenchange: fn.fullscreenchange,
        fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
        request: function request(element) {
            return new Promise(function(resolve, reject) {
                var onFullScreenEntered = function onFullScreenEntered() {
                    screenfull.off("fullscreenchange", onFullScreenEntered);
                    resolve();
                };
                screenfull.on("fullscreenchange", onFullScreenEntered);
                element = element || document.documentElement;
                var returnPromise = element[fn.requestFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            });
        },
        exit: function exit() {
            return new Promise(function(resolve, reject) {
                if (!screenfull.isFullscreen) {
                    resolve();
                    return;
                }
                var onFullScreenExit = function onFullScreenExit() {
                    screenfull.off("fullscreenchange", onFullScreenExit);
                    resolve();
                };
                screenfull.on("fullscreenchange", onFullScreenExit);
                var returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            });
        },
        on: function on(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback);
        },
        off: function off(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback);
        }
    };
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get: function get() {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get: function get() {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get: function get() {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    return screenfull;
}
/** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */ /** @typedef {import('./timing-object.types').TimingObject} TimingObject */ /** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */ /** @typedef {(msg: string) => any} Logger */ /** @typedef {import('timing-object.types').TConnectionState} TConnectionState */ /**
 * @type {TimingSrcConnectorOptions}
 *
 * For details on these properties and their effects, see the typescript definition referenced above.
 */ var $e2699dd4b9c01f75$var$defaultOptions = {
    role: "viewer",
    autoPlayMuted: true,
    allowedDrift: 0.3,
    maxAllowedDrift: 1,
    minCheckInterval: 0.1,
    maxRateAdjustment: 0.2,
    maxTimeToCatchUp: 1
};
/**
 * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
 *
 * Proposed spec: https://webtiming.github.io/timingobject/
 * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
 * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
 *
 * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
 *
 * There are 5 general responsibilities in TimingSrcConnector:
 *
 * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
 * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
 * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
 * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
 * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
 */ var $e2699dd4b9c01f75$var$TimingSrcConnector = /*#__PURE__*/ function(_EventTarget) {
    $e2699dd4b9c01f75$var$_inherits(TimingSrcConnector, _EventTarget);
    var _super = $e2699dd4b9c01f75$var$_createSuper(TimingSrcConnector);
    /**
   * @param {PlayerControls} player
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   * @param {Logger} logger
   */ function TimingSrcConnector(_player, timingObject) {
        var _this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var logger = arguments.length > 3 ? arguments[3] : undefined;
        $e2699dd4b9c01f75$var$_classCallCheck(this, TimingSrcConnector);
        _this = _super.call(this);
        $e2699dd4b9c01f75$var$_defineProperty($e2699dd4b9c01f75$var$_assertThisInitialized(_this), "logger", void 0);
        $e2699dd4b9c01f75$var$_defineProperty($e2699dd4b9c01f75$var$_assertThisInitialized(_this), "speedAdjustment", 0);
        /**
     * @param {PlayerControls} player
     * @param {number} newAdjustment
     * @return {Promise<void>}
     */ $e2699dd4b9c01f75$var$_defineProperty($e2699dd4b9c01f75$var$_assertThisInitialized(_this), "adjustSpeed", /*#__PURE__*/ function() {
            var _ref = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee(player, newAdjustment) {
                var newPlaybackRate;
                return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!(_this.speedAdjustment === newAdjustment)) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            _context.next = 4;
                            return player.getPlaybackRate();
                        case 4:
                            _context.t0 = _context.sent;
                            _context.t1 = _this.speedAdjustment;
                            _context.t2 = _context.t0 - _context.t1;
                            _context.t3 = newAdjustment;
                            newPlaybackRate = _context.t2 + _context.t3;
                            _this.log("New playbackRate:  ".concat(newPlaybackRate));
                            _context.next = 12;
                            return player.setPlaybackRate(newPlaybackRate);
                        case 12:
                            _this.speedAdjustment = newAdjustment;
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.logger = logger;
        _this.init(timingObject, _player, $e2699dd4b9c01f75$var$_objectSpread2($e2699dd4b9c01f75$var$_objectSpread2({}, $e2699dd4b9c01f75$var$defaultOptions), options));
        return _this;
    }
    $e2699dd4b9c01f75$var$_createClass(TimingSrcConnector, [
        {
            key: "disconnect",
            value: function disconnect() {
                this.dispatchEvent(new Event("disconnect"));
            }
        },
        {
            key: "init",
            value: function() {
                var _init = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee2(timingObject, player, options) {
                    var _this2 = this;
                    var playerUpdater, positionSync, timingObjectUpdater;
                    return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.waitForTOReadyState(timingObject, "open");
                            case 2:
                                if (!(options.role === "viewer")) {
                                    _context2.next = 10;
                                    break;
                                }
                                _context2.next = 5;
                                return this.updatePlayer(timingObject, player, options);
                            case 5:
                                playerUpdater = $e2699dd4b9c01f75$var$subscribe(timingObject, "change", function() {
                                    return _this2.updatePlayer(timingObject, player, options);
                                });
                                positionSync = this.maintainPlaybackPosition(timingObject, player, options);
                                this.addEventListener("disconnect", function() {
                                    positionSync.cancel();
                                    playerUpdater.cancel();
                                });
                                _context2.next = 14;
                                break;
                            case 10:
                                _context2.next = 12;
                                return this.updateTimingObject(timingObject, player);
                            case 12:
                                timingObjectUpdater = $e2699dd4b9c01f75$var$subscribe(player, [
                                    "seeked",
                                    "play",
                                    "pause",
                                    "ratechange"
                                ], function() {
                                    return _this2.updateTimingObject(timingObject, player);
                                }, "on", "off");
                                this.addEventListener("disconnect", function() {
                                    return timingObjectUpdater.cancel();
                                });
                            case 14:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function init(_x3, _x4, _x5) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "updateTimingObject",
            value: function() {
                var _updateTimingObject = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee3(timingObject, player) {
                    return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.t0 = timingObject;
                                _context3.next = 3;
                                return player.getCurrentTime();
                            case 3:
                                _context3.t1 = _context3.sent;
                                _context3.next = 6;
                                return player.getPaused();
                            case 6:
                                if (!_context3.sent) {
                                    _context3.next = 10;
                                    break;
                                }
                                _context3.t2 = 0;
                                _context3.next = 13;
                                break;
                            case 10:
                                _context3.next = 12;
                                return player.getPlaybackRate();
                            case 12:
                                _context3.t2 = _context3.sent;
                            case 13:
                                _context3.t3 = _context3.t2;
                                _context3.t4 = {
                                    position: _context3.t1,
                                    velocity: _context3.t3
                                };
                                _context3.t0.update.call(_context3.t0, _context3.t4);
                            case 16:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function updateTimingObject(_x6, _x7) {
                    return _updateTimingObject.apply(this, arguments);
                }
                return updateTimingObject;
            }()
        },
        {
            key: "updatePlayer",
            value: function() {
                var _updatePlayer = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee5(timingObject, player, options) {
                    var _timingObject$query, position, velocity;
                    return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _timingObject$query = timingObject.query(), position = _timingObject$query.position, velocity = _timingObject$query.velocity;
                                if (typeof position === "number") player.setCurrentTime(position);
                                if (!(typeof velocity === "number")) {
                                    _context5.next = 25;
                                    break;
                                }
                                if (!(velocity === 0)) {
                                    _context5.next = 11;
                                    break;
                                }
                                _context5.next = 6;
                                return player.getPaused();
                            case 6:
                                _context5.t0 = _context5.sent;
                                if (!(_context5.t0 === false)) {
                                    _context5.next = 9;
                                    break;
                                }
                                player.pause();
                            case 9:
                                _context5.next = 25;
                                break;
                            case 11:
                                if (!(velocity > 0)) {
                                    _context5.next = 25;
                                    break;
                                }
                                _context5.next = 14;
                                return player.getPaused();
                            case 14:
                                _context5.t1 = _context5.sent;
                                if (!(_context5.t1 === true)) {
                                    _context5.next = 19;
                                    break;
                                }
                                _context5.next = 18;
                                return player.play().catch(/*#__PURE__*/ function() {
                                    var _ref2 = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee4(err) {
                                        return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                                            while(true)switch(_context4.prev = _context4.next){
                                                case 0:
                                                    if (!(err.name === "NotAllowedError" && options.autoPlayMuted)) {
                                                        _context4.next = 5;
                                                        break;
                                                    }
                                                    _context4.next = 3;
                                                    return player.setMuted(true);
                                                case 3:
                                                    _context4.next = 5;
                                                    return player.play().catch(function(err2) {
                                                        return console.error("Couldn't play the video from TimingSrcConnector. Error:", err2);
                                                    });
                                                case 5:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }, _callee4);
                                    }));
                                    return function(_x11) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }());
                            case 18:
                                this.updatePlayer(timingObject, player, options);
                            case 19:
                                _context5.next = 21;
                                return player.getPlaybackRate();
                            case 21:
                                _context5.t2 = _context5.sent;
                                _context5.t3 = velocity;
                                if (!(_context5.t2 !== _context5.t3)) {
                                    _context5.next = 25;
                                    break;
                                }
                                player.setPlaybackRate(velocity);
                            case 25:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updatePlayer(_x8, _x9, _x10) {
                    return _updatePlayer.apply(this, arguments);
                }
                return updatePlayer;
            }()
        },
        {
            key: "maintainPlaybackPosition",
            value: function maintainPlaybackPosition(timingObject, player, options) {
                var _this3 = this;
                var allowedDrift = options.allowedDrift, maxAllowedDrift = options.maxAllowedDrift, minCheckInterval = options.minCheckInterval, maxRateAdjustment = options.maxRateAdjustment, maxTimeToCatchUp = options.maxTimeToCatchUp;
                var syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
                var check = /*#__PURE__*/ function() {
                    var _ref3 = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee6() {
                        var diff, diffAbs, min, max, adjustment;
                        return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                            while(true)switch(_context6.prev = _context6.next){
                                case 0:
                                    _context6.t0 = timingObject.query().velocity === 0;
                                    if (_context6.t0) {
                                        _context6.next = 6;
                                        break;
                                    }
                                    _context6.next = 4;
                                    return player.getPaused();
                                case 4:
                                    _context6.t1 = _context6.sent;
                                    _context6.t0 = _context6.t1 === true;
                                case 6:
                                    if (!_context6.t0) {
                                        _context6.next = 8;
                                        break;
                                    }
                                    return _context6.abrupt("return");
                                case 8:
                                    _context6.t2 = timingObject.query().position;
                                    _context6.next = 11;
                                    return player.getCurrentTime();
                                case 11:
                                    _context6.t3 = _context6.sent;
                                    diff = _context6.t2 - _context6.t3;
                                    diffAbs = Math.abs(diff);
                                    _this3.log("Drift: ".concat(diff));
                                    if (!(diffAbs > maxAllowedDrift)) {
                                        _context6.next = 22;
                                        break;
                                    }
                                    _context6.next = 18;
                                    return _this3.adjustSpeed(player, 0);
                                case 18:
                                    player.setCurrentTime(timingObject.query().position);
                                    _this3.log("Resync by currentTime");
                                    _context6.next = 29;
                                    break;
                                case 22:
                                    if (!(diffAbs > allowedDrift)) {
                                        _context6.next = 29;
                                        break;
                                    }
                                    min = diffAbs / maxTimeToCatchUp;
                                    max = maxRateAdjustment;
                                    adjustment = min < max ? (max - min) / 2 : max;
                                    _context6.next = 28;
                                    return _this3.adjustSpeed(player, adjustment * Math.sign(diff));
                                case 28:
                                    _this3.log("Resync by playbackRate");
                                case 29:
                                case "end":
                                    return _context6.stop();
                            }
                        }, _callee6);
                    }));
                    return function check() {
                        return _ref3.apply(this, arguments);
                    };
                }();
                var interval = setInterval(function() {
                    return check();
                }, syncInterval);
                return {
                    cancel: function cancel() {
                        return clearInterval(interval);
                    }
                };
            }
        },
        {
            key: "log",
            value: function log(msg) {
                var _this$logger;
                (_this$logger = this.logger) === null || _this$logger === void 0 || _this$logger.call(this, "TimingSrcConnector: ".concat(msg));
            }
        },
        {
            key: "waitForTOReadyState",
            value: /**
     * @param {TimingObject} timingObject
     * @param {TConnectionState} state
     * @return {Promise<void>}
     */ function waitForTOReadyState(timingObject, state) {
                return new Promise(function(resolve) {
                    var check = function check() {
                        if (timingObject.readyState === state) resolve();
                        else timingObject.addEventListener("readystatechange", check, {
                            once: true
                        });
                    };
                    check();
                });
            }
        }
    ]);
    return TimingSrcConnector;
}(/*#__PURE__*/ $e2699dd4b9c01f75$var$_wrapNativeSuper(EventTarget));
var $e2699dd4b9c01f75$var$playerMap = new WeakMap();
var $e2699dd4b9c01f75$var$readyMap = new WeakMap();
var $e2699dd4b9c01f75$var$screenfull = {};
var $e2699dd4b9c01f75$var$Player = /*#__PURE__*/ function() {
    /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */ function Player(element) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $e2699dd4b9c01f75$var$_classCallCheck(this, Player);
        /* global jQuery */ if (window.jQuery && element instanceof jQuery) {
            if (element.length > 1 && window.console && console.warn) console.warn("A jQuery object with multiple elements was passed, using the first element.");
            element = element[0];
        }
        // Find an element by ID
        if (typeof document !== "undefined" && typeof element === "string") element = document.getElementById(element);
        // Not an element!
        if (!$e2699dd4b9c01f75$var$isDomElement(element)) throw new TypeError("You must pass either a valid element or a valid id.");
        // Already initialized an embed in this div, so grab the iframe
        if (element.nodeName !== "IFRAME") {
            var iframe = element.querySelector("iframe");
            if (iframe) element = iframe;
        }
        // iframe url is not a Vimeo url
        if (element.nodeName === "IFRAME" && !$e2699dd4b9c01f75$var$isVimeoUrl(element.getAttribute("src") || "")) throw new Error("The player element passed isn\u2019t a Vimeo embed.");
        // If there is already a player object in the map, return that
        if ($e2699dd4b9c01f75$var$playerMap.has(element)) return $e2699dd4b9c01f75$var$playerMap.get(element);
        this._window = element.ownerDocument.defaultView;
        this.element = element;
        this.origin = "*";
        var readyPromise = new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
            _this._onMessage = function(event) {
                if (!$e2699dd4b9c01f75$var$isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) return;
                if (_this.origin === "*") _this.origin = event.origin;
                var data = $e2699dd4b9c01f75$var$parseMessageData(event.data);
                var isError = data && data.event === "error";
                var isReadyError = isError && data.data && data.data.method === "ready";
                if (isReadyError) {
                    var error = new Error(data.data.message);
                    error.name = data.data.name;
                    reject(error);
                    return;
                }
                var isReadyEvent = data && data.event === "ready";
                var isPingResponse = data && data.method === "ping";
                if (isReadyEvent || isPingResponse) {
                    _this.element.setAttribute("data-ready", "true");
                    resolve();
                    return;
                }
                $e2699dd4b9c01f75$var$processData(_this, data);
            };
            _this._window.addEventListener("message", _this._onMessage);
            if (_this.element.nodeName !== "IFRAME") {
                var params = $e2699dd4b9c01f75$var$getOEmbedParameters(element, options);
                var url = $e2699dd4b9c01f75$var$getVimeoUrl(params);
                $e2699dd4b9c01f75$var$getOEmbedData(url, params, element).then(function(data) {
                    var iframe = $e2699dd4b9c01f75$var$createEmbed(data, element);
                    // Overwrite element with the new iframe,
                    // but store reference to the original element
                    _this.element = iframe;
                    _this._originalElement = element;
                    $e2699dd4b9c01f75$var$swapCallbacks(element, iframe);
                    $e2699dd4b9c01f75$var$playerMap.set(_this.element, _this);
                    return data;
                }).catch(reject);
            }
        });
        // Store a copy of this Player in the map
        $e2699dd4b9c01f75$var$readyMap.set(this, readyPromise);
        $e2699dd4b9c01f75$var$playerMap.set(this.element, this);
        // Send a ping to the iframe so the ready promise will be resolved if
        // the player is already ready.
        if (this.element.nodeName === "IFRAME") $e2699dd4b9c01f75$var$postMessage(this, "ping");
        if ($e2699dd4b9c01f75$var$screenfull.isEnabled) {
            var exitFullscreen = function exitFullscreen() {
                return $e2699dd4b9c01f75$var$screenfull.exit();
            };
            this.fullscreenchangeHandler = function() {
                if ($e2699dd4b9c01f75$var$screenfull.isFullscreen) $e2699dd4b9c01f75$var$storeCallback(_this, "event:exitFullscreen", exitFullscreen);
                else $e2699dd4b9c01f75$var$removeCallback(_this, "event:exitFullscreen", exitFullscreen);
                // eslint-disable-next-line
                _this.ready().then(function() {
                    $e2699dd4b9c01f75$var$postMessage(_this, "fullscreenchange", $e2699dd4b9c01f75$var$screenfull.isFullscreen);
                });
            };
            $e2699dd4b9c01f75$var$screenfull.on("fullscreenchange", this.fullscreenchangeHandler);
        }
        return this;
    }
    /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */ $e2699dd4b9c01f75$var$_createClass(Player, [
        {
            key: "callMethod",
            value: function callMethod(name) {
                var _this2 = this;
                var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this2.ready().then(function() {
                        $e2699dd4b9c01f75$var$storeCallback(_this2, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $e2699dd4b9c01f75$var$postMessage(_this2, name, args);
                    }).catch(reject);
                });
            }
        },
        {
            key: "get",
            value: function get(name) {
                var _this3 = this;
                return new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    name = $e2699dd4b9c01f75$var$getMethodName(name, "get");
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this3.ready().then(function() {
                        $e2699dd4b9c01f75$var$storeCallback(_this3, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $e2699dd4b9c01f75$var$postMessage(_this3, name);
                    }).catch(reject);
                });
            }
        },
        {
            key: "set",
            value: function set(name, value) {
                var _this4 = this;
                return new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    name = $e2699dd4b9c01f75$var$getMethodName(name, "set");
                    if (value === undefined || value === null) throw new TypeError("There must be a value to set.");
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this4.ready().then(function() {
                        $e2699dd4b9c01f75$var$storeCallback(_this4, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $e2699dd4b9c01f75$var$postMessage(_this4, name, value);
                    }).catch(reject);
                });
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!eventName) throw new TypeError("You must pass an event name.");
                if (!callback) throw new TypeError("You must pass a callback function.");
                if (typeof callback !== "function") throw new TypeError("The callback must be a function.");
                var callbacks = $e2699dd4b9c01f75$var$getCallbacks(this, "event:".concat(eventName));
                if (callbacks.length === 0) this.callMethod("addEventListener", eventName).catch(function() {
                // Ignore the error. There will be an error event fired that
                // will trigger the error callback if they are listening.
                });
                $e2699dd4b9c01f75$var$storeCallback(this, "event:".concat(eventName), callback);
            }
        },
        {
            key: "off",
            value: function off(eventName, callback) {
                if (!eventName) throw new TypeError("You must pass an event name.");
                if (callback && typeof callback !== "function") throw new TypeError("The callback must be a function.");
                var lastCallback = $e2699dd4b9c01f75$var$removeCallback(this, "event:".concat(eventName), callback);
                // If there are no callbacks left, remove the listener
                if (lastCallback) this.callMethod("removeEventListener", eventName).catch(function(e) {
                // Ignore the error. There will be an error event fired that
                // will trigger the error callback if they are listening.
                });
            }
        },
        {
            key: "loadVideo",
            value: function loadVideo(options) {
                return this.callMethod("loadVideo", options);
            }
        },
        {
            key: "ready",
            value: function ready() {
                var readyPromise = $e2699dd4b9c01f75$var$readyMap.get(this) || new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    reject(new Error("Unknown player. Probably unloaded."));
                });
                return $e2699dd4b9c01f75$var$npo_src.resolve(readyPromise);
            }
        },
        {
            key: "addCuePoint",
            value: function addCuePoint(time) {
                var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.callMethod("addCuePoint", {
                    time: time,
                    data: data
                });
            }
        },
        {
            key: "removeCuePoint",
            value: function removeCuePoint(id) {
                return this.callMethod("removeCuePoint", id);
            }
        },
        {
            key: "enableTextTrack",
            value: function enableTextTrack(language, kind) {
                if (!language) throw new TypeError("You must pass a language.");
                return this.callMethod("enableTextTrack", {
                    language: language,
                    kind: kind
                });
            }
        },
        {
            key: "disableTextTrack",
            value: function disableTextTrack() {
                return this.callMethod("disableTextTrack");
            }
        },
        {
            key: "pause",
            value: function pause() {
                return this.callMethod("pause");
            }
        },
        {
            key: "play",
            value: function play() {
                return this.callMethod("play");
            }
        },
        {
            key: "requestFullscreen",
            value: function requestFullscreen() {
                if ($e2699dd4b9c01f75$var$screenfull.isEnabled) return $e2699dd4b9c01f75$var$screenfull.request(this.element);
                return this.callMethod("requestFullscreen");
            }
        },
        {
            key: "exitFullscreen",
            value: function exitFullscreen() {
                if ($e2699dd4b9c01f75$var$screenfull.isEnabled) return $e2699dd4b9c01f75$var$screenfull.exit();
                return this.callMethod("exitFullscreen");
            }
        },
        {
            key: "getFullscreen",
            value: function getFullscreen() {
                if ($e2699dd4b9c01f75$var$screenfull.isEnabled) return $e2699dd4b9c01f75$var$npo_src.resolve($e2699dd4b9c01f75$var$screenfull.isFullscreen);
                return this.get("fullscreen");
            }
        },
        {
            key: "requestPictureInPicture",
            value: function requestPictureInPicture() {
                return this.callMethod("requestPictureInPicture");
            }
        },
        {
            key: "exitPictureInPicture",
            value: function exitPictureInPicture() {
                return this.callMethod("exitPictureInPicture");
            }
        },
        {
            key: "getPictureInPicture",
            value: function getPictureInPicture() {
                return this.get("pictureInPicture");
            }
        },
        {
            key: "remotePlaybackPrompt",
            value: function remotePlaybackPrompt() {
                return this.callMethod("remotePlaybackPrompt");
            }
        },
        {
            key: "unload",
            value: function unload() {
                return this.callMethod("unload");
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this5 = this;
                return new $e2699dd4b9c01f75$var$npo_src(function(resolve) {
                    $e2699dd4b9c01f75$var$readyMap.delete(_this5);
                    $e2699dd4b9c01f75$var$playerMap.delete(_this5.element);
                    if (_this5._originalElement) {
                        $e2699dd4b9c01f75$var$playerMap.delete(_this5._originalElement);
                        _this5._originalElement.removeAttribute("data-vimeo-initialized");
                    }
                    if (_this5.element && _this5.element.nodeName === "IFRAME" && _this5.element.parentNode) {
                        // If we've added an additional wrapper div, remove that from the DOM.
                        // If not, just remove the iframe element.
                        if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
                        else _this5.element.parentNode.removeChild(_this5.element);
                    }
                    // If the clip is private there is a case where the element stays the
                    // div element. Destroy should reset the div and remove the iframe child.
                    if (_this5.element && _this5.element.nodeName === "DIV" && _this5.element.parentNode) {
                        _this5.element.removeAttribute("data-vimeo-initialized");
                        var iframe = _this5.element.querySelector("iframe");
                        if (iframe && iframe.parentNode) {
                            // If we've added an additional wrapper div, remove that from the DOM.
                            // If not, just remove the iframe element.
                            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) iframe.parentNode.parentNode.removeChild(iframe.parentNode);
                            else iframe.parentNode.removeChild(iframe);
                        }
                    }
                    _this5._window.removeEventListener("message", _this5._onMessage);
                    if ($e2699dd4b9c01f75$var$screenfull.isEnabled) $e2699dd4b9c01f75$var$screenfull.off("fullscreenchange", _this5.fullscreenchangeHandler);
                    resolve();
                });
            }
        },
        {
            key: "getAutopause",
            value: function getAutopause() {
                return this.get("autopause");
            }
        },
        {
            key: "setAutopause",
            value: function setAutopause(autopause) {
                return this.set("autopause", autopause);
            }
        },
        {
            key: "getBuffered",
            value: function getBuffered() {
                return this.get("buffered");
            }
        },
        {
            key: "getCameraProps",
            value: function getCameraProps() {
                return this.get("cameraProps");
            }
        },
        {
            key: "setCameraProps",
            value: function setCameraProps(camera) {
                return this.set("cameraProps", camera);
            }
        },
        {
            key: "getChapters",
            value: function getChapters() {
                return this.get("chapters");
            }
        },
        {
            key: "getCurrentChapter",
            value: function getCurrentChapter() {
                return this.get("currentChapter");
            }
        },
        {
            key: "getColor",
            value: function getColor() {
                return this.get("color");
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return $e2699dd4b9c01f75$var$npo_src.all([
                    this.get("colorOne"),
                    this.get("colorTwo"),
                    this.get("colorThree"),
                    this.get("colorFour")
                ]);
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                return this.set("color", color);
            }
        },
        {
            key: "setColors",
            value: function setColors(colors) {
                if (!Array.isArray(colors)) return new $e2699dd4b9c01f75$var$npo_src(function(resolve, reject) {
                    return reject(new TypeError("Argument must be an array."));
                });
                var nullPromise = new $e2699dd4b9c01f75$var$npo_src(function(resolve) {
                    return resolve(null);
                });
                var colorPromises = [
                    colors[0] ? this.set("colorOne", colors[0]) : nullPromise,
                    colors[1] ? this.set("colorTwo", colors[1]) : nullPromise,
                    colors[2] ? this.set("colorThree", colors[2]) : nullPromise,
                    colors[3] ? this.set("colorFour", colors[3]) : nullPromise
                ];
                return $e2699dd4b9c01f75$var$npo_src.all(colorPromises);
            }
        },
        {
            key: "getCuePoints",
            value: function getCuePoints() {
                return this.get("cuePoints");
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                return this.get("currentTime");
            }
        },
        {
            key: "setCurrentTime",
            value: function setCurrentTime(currentTime) {
                return this.set("currentTime", currentTime);
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return this.get("duration");
            }
        },
        {
            key: "getEnded",
            value: function getEnded() {
                return this.get("ended");
            }
        },
        {
            key: "getLoop",
            value: function getLoop() {
                return this.get("loop");
            }
        },
        {
            key: "setLoop",
            value: function setLoop(loop) {
                return this.set("loop", loop);
            }
        },
        {
            key: "setMuted",
            value: function setMuted(muted) {
                return this.set("muted", muted);
            }
        },
        {
            key: "getMuted",
            value: function getMuted() {
                return this.get("muted");
            }
        },
        {
            key: "getPaused",
            value: function getPaused() {
                return this.get("paused");
            }
        },
        {
            key: "getPlaybackRate",
            value: function getPlaybackRate() {
                return this.get("playbackRate");
            }
        },
        {
            key: "setPlaybackRate",
            value: function setPlaybackRate(playbackRate) {
                return this.set("playbackRate", playbackRate);
            }
        },
        {
            key: "getPlayed",
            value: function getPlayed() {
                return this.get("played");
            }
        },
        {
            key: "getQualities",
            value: function getQualities() {
                return this.get("qualities");
            }
        },
        {
            key: "getQuality",
            value: function getQuality() {
                return this.get("quality");
            }
        },
        {
            key: "setQuality",
            value: function setQuality(quality) {
                return this.set("quality", quality);
            }
        },
        {
            key: "getRemotePlaybackAvailability",
            value: function getRemotePlaybackAvailability() {
                return this.get("remotePlaybackAvailability");
            }
        },
        {
            key: "getRemotePlaybackState",
            value: function getRemotePlaybackState() {
                return this.get("remotePlaybackState");
            }
        },
        {
            key: "getSeekable",
            value: function getSeekable() {
                return this.get("seekable");
            }
        },
        {
            key: "getSeeking",
            value: function getSeeking() {
                return this.get("seeking");
            }
        },
        {
            key: "getTextTracks",
            value: function getTextTracks() {
                return this.get("textTracks");
            }
        },
        {
            key: "getVideoEmbedCode",
            value: function getVideoEmbedCode() {
                return this.get("videoEmbedCode");
            }
        },
        {
            key: "getVideoId",
            value: function getVideoId() {
                return this.get("videoId");
            }
        },
        {
            key: "getVideoTitle",
            value: function getVideoTitle() {
                return this.get("videoTitle");
            }
        },
        {
            key: "getVideoWidth",
            value: function getVideoWidth() {
                return this.get("videoWidth");
            }
        },
        {
            key: "getVideoHeight",
            value: function getVideoHeight() {
                return this.get("videoHeight");
            }
        },
        {
            key: "getVideoUrl",
            value: function getVideoUrl() {
                return this.get("videoUrl");
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.get("volume");
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                return this.set("volume", volume);
            }
        },
        {
            key: "setTimingSrc",
            value: function() {
                var _setTimingSrc = $e2699dd4b9c01f75$var$_asyncToGenerator(/*#__PURE__*/ $e2699dd4b9c01f75$var$_regeneratorRuntime().mark(function _callee(timingObject, options) {
                    var _this6 = this;
                    var connector;
                    return $e2699dd4b9c01f75$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (timingObject) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new TypeError("A Timing Object must be provided.");
                            case 2:
                                _context.next = 4;
                                return this.ready();
                            case 4:
                                connector = new $e2699dd4b9c01f75$var$TimingSrcConnector(this, timingObject, options);
                                $e2699dd4b9c01f75$var$postMessage(this, "notifyTimingObjectConnect");
                                connector.addEventListener("disconnect", function() {
                                    return $e2699dd4b9c01f75$var$postMessage(_this6, "notifyTimingObjectDisconnect");
                                });
                                return _context.abrupt("return", connector);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function setTimingSrc(_x, _x2) {
                    return _setTimingSrc.apply(this, arguments);
                }
                return setTimingSrc;
            }()
        }
    ]);
    return Player;
}(); // Setup embed only if this is not a node environment
if (!$e2699dd4b9c01f75$var$isNode) {
    $e2699dd4b9c01f75$var$screenfull = $e2699dd4b9c01f75$var$initializeScreenfull();
    $e2699dd4b9c01f75$var$initializeEmbeds();
    $e2699dd4b9c01f75$var$resizeEmbeds();
    $e2699dd4b9c01f75$var$initAppendVideoMetadata();
    $e2699dd4b9c01f75$var$checkUrlTimeParam();
}
var $e2699dd4b9c01f75$export$2e2bcd8739ae039 = $e2699dd4b9c01f75$var$Player;


const $ecb74c2a8f25c0d0$var$startingScene = "Kantoor";
const $ecb74c2a8f25c0d0$var$buttonText = "Doorgaan";
document.getElementById("whatsapp").addEventListener("click", function() {
    window.open("https://wa.me/31638900277?text=Ik%20ben%20ge\xefnteresseerd%20in%20Jullie%20Bedrijf%21", "_blank");
});
document.getElementById("email").addEventListener("click", function() {
    window.open("mailto:info@experiencerepublic.nl", "_blank");
});
document.getElementById("website").addEventListener("click", function() {
    window.open("https://www.purplesquirreleffect.nl/", "_blank");
});
document.getElementById("form").addEventListener("click", function() {
    window.open("https://www.purplesquirreleffect.nl/contact", "_blank");
});
var $db4f1d385a8ad635$exports = {};
$db4f1d385a8ad635$exports = new URL("Kantoor.f3221d2e.jpg", import.meta.url).toString();


var $7cb8913ee84a1124$exports = {};
$7cb8913ee84a1124$exports = new URL("Modern_kantoor.ec3d7e3f.jpg", import.meta.url).toString();


const $ecb74c2a8f25c0d0$var$scenes = {
    "Kantoor": {
        "type": "equirectangular",
        "panorama": new URL($db4f1d385a8ad635$exports),
        "hotSpots": [
            {
                "id": "Kantoor_5",
                "cssClass": "custom-hotspot Kantoor_5",
                "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
                "clickHandlerArgs": {
                    "id": "Kantoor_5",
                    "startingAction": 0
                },
                "pitch": -2,
                "yaw": -160,
                "type": "info",
                "text": "<b>Diversiteit</b><br> (ook bij feestjes)"
            },
            {
                "id": "Kantoor_4",
                "cssClass": "custom-hotspot Kantoor_4",
                "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
                "clickHandlerArgs": {
                    "id": "Kantoor_4",
                    "startingAction": 1
                },
                "pitch": 0,
                "yaw": -71,
                "type": "info",
                "text": "<b>Besties!</b>"
            },
            {
                "id": "Kantoor_3",
                "cssClass": "custom-hotspot Kantoor_3",
                "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
                "clickHandlerArgs": {
                    "id": "Kantoor_3",
                    "startingAction": 2
                },
                "pitch": 0,
                "yaw": -117,
                "type": "info",
                "text": "<b>Dit zijn wij</b>"
            },
            {
                "id": "Kantoor_2",
                "cssClass": "custom-hotspot Kantoor_2",
                "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
                "clickHandlerArgs": {
                    "id": "Kantoor_2",
                    "startingAction": 3
                },
                "pitch": -2,
                "yaw": -228,
                "type": "info",
                "text": "<b>Enthousiast?!</b>"
            },
            {
                "id": "Kantoor_1",
                "cssClass": "custom-hotspot Kantoor_1",
                "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
                "clickHandlerArgs": {
                    "id": "Kantoor_1",
                    "startingAction": 8
                },
                "pitch": -9,
                "yaw": -300,
                "type": "info",
                "text": "<b>Sollicitatietips</b>"
            },
            {
                "id": "Kantoor_0",
                "cssClass": "custom-hotspot Kantoor_0",
                "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
                "clickHandlerArgs": {
                    "id": "Kantoor_0",
                    "startingAction": 9
                },
                "pitch": -90,
                "yaw": 0,
                "type": "info"
            }
        ],
        "autoLoad": true,
        "yaw": -118,
        "pitch": -2
    },
    "Modern_kantoor": {
        "type": "equirectangular",
        "panorama": new URL($7cb8913ee84a1124$exports),
        "hotSpots": [
            {
                "id": "Modern_kantoor_3",
                "cssClass": "custom-hotspot Modern_kantoor_3",
                "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
                "clickHandlerArgs": {
                    "id": "Modern_kantoor_3"
                },
                "pitch": -2,
                "yaw": 60,
                "type": "scene",
                "text": "<b>Mediaplanning</b>",
                "sceneId": "Kantoor"
            },
            {
                "id": "Modern_kantoor_2",
                "cssClass": "custom-hotspot Modern_kantoor_2",
                "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
                "clickHandlerArgs": {
                    "id": "Modern_kantoor_2"
                },
                "pitch": -2,
                "yaw": -60,
                "type": "scene",
                "text": "<b>Social Media</b>",
                "sceneId": "Kantoor"
            },
            {
                "id": "Modern_kantoor_1",
                "cssClass": "custom-hotspot Modern_kantoor_1",
                "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
                "clickHandlerArgs": {
                    "id": "Modern_kantoor_1"
                },
                "pitch": 1,
                "yaw": 1,
                "type": "scene",
                "text": "<b>Vrijheid</b>",
                "sceneId": "Kantoor"
            }
        ],
        "autoLoad": true,
        "yaw": 2,
        "pitch": 1
    }
};
const $ecb74c2a8f25c0d0$var$hotspots = {
    "Modern_kantoor_3": {
        "id": "Modern_kantoor_3",
        "cssClass": "custom-hotspot Modern_kantoor_3",
        "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
        "clickHandlerArgs": {
            "id": "Modern_kantoor_3"
        },
        "pitch": -2,
        "yaw": 60,
        "type": "scene",
        "text": "<b>Mediaplanning</b>",
        "sceneId": "Kantoor"
    },
    "Modern_kantoor_2": {
        "id": "Modern_kantoor_2",
        "cssClass": "custom-hotspot Modern_kantoor_2",
        "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
        "clickHandlerArgs": {
            "id": "Modern_kantoor_2"
        },
        "pitch": -2,
        "yaw": -60,
        "type": "scene",
        "text": "<b>Social Media</b>",
        "sceneId": "Kantoor"
    },
    "Modern_kantoor_1": {
        "id": "Modern_kantoor_1",
        "cssClass": "custom-hotspot Modern_kantoor_1",
        "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
        "clickHandlerArgs": {
            "id": "Modern_kantoor_1"
        },
        "pitch": 1,
        "yaw": 1,
        "type": "scene",
        "text": "<b>Vrijheid</b>",
        "sceneId": "Kantoor"
    },
    "Kantoor_5": {
        "id": "Kantoor_5",
        "cssClass": "custom-hotspot Kantoor_5",
        "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
        "clickHandlerArgs": {
            "id": "Kantoor_5",
            "startingAction": 0
        },
        "pitch": -2,
        "yaw": -160,
        "type": "info",
        "text": "<b>Diversiteit</b><br> (ook bij feestjes)"
    },
    "Kantoor_4": {
        "id": "Kantoor_4",
        "cssClass": "custom-hotspot Kantoor_4",
        "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
        "clickHandlerArgs": {
            "id": "Kantoor_4",
            "startingAction": 1
        },
        "pitch": 0,
        "yaw": -71,
        "type": "info",
        "text": "<b>Besties!</b>"
    },
    "Kantoor_3": {
        "id": "Kantoor_3",
        "cssClass": "custom-hotspot Kantoor_3",
        "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
        "clickHandlerArgs": {
            "id": "Kantoor_3",
            "startingAction": 2
        },
        "pitch": 0,
        "yaw": -117,
        "type": "info",
        "text": "<b>Dit zijn wij</b>"
    },
    "Kantoor_2": {
        "id": "Kantoor_2",
        "cssClass": "custom-hotspot Kantoor_2",
        "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
        "clickHandlerArgs": {
            "id": "Kantoor_2",
            "startingAction": 3
        },
        "pitch": -2,
        "yaw": -228,
        "type": "info",
        "text": "<b>Enthousiast?!</b>"
    },
    "Kantoor_1": {
        "id": "Kantoor_1",
        "cssClass": "custom-hotspot Kantoor_1",
        "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
        "clickHandlerArgs": {
            "id": "Kantoor_1",
            "startingAction": 8
        },
        "pitch": -9,
        "yaw": -300,
        "type": "info",
        "text": "<b>Sollicitatietips</b>"
    },
    "Kantoor_0": {
        "id": "Kantoor_0",
        "cssClass": "custom-hotspot Kantoor_0",
        "clickHandlerFunc": $ecb74c2a8f25c0d0$var$hotspotClickHandler,
        "clickHandlerArgs": {
            "id": "Kantoor_0",
            "startingAction": 9
        },
        "pitch": -90,
        "yaw": 0,
        "type": "info"
    }
};
const $ecb74c2a8f25c0d0$var$actions = [
    {
        "type": "video",
        "vimeoId": 874552861
    },
    {
        "type": "video",
        "vimeoId": 874552842
    },
    {
        "type": "video",
        "vimeoId": 874552874
    },
    {
        "type": "question",
        "question": '<h2 id="meer-over-purple-squirrel-effect">Meer over Purple Squirrel Effect</h2>\n',
        "answers": [
            {
                "answer": "Plan een Pitch met Mitch",
                "next": 4
            },
            {
                "answer": "Bel ons op telefoonnummer +31 (0) 85 782 1400",
                "next": 5
            },
            {
                "answer": "Mail ons",
                "next": 6
            },
            {
                "answer": "Terug naar de omgeving"
            }
        ]
    },
    {
        "type": "redirect",
        "url": "https://www.purplesquirreleffect.nl/contact/"
    },
    {
        "type": "redirect",
        "url": "https://tinyurl.com/38j76jr8"
    },
    {
        "type": "redirect",
        "url": "https://tinyurl.com/k5z96wy9"
    },
    {
        "type": "question",
        "question": '<h2 id="meer-over-purple-squirrel-effect">Meer over Purple Squirrel Effect</h2>\n',
        "answers": [
            {
                "answer": "Plan een Pitch met Mitch",
                "next": 4
            },
            {
                "answer": "Bel ons op telefoonnummer +31 (0) 85 782 1400",
                "next": 5
            },
            {
                "answer": "Mail ons",
                "next": 6
            },
            {
                "answer": "Terug naar de omgeving"
            }
        ]
    },
    {
        "type": "text",
        "content": '<h1 id="solliciteer-als-de-beste">Solliciteer als de beste!</h1>\n<ul>\n<li>Bedenk van tevoren wat je over jezelf kunt en wil vertellen. Met een goede voorbereiding bespaar je jezelf een hoop onnodige stress.<br><br>   </li>\n<li>Zet je karaktereigenschappen op een rijtje, zowel je sterke als je minder sterke eigenschappen. Dat laatste wordt nog wel eens vergeten, terwijl je bewust zijn van je minder sterke eigenschappen en nagedacht hebben over hoe je die kan verbeteren juist kracht en drang tot zelfverbetering uitstraalt!<br><br>   </li>\n<li>Hou altijd in je achterhoofd dat je tijdens het sollicitatiegesprek in de eerste plaats duidelijk wil maken waarom wij jou zouden moeten aannemen.<br><br>   </li>\n<li>Zoek op internet eens naar de meest gestelde vragen bij een sollicitatiegesprek en kijk of je daar al een antwoord op kunt bedenken. Op die manier hoef je er tijdens het gesprek niet meer over na te denken. <br><br></li>\n</ul>\n'
    },
    {
        "type": "question",
        "question": '<h1 id="waar-krijg-jij-het-meeste-energie-van">Waar krijg jij het meeste energie van?</h1>\n',
        "answers": [
            {
                "answer": "Omzet verhogen"
            },
            {
                "answer": "Merken zichtbaar maken",
                "scene": "Modern_kantoor"
            }
        ]
    },
    {
        "type": "question",
        "question": '<h1 id="waar-krijg-jij-het-meeste-energie-van">Waar krijg jij het meeste energie van?</h1>\n',
        "answers": [
            {
                "answer": "Omzet verhogen"
            },
            {
                "answer": "Merken zichtbaar maken",
                "scene": "Modern_kantoor"
            }
        ]
    }
];
let $ecb74c2a8f25c0d0$var$viewer;
async function $ecb74c2a8f25c0d0$var$initiate_viewer() {
    $ecb74c2a8f25c0d0$var$viewer = await (0, $528105fcba5f9f10$export$2cf81d87fa45b315).viewer("panorama", {
        hfov: 120,
        autoLoad: false,
        touchPanSpeedCoeffFactor: 2.5,
        friction: 0.05,
        showControls: false,
        scenes: $ecb74c2a8f25c0d0$var$scenes
    });
    // Enable loading the scene from URL
    const path = window.location.pathname;
    // If the path is not the root path, load the scene.
    if (path !== "/") try {
        $ecb74c2a8f25c0d0$var$viewer.loadScene(path.slice(1));
    } catch (error) {
        // console.log(error);
        console.log("Scene not found or another error occured.");
    }
    else $ecb74c2a8f25c0d0$var$viewer.loadScene($ecb74c2a8f25c0d0$var$startingScene);
    // On the load event of the viewer, check if the window width is smaller than 768px, if it is, zoom in completely.
    $ecb74c2a8f25c0d0$var$viewer.on("load", function() {
        if (window.innerWidth < 768) $ecb74c2a8f25c0d0$var$viewer.setHfov(0);
        const currentScene = $ecb74c2a8f25c0d0$var$viewer.getScene();
        const url = new URL(window.location.href);
        url.pathname = `/${currentScene}`;
        window.history.pushState({}, "", url.toString());
        // If the posthog object exists, capture the scene load event.
        if (typeof posthog !== "undefined") posthog.capture("$pageview");
    });
    document.getElementById("fullscreen").addEventListener("click", function(e) {
        $ecb74c2a8f25c0d0$var$viewer.toggleFullscreen();
    });
    document.getElementById("home").addEventListener("click", function(e) {
        $ecb74c2a8f25c0d0$var$viewer.loadScene($ecb74c2a8f25c0d0$var$startingScene);
    });
    document.getElementById("bolt").addEventListener("click", function(e) {
        let conversionOptions = document.querySelector(".conversion-options");
        conversionOptions.classList.toggle("open");
    });
    document.getElementById("compass")?.addEventListener("click", function(e) {
        let orientationState = $ecb74c2a8f25c0d0$var$viewer.isOrientationActive();
        if (orientationState == true) $ecb74c2a8f25c0d0$var$viewer.stopOrientation();
        else $ecb74c2a8f25c0d0$var$viewer.startOrientation();
    });
    // Add a loading spinner.
    $ecb74c2a8f25c0d0$var$viewer.on("scenechange", function() {
        var div = document.createElement("div");
        div.className = "loading-spinner";
        document.body.appendChild(div);
        function onload() {
            document.querySelector(".loading-spinner").remove();
            $ecb74c2a8f25c0d0$var$viewer.off("load", onload);
        }
        $ecb74c2a8f25c0d0$var$viewer.on("load", onload);
    });
    undefined;
    function starting_Kantoor() {
        if ($ecb74c2a8f25c0d0$var$viewer.getScene() == "Kantoor") {
            document.getElementsByClassName("Kantoor_0")[0].click();
            $ecb74c2a8f25c0d0$var$viewer.off("load", starting_Kantoor);
        }
    }
    $ecb74c2a8f25c0d0$var$viewer.on("load", starting_Kantoor);
}
$ecb74c2a8f25c0d0$var$initiate_viewer();
// This function is called when the hotspot is clicked. It handles four things, the startingAction, and the view, create and hide options.
function $ecb74c2a8f25c0d0$var$hotspotClickHandler(clickEvent, hotspotArguments) {
    if (!clickEvent.target?.classList.contains(`${$ecb74c2a8f25c0d0$var$viewer.getScene()}_0`) && typeof posthog !== "undefined") posthog.capture("User clicked hotspot", {
        name: clickEvent.target?.innerText
    });
    // Create a new bootstrap modal.
    let modal = new $e9dd36436aec3b21$export$2b77a92f1a5ad772("#actionModal");
    // Check if the hotspot has a startingAction.
    if (hotspotArguments["startingAction"] != undefined) {
        if (hotspotArguments["startingAction"]["type"] != "redirect") {
            $ecb74c2a8f25c0d0$var$modalParser($ecb74c2a8f25c0d0$var$actions[hotspotArguments["startingAction"]]);
            modal.toggle();
        } else // Open in a new tab:
        window.open(hotspotArguments["startingAction"]["url"], "_blank");
    }
    // In this order, check the arguments['afterCompletion'] for a create, hide, view and load value.
    // Then add an event listener that runs once to the modal, if the modal is hidden, run the afterCompletion functions.
    if (hotspotArguments["afterCompletion"]) {
        let actionModal = document.getElementById("actionModal");
        let afterCompletion = hotspotArguments["afterCompletion"];
        actionModal.addEventListener("hidden.bs.modal", function() {
            if (afterCompletion["create"] != undefined) // For all the hotspots in the create array, add them to the viewer.
            afterCompletion["create"].forEach((hotspot)=>{
                $ecb74c2a8f25c0d0$var$viewer.addHotSpot($ecb74c2a8f25c0d0$var$hotspots[hotspot]);
            });
            if (afterCompletion["hide"] != undefined) $ecb74c2a8f25c0d0$var$viewer.removeHotSpot(hotspotArguments.id);
            if (afterCompletion["view"] != undefined) {
                let hotspotToView = $ecb74c2a8f25c0d0$var$hotspots[afterCompletion["view"]];
                $ecb74c2a8f25c0d0$var$viewer.lookAt(hotspotToView.pitch, hotspotToView.yaw);
            }
            if (afterCompletion["load"] != undefined) $ecb74c2a8f25c0d0$var$viewer.loadScene(afterCompletion["load"]);
        }, {
            once: true
        });
    }
}
// This function receives the action object and modifies the modal content.
async function $ecb74c2a8f25c0d0$var$modalParser(action) {
    let actionModal = document.getElementById("actionModal");
    // Get the #actionModal// If the action object is a Redirect, open the url in a new tab, hide the modal and stop executing the function.
    if (action["type"] == "redirect") {
        window.open(action["url"], "_blank");
        // If there is an action modal, get the bootstrap modal instance.
        setTimeout(()=>{
            let actionModal = document.getElementById("actionModal");
            if (actionModal != null) {
                let modal = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(actionModal);
                if (modal != null) modal.hide();
            }
        }, 1000);
        return;
    }
    let modalBody = actionModal.querySelector(".modal-body");
    let modalDialog = actionModal.querySelector(".modal-dialog");
    modalBody.innerHTML = "";
    modalBody.classList.remove("video-div", "modal-lg");
    modalDialog.classList.remove("modal-xl");
    let icon = document.createElement("i");
    icon.classList.add("bi", "bi-arrow-right-short");
    // We check for the type of the action object.
    switch(action["type"]){
        // If the action object is a text, create a new div with the class text-wrapper and add it to the modal-body.
        case "text":
            // Add the 'modal-lg' class to the modal-dialog.
            modalDialog.classList.add("modal-lg");
            let textWrapper = document.createElement("div");
            textWrapper.classList.add("text-wrapper");
            modalBody.appendChild(textWrapper);
            // Insert the content of the action object into the textWrapper.
            textWrapper.innerHTML = action["content"];
            // Check if there is an img in the action object.
            if (action["img"] != undefined) {
                // Create a new img element and add it to the textWrapper.
                let img = document.createElement("img");
                img.src = action["img"];
                textWrapper.appendChild(img);
            }
            // Add a button to the modal-body.
            let button = document.createElement("button");
            button.classList.add("btn", "btn-primary");
            button.innerHTML = $ecb74c2a8f25c0d0$var$buttonText;
            button.appendChild(icon);
            actionModal.querySelector(".modal-body").appendChild(button);
            // Check if the action object has a next property.
            if (action["next"] == undefined) // If the action object doesn't have a next property, add the dismiss attribute to the button.
            button.dataset.bsDismiss = "modal";
            else // Add an event listener to the button, which only runs once.
            button.addEventListener("click", (event)=>{
                $ecb74c2a8f25c0d0$var$modalParser($ecb74c2a8f25c0d0$var$actions[action["next"]]);
            }, {
                once: true
            });
            break;
        case "video":
            // Adding appropriate classes for styling.
            modalDialog.classList.add("modal-xl");
            modalBody.classList.add("video-div");
            // Make an oEmbed request to Vimeo, and get the aspect ratio. We save it in the variable aspectRatio.
            let response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${action["vimeoId"]}`);
            let data = await response.json();
            let aspectRatio = data["width"] / data["height"];
            if (aspectRatio < 1 && window.innerWidth > 768) {
                // Fetch the div with id 'innerContent' and set its max-width to calc(90vh*${aspectRatio}). This is done to make sure the video doesn't overflow the modal.
                let innerContent = document.getElementById("innerContent");
                if (innerContent != null) innerContent.style.maxWidth = `calc(88vh*${aspectRatio})`;
            }
            // Create a button and add it to the modal-body.
            let closeButton = document.createElement("button");
            closeButton.classList.add("btn-close", "btn-close-white");
            closeButton.dataset.ariaLabel = "Close";
            // Add a right-arrow icon to the button.
            modalBody.appendChild(closeButton);
            // Create a div with the class video-wrapper and add it to the modal-body.
            let videoWrapper = document.createElement("div");
            videoWrapper.classList.add("video-wrapper");
            modalBody.appendChild(videoWrapper);
            // Create an iframe and add it to the videoWrapper.
            let iframe = document.createElement("iframe");
            // Set the css variable '--aspect-ratio' to the aspectRatio.
            document.documentElement.style.setProperty("--aspect-ratio", aspectRatio.toString());
            // Set the appropriate attributes for the iframe.
            iframe.src = `https://player.vimeo.com/video/${action["vimeoId"]}?title=0&byline=0&portrait=0&autoplay=1&dnt=1`;
            iframe.allow = "autoplay";
            iframe.allowFullscreen = true;
            videoWrapper.appendChild(iframe);
            const player = new (0, $e2699dd4b9c01f75$export$2e2bcd8739ae039)(iframe);
            // Add an event listener to the modal, which only runs once. When the modal is closed, the iframe should be removed.
            actionModal.addEventListener("hidden.bs.modal", function() {
                iframe.remove();
                // Fetch the div with id 'innerContent' and remove all styles.
                let innerContent = document.getElementById("innerContent");
                innerContent.removeAttribute("style");
            }, {
                once: true
            });
            // Check if the action object has a next property.
            if (action["next"] == undefined) {
                player.on("ended", function() {
                    let modal = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(actionModal);
                    // If the action object doesn't have a next property, close the modal.
                    modal.toggle();
                });
                // If the action object doesn't have a next property, add the dismiss attribute to the button.
                closeButton.dataset.bsDismiss = "modal";
            } else {
                player.on("ended", function() {
                    $ecb74c2a8f25c0d0$var$modalParser($ecb74c2a8f25c0d0$var$actions[action["next"]]);
                });
                // Add an event listener to the button, which only runs once.
                closeButton.addEventListener("click", (event)=>{
                    $ecb74c2a8f25c0d0$var$modalParser($ecb74c2a8f25c0d0$var$actions[action["next"]]);
                }, {
                    once: true
                });
            }
            break;
        case "question":
            modalDialog.classList.add("modal-lg");
            // Create a new div with class 'question-wrapper' and add it to the modal-body.
            let questionWrapper = document.createElement("div");
            questionWrapper.classList.add("question-wrapper");
            modalBody.appendChild(questionWrapper);
            // Insert the content of the question into the questionWrapper.
            questionWrapper.innerHTML = action["question"];
            // Create a new form and add it to the questionWrapper.
            let form = document.createElement("form");
            // Add a div with class 'd-grid gap-2' to the form.
            let dGrid = document.createElement("div");
            dGrid.classList.add("d-grid", "gap-2");
            form.appendChild(dGrid);
            questionWrapper.appendChild(form);
            // Loop over the answers and create a new button for each answer.
            action["answers"].forEach((answer, index)=>{
                // Create the input.
                let input = document.createElement("input");
                input.type = "radio";
                // If the answer has a next value, or a scene value add the value to the input, else set it to no-next.
                if (answer["next"] != undefined) input.value = answer["next"].toString();
                else if (answer["scene"] != undefined) input.value = answer["scene"];
                else input.value = "no-next";
                input.name = "answer";
                input.classList.add("btn-check", "form-button");
                input.id = `opt-${index}`;
                input.autocomplete = "off";
                // Create the label.
                let label = document.createElement("label");
                label.classList.add("btn", "btn-outline-primary");
                label.htmlFor = `opt-${index}`;
                // Create the icons.
                let icon = document.createElement("i");
                let icon2 = document.createElement("i");
                icon.classList.add("bi", "bi-arrow-right-short");
                icon2.classList.add("bi", "bi-check");
                // Create the span.
                let span = document.createElement("span");
                span.innerHTML = answer["answer"];
                // Append the icon and span to the label.
                label.appendChild(icon);
                label.appendChild(icon2);
                label.appendChild(span);
                // Append the input and label to the dGrid.
                dGrid.appendChild(input);
                dGrid.appendChild(label);
            });
            // Create a button and add it to the form.
            let submitButton = document.createElement("button");
            submitButton.classList.add("btn", "btn-primary");
            submitButton.type = "submit";
            submitButton.innerHTML = $ecb74c2a8f25c0d0$var$buttonText;
            // Add a right-arrow icon to the button.
            submitButton.appendChild(icon);
            form.appendChild(submitButton);
            // Add an event listener to the form.
            form.addEventListener("submit", (event)=>{
                // Prevent the default action of the form.
                event.preventDefault();
                // Get the value of the checked radio button.
                let checked = document.querySelector('input[name="answer"]:checked');
                // Read the text inside the span of the checked radio button.
                let answerText = "";
                if (checked !== null && checked.nextElementSibling !== null && checked.nextElementSibling.lastElementChild !== null && typeof posthog !== "undefined") {
                    answerText = checked.nextElementSibling.lastElementChild.innerHTML;
                    posthog.capture("User answered question", {
                        question: action["question"],
                        answer: answerText
                    });
                }
                // Check if the checked radio button has a value.
                if (checked.value == "no-next") {
                    let modal = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(actionModal);
                    // If the checked radio button doesn't have a value, close the modal.
                    modal.toggle();
                } else // Check for the type of the next action.
                // If it's a number, call the modalParser function with the next action.
                if (!isNaN(parseInt(checked.value))) $ecb74c2a8f25c0d0$var$modalParser($ecb74c2a8f25c0d0$var$actions[parseInt(checked.value)]);
                else {
                    let modal = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(actionModal);
                    modal.toggle();
                    $ecb74c2a8f25c0d0$var$viewer.loadScene(checked.value);
                }
            });
            break;
    }
}


//# sourceMappingURL=index.00b31c4b.js.map
